// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================================================
   markdown.css — Answers, Assistants, Documents

   Colors: use var(--c-*), var(--ui-*), var(--doc-*), var(--mi-*) from tokens.css
   Type:  var(--font), var(--font-display), var(--mono) from tokens.css
   (loaded globally via index.css — no @import needed here)

   Answers:     .answers-md, .welcome-*, .answers-* (local --answers-* mixes on shell)
   Assistants:  .assistants-page, .configure-dialog, .mi-* researcher shell
   Documents:   .markdown-content, .doc-body
   ============================================================================= */

/* =============================================================================
   ANSWERS — Comply Answers only
   ============================================================================= */

/* Tints and neutrals derived only from tokens.css (--c-*, --c-black, --c-white) */
.welcome-page,
.answers-landing-page,
.answers-copy-shell,
.answers-copy-view,
.answers-shell {
  --answers-text-rich: color-mix(in srgb, var(--c-black) 88%, transparent);
  --answers-teal-045: color-mix(in srgb, var(--c-teal-active) 4.5%, transparent);
  --answers-teal-06: color-mix(in srgb, var(--c-teal-active) 6%, transparent);
  --answers-teal-07: color-mix(in srgb, var(--c-teal-active) 7%, transparent);
  --answers-teal-08: color-mix(in srgb, var(--c-teal-active) 8%, transparent);
  --answers-teal-10: color-mix(in srgb, var(--c-teal-active) 10%, transparent);
  --answers-teal-12: color-mix(in srgb, var(--c-teal-active) 12%, transparent);
  --answers-teal-14: color-mix(in srgb, var(--c-teal-active) 14%, transparent);
  --answers-teal-16: color-mix(in srgb, var(--c-teal-active) 16%, transparent);
  --answers-teal-20: color-mix(in srgb, var(--c-teal-active) 20%, transparent);
  --answers-teal-24: color-mix(in srgb, var(--c-teal-active) 24%, transparent);
  --answers-teal-28: color-mix(in srgb, var(--c-teal-active) 28%, transparent);
  --answers-teal-36: color-mix(in srgb, var(--c-teal-active) 36%, transparent);
  --answers-teal-38: color-mix(in srgb, var(--c-teal-active) 38%, transparent);
  --answers-teal-42: color-mix(in srgb, var(--c-teal-active) 42%, transparent);
  --answers-teal-48: color-mix(in srgb, var(--c-teal-active) 48%, transparent);
  --answers-blue-035: color-mix(in srgb, var(--c-blue-1) 3.5%, transparent);
  --answers-blue-07: color-mix(in srgb, var(--c-blue-1) 7%, transparent);
  --answers-blue-08: color-mix(in srgb, var(--c-blue-1) 8%, transparent);
  --answers-blue-10: color-mix(in srgb, var(--c-blue-1) 10%, transparent);
  --answers-blue-14: color-mix(in srgb, var(--c-blue-1) 14%, transparent);
  --answers-blue-20: color-mix(in srgb, var(--c-blue-1) 20%, transparent);
  --answers-blue-24: color-mix(in srgb, var(--c-blue-1) 24%, transparent);
  --answers-orange-10: color-mix(in srgb, var(--c-orange) 10%, transparent);
  --answers-orange-28: color-mix(in srgb, var(--c-orange) 28%, transparent);
  --answers-orange-30: color-mix(in srgb, var(--c-orange) 30%, transparent);
  --answers-black-014: color-mix(in srgb, var(--c-black) 1.4%, transparent);
  --answers-black-018: color-mix(in srgb, var(--c-black) 1.8%, transparent);
  --answers-black-025: color-mix(in srgb, var(--c-black) 2.5%, transparent);
  --answers-black-03: color-mix(in srgb, var(--c-black) 3%, transparent);
  --answers-black-035: color-mix(in srgb, var(--c-black) 3.5%, transparent);
  --answers-black-05: color-mix(in srgb, var(--c-black) 5%, transparent);
  --answers-black-055: color-mix(in srgb, var(--c-black) 5.5%, transparent);
  --answers-black-06: color-mix(in srgb, var(--c-black) 6%, transparent);
  --answers-black-08: color-mix(in srgb, var(--c-black) 8%, transparent);
  --answers-black-12: color-mix(in srgb, var(--c-black) 12%, transparent);
  --answers-white-92: color-mix(in srgb, var(--c-white) 92%, transparent);
}

.answers-md {
  --answers-md-color: var(--answers-text-rich);
  --answers-md-size: var(--fs-base);
  --answers-md-leading: 1.58;

  font-family: var(--font);
  color: var(--answers-md-color);
  font-size: var(--answers-md-size);
  line-height: var(--answers-md-leading);
}

.answers-md,
.answers-md * {
  font-family: var(--font);
  font-size: 15px;
}

.answers-md p {
  margin: 0 0 var(--space-2);
  font-size: var(--answers-md-size);
  line-height: var(--answers-md-leading);
  color: var(--answers-md-color);
}

.answers-md h1,
.answers-md h2,
.answers-md h3 {
  margin: var(--space-4) 0 var(--space-2);
  color: var(--c-black);
  letter-spacing: -0.03em;
  font-weight: 600;
  font-size: 16px;
}

.answers-md h1 {
  font-size: var(--fs-2xl);
  font-weight: 500;
  line-height: 1.3;
  margin-bottom: var(--space-6);
}

.answers-md h2 {
  font-size: var(--fs-md);
  line-height: 1.2;
}

.answers-md h3 {
  font-size: calc(var(--fs-base) + 1px);
  line-height: 1.25;
}

.answers-md ul,
.answers-md ol {
  margin: 0 0 var(--space-3);
  padding-left: var(--space-7);
}

.answers-md li {
  margin: 0 0 var(--space-2) var(--space-4);
  padding-left: 2px;
}

.answers-md li::marker {
  color: var(--text3);
}

.answers-md a {
  color: var(--c-blue-1);
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: var(--space-1);
}

.answers-md a:hover {
  color: var(--c-blue-2);
}

.answers-md strong,
.answers-md b {
  font-weight: 500;
  color: var(--c-black);
}

.answers-md code {
  font-size: 0.92em;
  padding: 1px var(--space-2);
  border-radius: var(--border-radius-sm);
  background: var(--bar-track-bg);
}

.answers-md pre {
  margin: 0 0 var(--space-3);
  padding: var(--space-3);
  border: var(--border-width) solid var(--border-color);
  border-radius: var(--border-radius);
  background: var(--answers-black-03);
  overflow-x: auto;
}

.answers-md pre code {
  padding: 0;
  background: transparent;
}

.answers-md blockquote {
  margin: 0 0 var(--space-3);
  padding-left: var(--space-3);
  border-left: var(--border-width-thick) solid var(--border-color);
  color: var(--text2);
  background: var(--answers-black-03);
  border-radius: 0 var(--border-radius-sm) var(--border-radius-sm) 0;
}

.answers-md .answers-md-list-item {
  margin: 0 0 var(--space-2);
  padding-left: var(--space-2);
}

.answers-md .answers-md-citation-group {
  margin: 0 0 var(--space-2);
}

.answers-md .answers-md-list-bullet {
  display: inline-block;
  margin-right: 0.4em;
  font-size: 1.2em;
  line-height: 1;
  vertical-align: baseline;
}

.answers-md .answers-md-hr {
  margin: var(--space-4) 0;
  border: none;
  border-top: var(--border-width) solid var(--border-color);
}

.answers-md-table-wrap {
  margin: 0 0 var(--space-3);
  overflow-x: auto;
  border: var(--border-width) solid var(--border-color);
  border-radius: var(--border-radius);
}

.answers-md-table {
  width: 100%;
  min-width: 480px;
  border-collapse: collapse;
  font-size: var(--fs-sm);
  line-height: 1.45;
}

.answers-md-table th,
.answers-md-table td {
  padding: var(--space-2) var(--space-3);
  border: var(--border-width) solid var(--border-color);
  text-align: left;
  vertical-align: top;
  max-width: 0;
}

.answers-md-table .md-table-cell-inner {
  display: block;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.answers-md-table th {
  font-weight: 600;
  color: var(--c-black);
  background: var(--bar-track-bg);
}

.answers-md-table tbody tr:nth-child(even) {
  background: var(--answers-black-03);
}

.answers-md-spacer {
  height: var(--space-2);
}

.answers-md-citation {
  margin: 0;
  padding: 0;
  border: none;
  border-radius: 0;
  background: none;
  color: var(--c-teal-active);
  cursor: pointer;
  font: inherit;
  font-size: inherit;
  font-weight: inherit;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.answers-md-citation + .answers-md-citation {
  margin-left: 0.35em;
}

.answers-md-citation:hover {
  background: none;
  color: var(--c-teal-3);
}

.answers-md-cursor {
  display: inline-block;
  color: var(--c-teal-active);
  animation: answersMdBlink 1s step-end infinite;
}

@keyframes answersMdBlink {
  50% {
    opacity: 0;
  }
}



/* =============================================================================
   ANSWERS — Welcome page (/answers)
   ============================================================================= */

.welcome-page {
  min-height: 100%;
  background: var(--c-white);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-8) var(--space-6);
  box-sizing: border-box;
  font-family: var(--font);
  font-size: var(--fs-base);
  color: var(--c-black);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.welcome-page *,
.welcome-page button,
.welcome-page input,
.welcome-page select,
.welcome-page textarea {
  font-family: var(--font);
}

.welcome-inner {
  width: 100%;
  max-width: 560px;
  margin: 0 auto;
}

.welcome-main {
  background: var(--c-white);
  border-radius: var(--border-radius-xl);
  box-shadow:
    0 var(--space-2) var(--space-7) var(--answers-black-06),
    0 var(--border-width) var(--space-2) var(--answers-black-035);
  border: var(--border-width) solid var(--border-color);
  padding: calc(var(--space-7) + var(--space-3)) calc(var(--space-7) + var(--space-1));
  overflow: hidden;
}

.welcome-hero {
  text-align: center;
  margin-bottom: var(--space-7);
}

.hero-icon {
  width: var(--space-10);
  height: var(--space-10);
  margin: 0 auto var(--space-6);
  color: var(--c-teal-active);
  display: flex;
  align-items: center;
  justify-content: center;
}

.hero-icon svg {
  width: 100%;
  height: 100%;
}

.hero-title {
  font-size: var(--fs-3xl);
  font-weight: 600;
  color: var(--c-black);
  font-family: var(--font-display);
  line-height: 1.3;
  margin: 0 0 var(--space-3) 0;
  letter-spacing: -0.02em;
}

.hero-subtitle {
  font-size: var(--fs-md);
  color: var(--text2);
  line-height: 1.6;
  margin: 0 auto var(--space-6) auto;
  max-width: 420px;
}

.cta-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  padding: var(--space-3) var(--space-7);
  font-size: var(--fs-md);
  font-weight: 600;
  color: var(--c-white);
  background: var(--c-teal-active);
  border: none;
  border-radius: var(--border-radius-md);
  cursor: pointer;
  text-decoration: none;
  transition: background 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0 var(--space-2) var(--space-2) color-mix(in srgb, var(--c-teal-active) 24%, transparent);
}

.cta-button:hover {
  background: var(--c-teal-3);
  box-shadow: 0 var(--space-2) var(--space-3) color-mix(in srgb, var(--c-teal-active) 28%, transparent);
}

.cta-button:focus-visible {
  outline: var(--border-width-thick) solid var(--c-teal-active);
  outline-offset: var(--space-2);
}

.cta-label {
  letter-spacing: 0.01em;
  font-size: var(--fs-2xl);
}

.cta-arrow {
  flex-shrink: 0;
  opacity: 0.9;
}

.welcome-features {
  list-style: none;
  margin: 0;
  padding: var(--space-6) 0 0 0;
  border-top: var(--border-width) solid var(--border-color);
}

.feature-item {
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
  font-size: var(--fs-base);
  color: var(--text2);
  line-height: 1.5;
  margin-bottom: var(--space-3);
}

.feature-item:last-child {
  margin-bottom: 0;
}

.feature-dot {
  flex-shrink: 0;
  width: var(--space-2);
  height: var(--space-2);
  border-radius: var(--border-radius-pill);
  background: var(--c-teal-active);
  margin-top: var(--space-2);
  opacity: 0.9;
}

/* =============================================================================
   ANSWERS — Landing page (/answers/copy, answers-assitant-13-May-2026)
   ============================================================================= */

@keyframes answersFadeIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.answers-landing-page {
  --answers-prompt-max: 990px;
  --answers-prompt-radius: 28px;
  --answers-prompt-pad: 1rem 1.35rem 0.85rem;
  --answers-textarea-min-h: 98px;
  min-height: 100%;
  display: flex;
  flex-direction: column;
}

.landing-container {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 200px 24px 32px;
  background: var(--c-white);
  overflow-y: auto;
  font-family: var(--font);
}

.landing-title {
  font-family: var(--font-display);
  font-size: 2.2rem;
  font-weight: 400;
  color: var(--c-black);
  letter-spacing: -0.3px;
  line-height: 1.15;
  margin: 0 0 16px;
  text-align: center;
  animation: assistantsHeaderIn 0.48s cubic-bezier(0.16, 1, 0.3, 1) 0.06s backwards;
}

.landing-subtitle {
  max-width: 720px;
  margin: 0 auto 16px;
  font-size: 15px;
  line-height: 1.55;
  color: var(--text2);
  text-align: center;
  animation: assistantsPageIn 0.42s cubic-bezier(0.16, 1, 0.3, 1) 0.1s backwards;
}

.landing-features {
  max-width: 560px;
  margin: 0 auto 28px;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.landing-features li {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 13px;
  color: var(--text2);
  line-height: 1.45;
}

.landing-feature-dot {
  flex-shrink: 0;
  width: 6px;
  height: 6px;
  margin-top: 6px;
  border-radius: 50%;
  background: var(--c-teal-active);
}

.landing-quick-actions {
  display: flex;
  gap: 12px;
  margin-bottom: 48px;
}

.lqa-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: var(--c-white);
  border: 1px solid var(--border);
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  color: var(--c-black);
  cursor: pointer;
  transition: all 0.2s ease;
}

.lqa-btn:hover {
  background: var(--answers-blue-035);
  border-color: var(--c-blue-1);
}

.landing-search-wrapper {
  width: 100%;
  max-width: var(--answers-prompt-max);
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
  padding: 0 var(--space-5);
  box-sizing: border-box;
  animation: assistantsPageIn 0.42s cubic-bezier(0.16, 1, 0.3, 1) 0.12s backwards;
}

.lsw-top-bar {
  display: flex;
  gap: 16px;
  font-size: 13px;
  color: var(--c-black);
}

.lsw-pill-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: none;
  cursor: pointer;
  color: var(--c-black);
  font-weight: 500;
  font-family: var(--font);
  font-size: 13px;
}

/* Match Assistants \`.mi-prompt-shell\` / \`.mi-first-textarea\` dimensions */
.main-search-box {
  width: 100%;
  box-sizing: border-box;
  margin: var(--space-7) 0 var(--space-8);
  background: var(--c-white);
  border: 1px solid var(--mi-border-prompt);
  border-radius: 18px;
  padding: var(--answers-prompt-pad);
  display: flex;
  flex-direction: column;
  box-shadow: var(--mi-shadow-sm);
  animation: cardPopIn 0.44s cubic-bezier(0.16, 1, 0.3, 1) 0.14s backwards;
}

.main-search-textarea {
  width: 100%;
  box-sizing: border-box;
  background: transparent;
  border: none;
  resize: none;
  min-height: var(--answers-textarea-min-h);
  margin: 0;
  padding: 0;
  display: block;
  font-family: var(--font);
  font-size: 14.5px;
  line-height: 1.5;
  color: var(--mi-text-primary);
  outline: none;
}

.main-search-textarea::placeholder {
  color: var(--mi-text-placeholder);
}

.main-search-textarea:focus {
  outline: none;
}

.main-search-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 0;
  padding-top: 0.7rem;
  border-top: 1px solid var(--mi-border-toolbar);
  gap: 0.75rem;
  min-width: 0;
}

.main-search-footer .msf-left {
  flex: 1 1;
  min-width: 0;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.4;
}

.main-search-footer .answers-scope-chips {
  flex: 1 1;
  min-width: 0;
  justify-content: flex-start;
}

.main-search-footer button.msf-action {
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
}

/* Scope chips in search footer — typographically match Configure scope */
.main-search-footer .answers-scope-chip {
  min-height: 0;
  padding: 4px 10px;
  border: var(--border-width) solid var(--answers-teal-16);
  border-radius: var(--border-radius-pill);
  background: var(--c-white);
  font-family: var(--font);
  font-size: 13px;
  font-weight: 500;
  line-height: 1.4;
  letter-spacing: normal;
  color: var(--text2);
  -webkit-font-smoothing: antialiased;
}

.main-search-footer .answers-scope-chip-value {
  font: inherit;
  color: inherit;
}

.main-search-footer .answers-scope-chip-label {
  font-size: inherit;
  font-weight: inherit;
  color: var(--text3);
}

.main-search-footer .answers-scope-chip-count {
  font-size: inherit;
  font-weight: 600;
  line-height: inherit;
  color: var(--c-teal-active);
}

@media (max-width: 860px) {
  .answers-landing-page {
    --answers-prompt-radius: 20px;
    --answers-prompt-pad: 0.85rem 0.9rem 0.7rem;
    --answers-textarea-min-h: 82px;
  }

  .main-search-textarea {
    font-size: 1rem;
  }
}

.msf-left {
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 13px;
  color: var(--text2);
  flex-wrap: wrap;
}

.msf-action {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}

button.msf-action {
  flex-shrink: 0;
  background: transparent;
  border: none;
  border-radius: 6px;
  padding: 4px 8px;
  margin: -4px -8px;
  font: inherit;
  color: inherit;
  transition: color 0.15s ease, background-color 0.15s ease;
}

button.msf-action:hover {
  color: var(--c-black);
  background-color: var(--answers-teal-08);
}

button.msf-action:focus-visible {
  outline: 2px solid var(--c-teal-active);
  outline-offset: 2px;
}

.msf-divider {
  color: var(--text3);
  -webkit-user-select: none;
          user-select: none;
}

.msf-btn-primary {
  background: var(--c-neon);
  color: var(--c-black);
  border: none;
  border-radius: 8px;
  padding: 0 16px;
  height: 36px;
  font-weight: 500;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  font-family: var(--font);
}

.msf-btn-primary:hover:not(:disabled) {
  background: var(--neon-btn-bg-hover);
  color: var(--c-black);
}

.msf-btn-primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.landing-sources-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  margin-top: 20px;
  width: 100%;
  max-width: 960px;
  padding: 0 20px;
  box-sizing: border-box;
}

.source-chip {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  background: var(--c-white);
  border: 1px solid var(--border);
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  color: var(--c-black);
  cursor: pointer;
  transition: all 0.2s ease;
}

.answers-landing-source-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.answers-landing-source-dot--teal {
  background: var(--c-teal-active);
}

.answers-landing-source-dot--blue {
  background: var(--c-blue-1);
}

.source-chip:nth-child(1):hover {
  background: var(--answers-teal-045);
  border-color: var(--c-teal-active);
}

.source-chip:nth-child(2):hover {
  background: var(--answers-blue-035);
  border-color: var(--c-blue-1);
}

.source-chip:nth-child(3):hover {
  background: color-mix(in srgb, var(--c-cyan-3) 4%, transparent);
  border-color: var(--c-cyan-3);
}

.source-chip:nth-child(4):hover {
  background: color-mix(in srgb, var(--c-purple-1) 4%, transparent);
  border-color: var(--c-purple-1);
}

.recommended-section {
  width: 100%;
  margin-top: 0;
  padding: 0 0 48px;
  box-sizing: border-box;
  animation: assistantsPageIn 0.4s cubic-bezier(0.16, 1, 0.3, 1) 0.18s backwards;
}

.rs-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.rs-title {
  font-size: 14px;
  font-weight: 500;
  color: var(--text2);
}

.rs-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

@media (max-width: 900px) {
  .rs-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 600px) {
  .landing-title {
    font-size: 1.6rem;
  }

  .rs-grid {
    grid-template-columns: 1fr;
  }
}

.rs-card {
  background: var(--c-white);
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 24px;
  min-height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
  transition: border-color 0.2s ease, background-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
  box-shadow: 0 1px 2px var(--answers-black-018);
  animation: cardPopIn 0.38s cubic-bezier(0.16, 1, 0.3, 1) backwards;
}

.rs-card:nth-child(1) { animation-delay: 0.22s; }
.rs-card:nth-child(2) { animation-delay: 0.28s; }
.rs-card:nth-child(3) { animation-delay: 0.34s; }
.rs-card:nth-child(n + 4) { animation-delay: 0.4s; }

@media (prefers-reduced-motion: reduce) {
  .landing-title,
  .landing-subtitle,
  .landing-search-wrapper,
  .main-search-box,
  .recommended-section,
  .rs-card,
  .answers-copy-view,
  .answers-copy-view .answers-header,
  .answers-copy-view .ap-left,
  .answers-copy-view .ap-right,
  .answers-copy-view .version-card {
    animation: none;
  }
}

button.rs-card {
  width: 100%;
  text-align: left;
  font: inherit;
}

.rs-card:nth-child(1) {
  border-color: var(--c-teal-active);
}

.rs-card:nth-child(1):hover {
  background: var(--answers-teal-045);
}

.rs-card:nth-child(2) {
  border-color: var(--c-blue-1);
}

.rs-card:nth-child(2):hover {
  background: var(--answers-blue-035);
}

.rs-card:nth-child(3) {
  border-color: var(--c-cyan-3);
}

.rs-card:nth-child(3):hover {
  background: color-mix(in srgb, var(--c-cyan-3) 4%, transparent);
}

.rs-card:nth-child(4) {
  border-color: var(--c-purple-1);
}

.rs-card:nth-child(4):hover {
  background: color-mix(in srgb, var(--c-purple-1) 4%, transparent);
}

.rs-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px var(--answers-black-035);
}

.rs-card-title {
  font-family: var(--font-display);
  font-size: 16px;
  font-weight: 500;
  color: var(--c-black);
  line-height: 1.4;
}

.rs-card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 11px;
  color: var(--text2);
}

.rs-card-meta {
  display: flex;
  align-items: center;
  gap: 4px;
}

.rs-card-action-icon {
  flex-shrink: 0;
  color: var(--text3);
}


/* =============================================================================
   ANSWERS COPY — Workspace + morph (answers-assitant-13-May-2026)
   ============================================================================= */

.answers-copy-shell {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.answers-copy-view {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
  background: var(--c-white);
  color: var(--c-black);
  font-family: var(--font);
  overflow: hidden;
  animation: assistantsPageIn 0.42s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

.answers-copy-view .answers-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  border-bottom: 1px solid var(--border);
  animation: assistantsHeaderIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) 0.06s backwards;
}

.answers-copy-view .ah-title-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.answers-copy-view .ah-title {
  font-family: var(--font-display);
  font-size: 16px;
  font-weight: 500;
  color: var(--c-black);
  margin: 0;
}

.answers-copy-view .ah-left {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.answers-copy-view .ah-left .answers-scope-chips {
  max-width: min(720px, 100%);
}

.answers-copy-view .ah-meta {
  font-size: 11px;
  color: var(--text2);
  display: flex;
  align-items: center;
  gap: 12px;
}

.answers-copy-filter-summary {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  font-size: 12px;
  color: var(--text2);
  max-width: 180px;
}

.answers-copy-filter-summary span {
  font-weight: 600;
  color: var(--c-teal-active);
}

.answers-copy-filter-summary small {
  font-size: 12px;
  line-height: 1.2;
  text-align: right;
}

.answers-copy-view .answers-references-card--copy {
  margin-top: 12px;
  border: none;
  background: none;
  border-radius: 0;
  overflow: visible;
}

.answers-copy-view .answers-references-card--copy .answers-references-header {
  appearance: none;
  box-shadow: none;
  outline: none;
}

.answers-copy-view .answers-references-card--copy .answers-references-header:focus-visible {
  outline: 2px solid var(--c-teal-active);
  outline-offset: 2px;
}

.answers-copy-view .answers-references-card--copy .answers-reference-grid {
  grid-template-columns: 1fr;
  gap: 8px;
  padding: 8px 10px 10px;
  max-height: 320px;
  overflow-y: auto;
}

.ah-meta-filters-active {
  color: var(--c-teal-active);
  font-weight: 500;
}

.answers-copy-view .ah-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.answers-copy-view .answers-body {
  display: flex;
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
}

.answers-copy-view .ap-left {
  flex: 1 1;
  min-width: 360px;
  display: flex;
  flex-direction: column;
  background: var(--c-white);
  border-right: 1px solid var(--border);
  animation: cardPopIn 0.4s cubic-bezier(0.16, 1, 0.3, 1) 0.04s backwards;
}

.answers-copy-view .ap-left-scroll {
  flex: 1 1;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.answers-copy-user-bubble {
  align-self: flex-end;
  background: var(--c-black);
  color: var(--c-white);
  padding: 10px 14px;
  border-radius: 16px 16px 2px 16px;
  font-size: 13px;
  max-width: 85%;
  line-height: 1.4;
  box-shadow: 0 2px 4px var(--answers-black-035);
}

.answers-copy-view .version-card {
  align-self: stretch;
  width: 100%;
  margin-top: 0;
  text-align: left;
  animation: cardPopIn 0.5s cubic-bezier(0.16, 1, 0.3, 1) backwards;
}

.answers-copy-view .version-card--loading {
  display: flex;
  align-items: center;
  gap: 12px;
  color: var(--text3);
  font-size: 13px;
}

.answers-copy-view .vc-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  margin-bottom: 8px;
}

.answers-copy-view .vc-header .mi-assistant-head {
  margin: 0;
}

.answers-copy-view .vc-response-time {
  font-size: 11px;
  font-weight: 500;
  color: var(--text3);
  line-height: 1.2;
}

.vc-header-brand {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.answers-copy-view .vc-time {
  color: var(--text3);
  font-size: 12px;
  font-weight: 400;
}

.answers-copy-view .answers-thinking-card--copy {
  margin-bottom: 12px;
  border: 1px solid var(--border);
  border-radius: 8px;
  overflow: hidden;
}

.answers-copy-view .answers-thinking-card--copy .answers-thinking-body {
  max-height: 280px;
  overflow-y: auto;
}

.answers-copy-view .vc-content {
  font-size: 13px;
  line-height: 1.5;
  color: var(--c-black);
}

.answers-copy-view .vc-content--loading {
  display: flex;
  align-items: center;
  gap: 12px;
}

.vc-content-placeholder {
  color: var(--text3);
  font-size: 12px;
}

.answers-copy-view .vc-footer {
  margin-top: 12px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.answers-copy-view .vc-footer-left {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.answers-copy-view .vc-metrics {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 11px;
  color: var(--text3);
}

.answers-copy-view .vc-metrics span {
  font-weight: 600;
  color: var(--c-teal-active);
}

.answers-copy-view .vc-filter-stats {
  margin: 8px 0 0;
  font-size: 11px;
  line-height: 1.45;
  color: var(--text2);
}

button.source-chip--btn {
  border: none;
  background: transparent;
  font: inherit;
  cursor: pointer;
}

button.source-chip--btn:hover {
  border-color: var(--c-teal-active);
}

.answers-copy-view .vc-actions {
  display: flex;
  gap: 12px;
  color: var(--text3);
}

.answers-copy-view .vc-action-btn {
  cursor: pointer;
  opacity: 0.7;
  background: transparent;
  border: none;
  padding: 0;
}

.answers-copy-view .vc-action-btn:hover {
  opacity: 1;
  color: var(--c-black);
}

.answers-copy-query-error {
  color: var(--c-orange);
  font-size: 12px;
  padding: 10px;
  background: var(--orange-bg);
  border-radius: 8px;
  margin-top: 10px;
}

.answers-copy-view .ap-left-input-area {
  padding: 12px 16px 12px 20px;
  border-top: 1px solid var(--border);
}

.answers-copy-view .ask-box {
  background: var(--c-white);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 6px 12px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 1px 4px var(--answers-black-018);
  gap: 6px;
}

.answers-copy-view .ask-textarea {
  background: transparent;
  border: none;
  resize: none;
  font-size: 13px;
  line-height: 1.45;
  color: var(--c-black);
  min-height: 36px;
  height: 36px;
  max-height: 120px;
  padding: 0;
  outline: none;
  font-family: var(--font);
  width: 100%;
}

.answers-copy-view .ask-textarea::placeholder {
  color: var(--text3);
}

.answers-copy-view .ask-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 2px;
}

.answers-copy-view .ask-tb-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.answers-copy-view .ask-send-btn {
  background: var(--c-neon);
  color: var(--c-black);
  border: none;
  width: 26px;
  height: 26px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.answers-copy-view .ask-send-btn svg {
  color: var(--c-black);
}

.answers-copy-view .ap-right {
  width: min(840px, 52vw);
  flex-shrink: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: var(--c-white);
  animation: miSourcesPanelIn 0.38s cubic-bezier(0.16, 1, 0.3, 1) 0.1s backwards;
}

.answers-copy-view .ap-right-toolbar {
  display: flex;
  align-items: center;
  height: 54px;
  padding: 0 16px;
  flex-shrink: 0;
  border-bottom: 1px solid var(--border);
  background: var(--c-white);
  overflow-x: auto;
}

.ap-right-citations {
  display: flex;
  gap: 8px;
  align-items: center;
  flex: 1 1;
  overflow-x: auto;
}

.ap-right-citations-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  color: var(--c-black);
  margin-right: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  flex-shrink: 0;
}

.ap-right-citation-tab {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  color: var(--text2);
  border: 1px solid var(--border);
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s;
  font-family: var(--font);
}

.ap-right-citation-tab.is-selected {
  background: var(--answers-teal-10);
  color: var(--c-teal-active);
  border-color: var(--c-teal-active);
  font-weight: 600;
}

.ap-right-citation-score {
  font-size: 10px;
  font-weight: 600;
  color: var(--c-teal-active);
}

.ap-right-citation-page {
  opacity: 0.7;
  font-size: 10px;
  background: var(--answers-black-018);
  padding: 1px 4px;
  border-radius: 3px;
}

.answers-copy-view .ap-right-content {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: color-mix(in srgb, var(--c-black) 3%, var(--c-white));
  padding: 0;
  overflow: hidden;
  position: relative;
}

.ap-right-pdf-frame {
  width: 100%;
  height: 100%;
  border: none;
  background: color-mix(in srgb, var(--c-black) 3%, var(--c-white));
}

.ap-right-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: var(--text3);
  padding: 40px;
}

.ap-right-empty-icon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: color-mix(in srgb, var(--c-black) 4%, var(--c-white));
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}

.ap-right-empty-icon svg {
  opacity: 0.3;
  color: var(--c-black);
}

.ap-right-empty-title {
  font-size: 14px;
  color: var(--text2);
  font-weight: 500;
  text-align: center;
}

.ap-right-empty-sub {
  font-size: 12px;
  color: var(--text3);
  margin-top: 8px;
  text-align: center;
  max-width: 300px;
}

.answers-copy-view .doc-h1 {
  font-family: var(--font-display);
  font-size: 24px;
  font-weight: 500;
  line-height: 1.3;
  margin: 0 0 24px;
  color: var(--c-black);
}

.answers-copy-view .doc-h2 {
  font-size: 14px;
  font-weight: 500;
  margin: 32px 0 12px;
  color: var(--c-black);
}

.answers-copy-view .doc-p {
  font-size: 14px;
  line-height: 1.6;
  color: var(--ink-emphasis);
  margin: 0 0 16px;
}

.doc-p--inline {
  margin: 0;
}

.doc-li-row {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
  padding-left: 16px;
}

.morph-ghost {
  position: fixed;
  z-index: 10000;
  background: var(--c-white);
  border: 1px solid var(--border);
  border-radius: 16px;
  box-shadow: 0 8px 24px var(--answers-black-08);
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 28px;
  pointer-events: none;
  overflow: hidden;
}

.morph-ghost.animating {
  transition: all 0.65s cubic-bezier(0.19, 1, 0.22, 1);
}

.morph-ghost-text {
  font-size: 15px;
  color: var(--c-black);
  opacity: 0.9;
}

@keyframes answersSlideDownIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes answersZoomInLift {
  from {
    opacity: 0;
    transform: scale(0.98) translateY(15px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

@keyframes cardPopIn {
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.animate-spin {
  animation: spin 1s linear infinite;
}

.premium-loader-orb {
  position: relative;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
}

.orb-core {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 1px solid var(--c-black);
  animation: orbPulse 1.5s cubic-bezier(0.45, 0, 0.55, 1) infinite, orbCoreColors 4s ease-in-out infinite;
}

.orb-ring {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 3px solid var(--c-white);
  border-top-color: var(--c-purple-1);
  border-right-color: transparent;
  animation: spin 0.9s cubic-bezier(0.5, 0.1, 0.5, 0.9) infinite, orbRingColors 4s linear infinite;
}

@keyframes orbPulse {
  0%, 100% { transform: scale(0.8); opacity: 0.8; }
  50% { transform: scale(1.25); opacity: 1; }
}

@keyframes orbCoreColors {
  0%, 100% { background: var(--c-purple-1); box-shadow: 0 0 12px 2px var(--glow-purple); }
  25% { background: var(--c-aqua-mass); box-shadow: 0 0 12px 2px var(--glow-teal); }
  50% { background: var(--c-blue-3); box-shadow: 0 0 12px 2px var(--glow-blue); }
  75% { background: var(--c-purple-2); box-shadow: 0 0 12px 2px var(--glow-purple); }
}

@keyframes orbRingColors {
  0%, 100% { border-top-color: var(--c-purple-1); }
  25% { border-top-color: var(--c-aqua-mass); }
  50% { border-top-color: var(--c-blue-3); }
  75% { border-top-color: var(--c-purple-2); }
}

.answers-md--copy h2,
.answers-md--copy h3,
.answers-md--copy p,
.answers-md--copy li {
  font-size: inherit;
  line-height: 1.5;
}

.answers-copy-suggestions {
  margin-top: 12px;
  padding-top: 10px;
  border-top: 1px solid var(--border);
}

.answers-copy-suggestions p {
  font-size: 11px;
  color: var(--text2);
  margin: 0 0 8px;
}

.answers-copy-suggestions div {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.answers-copy-suggestions button {
  font-size: 11px;
  padding: 4px 10px;
  border-radius: 6px;
  border: 1px solid var(--border);
  background: var(--c-white);
  cursor: pointer;
  text-align: left;
  justify-content: flex-start;
}

.answers-copy-source-summary {
  flex-shrink: 0;
  padding: 12px 16px;
  border-bottom: 1px solid var(--border);
  font-size: 12px;
}

.answers-copy-source-summary h3 {
  margin: 0 0 4px;
  font-size: 13px;
}

.answers-copy-source-summary p {
  margin: 0;
  color: var(--text2);
}

.answers-copy-pdf-frame {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.answers-copy-source-text {
  padding: 16px;
  font-size: 13px;
  line-height: 1.5;
  overflow-y: auto;
}


/* =============================================================================
   ANSWERS — Chat workspace (/answers/chat)
   ============================================================================= */

.answers-shell {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  background: var(--c-white);
  color: var(--c-black);
  font-family: var(--font);
  font-size: var(--fs-base);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.answers-shell *,
.answers-shell input,
.answers-shell button,
.answers-shell select,
.answers-shell textarea {
  box-sizing: border-box;
  font-family: var(--font);
}

.answers-shell-header {
  min-height: var(--space-10);
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: calc(var(--space-3) + var(--space-2));
  padding: var(--space-2) var(--space-6);
  background: var(--c-white);
  border-bottom: var(--border-width) solid var(--border-color);
}

.answers-brand-block {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  min-width: 0;
}

.answers-brand-block h1,
.answers-empty-card h2,
.answers-evidence-header h2,
.answers-source-summary h3 {
  margin: 0;
  color: var(--c-black);
  font-family: var(--font-display);
  letter-spacing: -0.035em;
}

.answers-brand-block h1 {
  font-size: var(--fs-lg);
  line-height: 1;
  font-weight: 600;
}

.answers-scope-chips {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: var(--space-2);
  overflow-x: auto;
  scrollbar-width: none;
}

.answers-scope-chips::-webkit-scrollbar {
  display: none;
}

.answers-scope-chip {
  min-height: var(--space-6);
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 7px;
  border: var(--border-width) solid var(--answers-teal-16);
  border-radius: 8px;
  background: var(--c-white);
  color: var(--c-black);
  font-family: var(--font);
  font-size: 12px;
  padding: 0 var(--space-2);
}

.answers-scope-chip-label {
  color: var(--text3);
  font-family: var(--font);
  font-size: inherit;
  font-weight: inherit;
}

.answers-scope-chip-count {
  flex-shrink: 0;
  color: var(--c-teal-active);
  font-size: inherit;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

.answers-eyebrow {
  margin: 0;
  color: var(--text3);
  font-size: var(--fs-xs);
  font-weight: 600;
  letter-spacing: 0.11em;
  line-height: 1.2;
  text-transform: uppercase;
}

.answers-header-actions {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: var(--space-3);
}

.answers-filter-summary {
  min-width: 132px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 1px;
}

.answers-filter-summary span {
  color: var(--c-black);
  font-size: var(--fs-sm);
  font-weight: 700;
}

.answers-filter-summary small {
  max-width: 180px;
  overflow: hidden;
  color: var(--text3);
  font-size: calc(var(--fs-sm) - 1px);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.answers-layout {
  flex: 1 1 auto;
  min-height: 0;
  display: grid;
  grid-template-columns: minmax(680px, 1fr) minmax(360px, 30vw);
  gap: calc(var(--space-3) + var(--space-1));
  padding: calc(var(--space-3) + var(--space-1)) var(--space-4) var(--space-4);
}

.answers-workspace,
.answers-evidence-panel {
  min-height: 0;
  overflow: hidden;
  border: var(--border-width) solid var(--border-color);
  border-radius: calc(var(--border-radius-xl) - var(--space-1));
  background: var(--c-white);
  box-shadow: 0 var(--space-4) calc(var(--space-6) + var(--space-2)) var(--answers-black-05);
}

.answers-workspace {
  display: flex;
  flex-direction: column;
}

.answers-scroll-area {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: var(--space-6) calc(var(--space-7) - var(--space-1)) var(--space-7);
  background: var(--c-white);
}

.answers-error-banner,
.answers-loading-banner {
  margin-bottom: calc(var(--space-3) + var(--space-2));
  padding: var(--space-3) calc(var(--space-3) + var(--space-1));
  border-radius: var(--border-radius-lg);
  font-size: calc(var(--fs-base) - 1px);
}

.answers-error-banner {
  border: var(--border-width) solid var(--answers-orange-30);
  background: var(--orange-bg);
  color: var(--c-orange);
}

.answers-loading-banner,
.answers-loading-inline {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  color: var(--text2);
}

.answers-loading-banner span,
.answers-loading-inline span {
  width: 7px;
  height: 7px;
  border-radius: var(--border-radius-pill);
  background: var(--c-teal-active);
  animation: answersPulse 1.2s ease-in-out infinite;
}

.answers-loading-inline span:nth-child(2) {
  animation-delay: 0.12s;
}

.answers-loading-inline span:nth-child(3) {
  animation-delay: 0.24s;
}

@keyframes answersPulse {
  0%, 100% {
    opacity: 0.35;
    transform: scale(0.82);
  }
  50% {
    opacity: 1;
    transform: scale(1.1);
  }
}

.answers-empty-card {
  position: relative;
  max-width: 760px;
  margin: 5vh auto 0;
  padding: calc(var(--space-7) - var(--space-1));
  overflow: hidden;
  border: var(--border-width) solid var(--answers-teal-16);
  border-radius: calc(var(--border-radius-xl) + var(--space-1));
  background: var(--c-white);
  box-shadow: 0 var(--space-7) calc(var(--space-8) + var(--space-2)) var(--answers-black-055);
}

.answers-empty-card h2 {
  position: relative;
  max-width: 560px;
  margin-top: 7px;
  font-size: clamp(var(--fs-2xl), 3.4vw, var(--fs-3xl));
  line-height: 1;
  letter-spacing: -0.045em;
}

.answers-empty-card p:not(.answers-eyebrow) {
  position: relative;
  max-width: 620px;
  margin: calc(var(--space-3) + 1px) 0 0;
  color: var(--text2);
  font-size: calc(var(--fs-base) - 1px);
  line-height: 1.55;
}

.answers-empty-card > .answers-scope-chips {
  position: relative;
  max-width: 100%;
  margin-top: calc(var(--space-3) + var(--space-2));
}

.answers-hero-prompt {
  position: relative;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: var(--space-3);
  align-items: center;
  margin-top: calc(var(--space-3) + var(--space-2));
  padding: 7px var(--space-2) 7px calc(var(--space-3) + var(--space-1));
  border: var(--border-width) solid var(--answers-black-12);
  border-radius: var(--border-radius-xl);
  background: var(--c-white);
  box-shadow: 0 var(--space-4) calc(var(--space-6) + var(--space-2)) var(--answers-black-05);
}

.answers-hero-prompt:focus-within {
  border-color: var(--answers-teal-42);
  box-shadow:
    0 0 0 var(--space-2) var(--answers-teal-10),
    0 calc(var(--space-4) + var(--space-2)) calc(var(--space-7) + var(--space-2)) var(--answers-black-06);
}

.answers-hero-prompt input {
  min-width: 0;
  min-height: calc(var(--space-8) + var(--space-2));
  border: none;
  outline: none;
  background: transparent;
  color: var(--c-black);
  font-size: calc(var(--fs-base) - 1px);
}

.answers-hero-prompt input::placeholder {
  color: var(--text3);
}

.answers-hero-prompt button {
  min-width: calc(var(--space-8) + var(--space-6));
  height: calc(var(--space-6) + var(--space-2));
  border: none;
  border-radius: var(--border-radius-md);
  background: var(--c-black);
  color: var(--c-white);
  cursor: pointer;
  font-size: var(--fs-sm);
  font-weight: 800;
}

.answers-hero-prompt button:hover:not(:disabled) {
  background: var(--c-teal-active);
}

.answers-hero-prompt button:disabled {
  background: var(--answers-black-08);
  color: var(--text3);
  cursor: not-allowed;
}

.answers-empty-actions {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
  margin-top: calc(var(--space-3) + var(--space-2));
}

.answers-empty-actions button,
.answers-suggestions button {
  min-height: calc(var(--space-6) + var(--space-2));
  border: var(--border-width) solid var(--border-color);
  border-radius: var(--border-radius-pill);
  background: var(--c-white);
  color: var(--c-black);
  cursor: pointer;
  font-size: var(--fs-sm);
  font-weight: 700;
  padding: 0 calc(var(--space-3) - 1px);
}

.answers-empty-actions button:hover,
.answers-suggestions button:hover {
  background: var(--answers-teal-08);
  border-color: var(--answers-teal-24);
}

.answers-turn + .answers-turn {
  margin-top: var(--space-6);
}

.answers-question-row {
  display: flex;
  justify-content: flex-end;
  margin-bottom: calc(var(--space-3) + var(--space-1));
}

.answers-question-bubble {
  max-width: min(760px, 82%);
  padding: var(--space-3) calc(var(--space-3) + var(--space-1));
  border: var(--border-width) solid var(--answers-teal-20);
  border-radius: calc(var(--border-radius-md) + var(--space-1)) calc(var(--border-radius-md) + var(--space-1)) var(--border-radius-sm) calc(var(--border-radius-md) + var(--space-1));
  background: var(--c-white);
  color: var(--c-black);
  font-size: calc(var(--fs-base) - 1px);
  font-weight: 700;
  line-height: 1.45;
}

.answers-response-grid {
  display: grid;
  gap: var(--space-3);
}

.answers-response-meta {
  color: var(--text3);
  font-size: var(--fs-sm);
}

.answers-answer-card,
.answers-thinking-card,
.answers-references-card,
.answers-suggestions {
  border: var(--border-width) solid var(--border-color);
  border-radius: calc(var(--border-radius-md) + var(--space-1));
  background: var(--c-white);
}

.answers-answer-card {
  padding: 0;
  overflow: hidden;
  border-color: var(--answers-teal-14);
  box-shadow: 0 var(--space-4) calc(var(--space-6) + var(--space-2)) var(--answers-black-055);
}

.answers-artifact-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: calc(var(--space-3) + var(--space-1));
  padding: calc(var(--space-4) + 1px) var(--space-6) calc(var(--space-3) + 1px);
  border-bottom: var(--border-width) solid var(--border-color);
  background: var(--c-white);
}

.answers-artifact-header h2 {
  margin: var(--space-1) 0 0;
  color: var(--c-black);
  font-family: var(--font-display);
  font-size: var(--fs-xl);
  line-height: 1.05;
  letter-spacing: -0.035em;
}

.answers-artifact-metrics {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: var(--space-2);
}

.answers-artifact-metrics span {
  min-height: 23px;
  display: inline-flex;
  align-items: center;
  border: var(--border-width) solid var(--answers-teal-14);
  border-radius: var(--border-radius-pill);
  background: var(--c-white);
  color: var(--text2);
  font-size: var(--fs-xs);
  font-weight: 800;
  padding: 0 var(--space-2);
}

.answers-answer-body {
  max-width: 900px;
  padding: calc(var(--space-3) + var(--space-1)) var(--space-6) var(--space-6);
}

.answers-skeleton {
  display: grid;
  gap: var(--space-3);
}

.answers-skeleton span {
  height: var(--fs-base);
  border-radius: var(--border-radius-pill);
  background: var(--bar-track-bg);
  animation: answersSkeletonPulse 1.2s ease-in-out infinite;
}

.answers-skeleton span:nth-child(3) {
  width: 62%;
}

@keyframes answersSkeletonPulse {
  0%,
  100% {
    opacity: 0.55;
  }

  50% {
    opacity: 1;
  }
}

.answers-thinking-card {
  overflow: hidden;
  background: var(--c-white);
}

.answers-thinking-card > button {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: none;
  background: transparent;
  color: var(--c-black);
  cursor: pointer;
  font-size: var(--fs-sm);
  font-weight: 800;
  padding: calc(var(--space-3) - 1px) calc(var(--space-3) + var(--space-1));
  text-align: left;
}

.answers-thinking-card > button span:last-child {
  color: var(--text3);
  font-size: calc(var(--fs-sm) - 1px);
  font-weight: 700;
}

.answers-thinking-body {
  border-top: var(--border-width) solid var(--border-color);
  color: var(--text2);
  font-size: var(--fs-sm);
  line-height: 1.55;
  padding: calc(var(--space-3) - 1px) calc(var(--space-3) + var(--space-1));
  white-space: pre-wrap;
  word-break: break-word;
}

.answers-loading-inline em {
  color: var(--text2);
  font-style: normal;
  font-size: calc(var(--fs-base) - 1px);
}

.answers-references-card {
  padding: 0;
  overflow: hidden;
  border-color: var(--answers-blue-14);
}

.answers-references-header {
  display: inline;
  width: auto;
  margin: 0;
  padding: 0;
  border: none;
  background: none;
  box-shadow: none;
  appearance: none;
  color: var(--ui-text-body);
  font: inherit;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
  text-align: left;
  text-decoration: none;
  cursor: pointer;
  outline: none;
}

.answers-references-header:hover {
  color: var(--c-teal-3);
  /* text-decoration: underline; */
  /* text-underline-offset: 2px; */
}

.answers-references-body {
  display: grid;
  grid-template-rows: 0fr;
  opacity: 0;
  overflow: hidden;
  transition:
    grid-template-rows 0.38s cubic-bezier(0.4, 0, 0.2, 1),
    opacity 0.28s ease;
}

.answers-references-body.is-expanded {
  grid-template-rows: 1fr;
  opacity: 1;
}

.answers-references-body-inner {
  min-height: 0;
  overflow: visible;
}

@media (prefers-reduced-motion: reduce) {
  .answers-references-body {
    transition: none;
  }
}

.answers-reference-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: var(--space-2);
  padding: var(--space-3);
}

.answers-reference-card {
  min-height: calc(var(--space-9) + var(--space-6));
  display: grid;
  grid-template-columns: calc(var(--space-8) + var(--space-2)) 1fr;
  gap: 9px;
  align-items: flex-start;
  border: var(--border-width) solid var(--border-color);
  border-radius: var(--border-radius-md);
  background: var(--c-white);
  color: var(--c-black);
  cursor: pointer;
  padding: var(--space-3) calc(var(--space-3) - 1px);
  text-align: left;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
}

.answers-reference-card:hover {
  border-color: var(--answers-teal-28);
  box-shadow: 0 var(--space-3) calc(var(--space-6) - var(--space-1)) var(--answers-black-06);
  transform: translateY(-1px);
}

.answers-reference-card.is-selected {
  border-color: var(--answers-teal-48);
  box-shadow: 0 var(--space-3) var(--space-6) var(--answers-teal-08);
}

.answers-reference-score {
  width: var(--space-9);
  height: calc(var(--space-4) + var(--space-2));
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--border-radius-pill);
  background: var(--answers-teal-08);
  color: var(--c-teal-active);
  font-size: var(--fs-xs);
  font-weight: 800;
}

.answers-reference-content {
  min-width: 0;
  display: grid;
  gap: 2px;
}

.answers-reference-content strong {
  color: var(--c-black);
  font-size: calc(var(--fs-xs) + 1px);
  line-height: 1.25;
}

.answers-reference-content span,
.answers-reference-content small {
  overflow: hidden;
  color: var(--text2);
  font-size: var(--fs-xs);
  line-height: 1.3;
  text-overflow: ellipsis;
}

.answers-suggestions {
  padding: var(--space-3);
}

.answers-suggestions p {
  margin: 0 0 var(--space-2);
  color: var(--text2);
  font-size: var(--fs-sm);
  font-weight: 700;
}

.answers-suggestions div {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
}

.answers-composer {
  flex: 0 0 auto;
  padding: var(--space-3) calc(var(--space-7) - var(--space-1)) calc(var(--space-3) + var(--space-1));
  border-top: var(--border-width) solid var(--border-color);
  background: var(--c-white);
}

.answers-composer-box {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  min-height: calc(var(--space-8) + var(--space-4));
  border: var(--border-width) solid var(--answers-black-12);
  border-radius: calc(var(--border-radius-md) + var(--space-1));
  background: var(--c-white);
  padding: var(--space-2) 7px var(--space-2) calc(var(--space-3) + var(--space-1));
}

.answers-composer-box:focus-within {
  border-color: var(--answers-teal-36);
  box-shadow: 0 0 0 var(--space-2) var(--answers-teal-08);
}

.answers-composer-box input {
  flex: 1 1;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  color: var(--c-black);
  font-size: calc(var(--fs-base) - 1px);
}

.answers-composer-box input::placeholder {
  color: var(--text3);
}

.answers-composer-box button {
  min-width: calc(var(--space-8) + var(--space-6));
  height: var(--space-8);
  border: none;
  border-radius: var(--border-radius-md);
  background: var(--c-teal-active);
  color: var(--c-white);
  cursor: pointer;
  font-size: var(--fs-sm);
  font-weight: 800;
}

.answers-composer-box button:disabled {
  background: var(--answers-black-08);
  color: var(--text3);
  cursor: not-allowed;
}

.answers-evidence-panel {
  display: flex;
  flex-direction: column;
}

.answers-evidence-header {
  flex: 0 0 auto;
  padding: calc(var(--space-4) - 1px) calc(var(--space-4) + 1px) var(--space-3);
  border-bottom: var(--border-width) solid var(--border-color);
  background: var(--c-white);
}

.answers-evidence-header h2 {
  margin-top: var(--space-1);
  font-size: calc(var(--fs-md) + 1px);
  line-height: 1.05;
}

.answers-evidence-empty {
  margin: calc(var(--space-3) + var(--space-1));
  padding: var(--space-6) calc(var(--space-4) + var(--space-1));
  border: var(--border-width) dashed var(--answers-blue-24);
  border-radius: calc(var(--border-radius-md) + var(--space-1));
  background: var(--c-white);
  text-align: center;
}

.answers-evidence-empty h3 {
  margin: 0 0 var(--space-2);
  color: var(--c-black);
  font-size: calc(var(--fs-base) - 1px);
}

.answers-evidence-empty p {
  margin: 0 auto;
  max-width: 320px;
  color: var(--text2);
  font-size: var(--fs-sm);
  line-height: 1.55;
}

.answers-source-summary {
  flex: 0 0 auto;
  padding: calc(var(--space-3) + 1px) var(--space-4) var(--space-3);
  border-bottom: var(--border-width) solid var(--border-color);
}

.answers-source-summary h3 {
  font-size: calc(var(--fs-base) + 1px);
  line-height: 1.15;
}

.answers-source-summary p {
  margin: 7px 0 0;
  color: var(--text2);
  font-size: calc(var(--fs-sm) - 1px);
  line-height: 1.35;
}

.answers-source-summary a {
  width: fit-content;
  display: inline-flex;
  align-items: center;
  min-height: calc(var(--space-6) + var(--space-2));
  margin-top: var(--space-2);
  border-radius: var(--border-radius);
  background: var(--answers-blue-08);
  color: var(--c-blue-1);
  font-size: calc(var(--fs-sm) - 1px);
  font-weight: 800;
  padding: 0 var(--space-3);
  text-decoration: none;
}

.answers-source-summary a:hover {
  color: var(--c-blue-2);
}

.answers-pdf-frame {
  flex: 1 1 auto;
  min-height: 0;
  padding: var(--space-3);
}

.answers-source-text {
  flex: 1 1 auto;
  overflow: auto;
  margin: calc(var(--space-3) + var(--space-1));
  border: var(--border-width) solid var(--border-color);
  border-radius: calc(var(--border-radius-md) + var(--space-1));
  color: var(--text2);
  font-size: calc(var(--fs-base) - 1px);
  line-height: 1.6;
  padding: var(--space-4);
  white-space: pre-wrap;
}

.context-pdf-error {
  margin: calc(var(--space-3) + var(--space-1));
  padding: var(--space-3) calc(var(--space-3) + var(--space-1));
  border: var(--border-width) solid var(--answers-orange-28);
  border-radius: var(--border-radius-lg);
  background: var(--orange-bg);
  color: var(--c-orange);
  font-size: calc(var(--fs-base) - 1px);
  line-height: 1.45;
}

.pdfjs-viewer {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: var(--border-width) solid var(--border-color);
  border-radius: calc(var(--border-radius-md) + var(--space-1));
  background: var(--c-white);
}

.pdfjs-toolbar {
  min-height: calc(var(--space-8) + var(--space-2));
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 7px;
  padding: var(--space-2) var(--space-3);
  border-bottom: var(--border-width) solid var(--border-color);
  background: var(--c-white);
  color: var(--text2);
  font-size: var(--fs-sm);
  flex-wrap: wrap;
}

.pdfjs-toolbar button {
  min-height: calc(var(--space-6) + var(--space-1));
  border: var(--border-width) solid var(--border-color);
  border-radius: var(--border-radius);
  background: var(--c-white);
  color: var(--c-black);
  cursor: pointer;
  font-size: var(--fs-sm);
  font-weight: 800;
  padding: var(--space-1) var(--space-2);
}

.pdfjs-toolbar button:hover:not(:disabled) {
  background: var(--answers-teal-08);
}

.pdfjs-toolbar button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.pdfjs-scroll {
  flex: 1 1 auto;
  min-height: 0;
  position: relative;
  overflow-x: auto;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: calc(var(--space-3) + var(--space-1));
  background: var(--answers-surface-muted, #f4f5f7);
}

.pdfjs-scroll--loading .pdfjs-page {
  visibility: hidden;
  pointer-events: none;
}

.pdfjs-loading-panel {
  position: absolute;
  inset: 0;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--space-3);
  padding: var(--space-6) var(--space-4);
  text-align: center;
  background: var(--answers-surface-muted, #f4f5f7);
}

.pdfjs-loading-panel--page {
  background: rgba(244, 245, 247, 0.92);
}

.pdfjs-loading-spinner {
  width: 36px;
  height: 36px;
  border: 3px solid var(--border-color);
  border-top-color: var(--c-teal-active);
  border-radius: 50%;
  animation: pdfjsSpin 0.85s linear infinite;
}

.pdfjs-loading-title {
  margin: 0;
  color: var(--text1);
  font-size: var(--fs-base);
  font-weight: 600;
}

.pdfjs-loading-meta {
  margin: 0;
  color: var(--text2);
  font-size: var(--fs-sm);
}

.pdfjs-loading-hint {
  margin: 0;
  max-width: 28rem;
  color: var(--text2);
  font-size: var(--fs-sm);
  line-height: 1.45;
}

@keyframes pdfjsSpin {
  to {
    transform: rotate(360deg);
  }
}

.pdfjs-page {
  position: relative;
  margin: 0 auto;
  background: var(--c-white);
  box-shadow:
    0 var(--space-2) var(--space-3) var(--answers-black-12),
    0 calc(-1 * var(--space-2)) var(--space-3) var(--answers-black-12);
}

.pdfjs-page canvas {
  display: block;
}

.pdfjs-text-layer {
  position: absolute;
  inset: 0;
  overflow: hidden;
  line-height: 1;
  opacity: 1;
}

.pdfjs-text-layer span {
  position: absolute;
  color: transparent;
  pointer-events: none;
  transform-origin: 0 0;
  white-space: pre;
}

.citation-highlight {
  position: absolute;
  z-index: 3;
  border: var(--border-width-thick) solid var(--c-teal-active);
  border-radius: var(--border-radius-sm);
  background: var(--answers-teal-14);
  box-sizing: border-box;
  pointer-events: none;
}

.pdfjs-text-layer .citation-highlight-text {
  border-radius: var(--border-radius-sm);
  background: color-mix(in srgb, var(--c-teal-active) 22%, transparent) !important;
}


@media (max-width: 1180px) {
  .answers-layout {
    grid-template-columns: minmax(0, 1fr) 350px;
    padding: calc(var(--space-3) + var(--space-1));
  }

  .answers-scroll-area {
    padding: calc(var(--space-6) - var(--space-1));
  }

  .answers-composer {
    padding: var(--space-3) calc(var(--space-6) - var(--space-1)) calc(var(--space-3) + var(--space-1));
  }
}

@media (max-width: 980px) {
  .answers-shell-header {
    height: auto;
    min-height: calc(var(--space-8) + var(--space-7));
    align-items: flex-start;
    flex-direction: column;
    padding: calc(var(--space-3) + var(--space-1)) var(--space-4);
  }

  .answers-header-actions {
    width: 100%;
    margin-left: 0;
    justify-content: flex-end;
    flex-wrap: wrap;
  }

  .answers-filter-summary {
    align-items: flex-start;
    margin-right: auto;
  }

  .answers-layout {
    grid-template-columns: 1fr;
    overflow-y: auto;
  }

  .answers-workspace,
  .answers-evidence-panel {
    min-height: 560px;
  }

  .answers-evidence-panel {
    max-height: 620px;
  }
}

@media (max-width: 640px) {
  .answers-scroll-area {
    padding: var(--space-5);
  }

  .answers-answer-card {
    padding: 0;
  }

  .answers-empty-card {
    padding: calc(var(--space-6) - var(--space-1));
  }

  .answers-empty-card h2 {
    font-size: calc(var(--fs-2xl) + 2px);
  }

  .answers-reference-grid {
    grid-template-columns: 1fr;
  }

  .filters-details-drawer .rag-date-range-row {
    grid-template-columns: 1fr;
  }
}


/* =============================================================================
   DOCUMENTS — filings / exports (not Answers or Assistants)
   Colors: var(--doc-*), var(--c-*) from tokens.css
   ============================================================================= */

.markdown-content,
.doc-body {
  color: var(--doc-text);
  font-size: var(--fs-base);
  line-height: 1.58;
}

.markdown-content p,
.doc-body p,
.doc-p {
  margin: 0 0 var(--space-2);
  font-size: var(--fs-base);
  line-height: 1.58;
  color: var(--doc-text);
}

.markdown-content h1,
.markdown-content h2,
.markdown-content h3,
.doc-h1,
.doc-h2 {
  margin: var(--space-4) 0 var(--space-2);
  color: var(--c-black);
  font-family: var(--font-display);
  letter-spacing: -0.03em;
}

.markdown-content h1,
.doc-h1 {
  font-size: var(--fs-2xl);
  font-weight: 500;
  line-height: 1.3;
  margin-bottom: var(--space-6);
}

.markdown-content h2,
.doc-h2 {
  font-size: 17px;
  line-height: 1.2;
}

.markdown-content h3 {
  font-size: 15px;
  line-height: 1.25;
}

.markdown-content ul,
.markdown-content ol,
.doc-ol {
  margin: 0 0 var(--space-3);
  padding-left: 18px;
}

.markdown-content li {
  margin: 0 0 6px 20px;
  padding-left: 2px;
}

.markdown-content a,
.doc-body a {
  color: var(--c-blue-1);
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.markdown-content a:hover {
  color: var(--c-blue-2);
}

.markdown-content strong,
.markdown-content b {
  font-weight: 600;
  color: var(--c-black);
}

.markdown-content code {
  font-family: var(--mono);
  font-size: 0.92em;
  padding: 1px 5px;
  border-radius: var(--border-radius-sm);
  background: var(--doc-code-bg);
}

.markdown-content pre {
  margin: 0 0 var(--space-3);
  padding: var(--space-3);
  border: var(--border-width) solid var(--border);
  border-radius: var(--border-radius);
  background: var(--doc-pre-bg);
  overflow-x: auto;
}

.markdown-content pre code {
  padding: 0;
  background: transparent;
}

.markdown-content blockquote {
  margin: 0 0 var(--space-3);
  padding-left: var(--space-3);
  border-left: 3px solid var(--border);
  color: var(--text2);
}

.markdown-spacer {
  height: 10px;
}

.doc-sup {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  background: var(--border);
  color: var(--text3);
  width: 14px;
  height: 14px;
  border-radius: var(--border-radius-sm);
  margin-left: 3px;
  vertical-align: top;
}

.doc-li-title {
  font-weight: 500;
  margin-bottom: var(--space-1);
}


/* =============================================================================
   ASSISTANTS — Pre-built Assistants landing (/assistants)
   Colors: var(--ui-*), var(--c-*) from tokens.css (via index.css)
   ============================================================================= */

@keyframes assistantsPageIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes assistantsHeaderIn {
  from {
    opacity: 0;
    transform: translateY(-12px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.assistants-page {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  flex: 1 1;
  padding: 20px;
  max-width: 100%;
  margin: 0 auto;
  overflow-x: auto;
  overflow-y: auto;
  font-family: var(--font);
  font-size: var(--fs-base);
  color: var(--c-black);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  animation: assistantsPageIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

.assistants-page *,
.assistants-page button,
.assistants-page input,
.assistants-page select,
.assistants-page textarea {
  font-family: var(--font);
}

.assistants-surface {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  background: var(--ui-surface);
  border: 1px solid var(--ui-border-shell);
  border-radius: var(--border-radius);
  /* box-shadow: var(--ui-shadow-sm); */
  overflow: hidden;
  padding: 20px;
  animation: assistantsPageIn 0.5s cubic-bezier(0.16, 1, 0.3, 1) 0.05s backwards;
}

.assistants-header {
  margin-bottom: 32px;
  animation: assistantsHeaderIn 0.5s cubic-bezier(0.16, 1, 0.3, 1) 0.1s backwards;
}
.assistants-header .assistants-sub {
  font-size: 17px;
  font-weight: 500;
  color: var(--ui-text-heading);
  margin: 0;
}

.assistants-status {
  font-size: 14px;
  color: var(--ui-text-secondary);
  margin: 0 0 20px;
}
.assistants-status.error {
  color: var(--ui-text-error);
}

.agents-grid {
  display: grid;
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 24px;
}

.agent-card {
  background: var(--c-white);
  border: 1px solid var(--ui-border-card);
  border-radius: var(--border-radius);
  padding: 20px;
  display: flex;
  flex-direction: column;
  transition: transform 0.2s, box-shadow 0.2s;
  min-height: 200px;
  animation: cardPopIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) backwards;
}

.agent-card:nth-child(1) { animation-delay: 0.14s; }
.agent-card:nth-child(2) { animation-delay: 0.2s; }
.agent-card:nth-child(3) { animation-delay: 0.26s; }
.agent-card:nth-child(4) { animation-delay: 0.32s; }
.agent-card:nth-child(5) { animation-delay: 0.38s; }
.agent-card:nth-child(6) { animation-delay: 0.44s; }
.agent-card:nth-child(n + 7) { animation-delay: 0.5s; }
.agent-card:hover {
  box-shadow: var(--ui-shadow-md);
}

.agent-card-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 10px;
  gap: 10px;
}
.agent-card-header .title-wrap {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  min-width: 0;
}
.agent-card-header .title-wrap .title-bar {
  width: 4px;
  height: 20px;
  background-color: var(--c-black);
  border-radius: 2px;
  margin-top: 2px;
  flex: 0 0 auto;
}
.agent-card-header .title-wrap .title {
  font-size: 15px;
  font-weight: 600;
  color: var(--ui-text-heading);
  margin: 0;
  line-height: 1.25;
  min-width: 0;
  word-break: break-word;
}
.agent-card-header .info-icon {
  color: var(--ui-text-icon);
  font-size: 16px;
  cursor: help;
}

.agent-type-badge {
  box-sizing: border-box;
  height: 18px;
  padding: 0 10px;
  border-radius: 999px;
  display: inline-grid;
  place-items: center;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  border: 1px solid var(--c-agent-badge-surface);
  color: var(--c-agent-badge-text);
  background: var(--c-agent-badge-surface);
  flex: 0 0 auto;
}

.card-separator {
  height: 1px;
  background-color: var(--ui-border-separator);
  margin: 12px 0 16px 0;
  width: 100%;
}

.agent-card-desc {
  font-size: 14px;
  color: var(--ui-text-body);
  line-height: 1.75;
  margin: 0 0 24px 0;
  flex-grow: 1;
}

.agent-config-summary {
  margin: 0 0 12px;
  font-size: 12px;
  color: var(--ui-text-link);
  line-height: 1.4;
}

.agent-card-footer {
  text-align: center;
  margin-top: auto;
}

.configure-btn {
  background-color: var(--c-neon);
  color: var(--c-black);
  border: none;
  border-radius: 24px;
  padding: 6px 24px;
  font-family: var(--font);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: background-color 0.2s ease, transform 0.2s ease;
  outline: none;
}
.configure-btn .pi {
  font-size: 24px;
  color: var(--c-black);
  font-weight: 200;
}
.configure-btn:hover {
  background-color: var(--neon-btn-bg-hover);
  transform: translateY(-1px);
}
.configure-btn:active {
  transform: translateY(0);
}
.configure-btn:focus-visible {
  box-shadow: 0 0 0 2px var(--c-white), 0 0 0 4px var(--c-neon);
}

.no-config-inline {
  font-size: 13px;
  color: var(--ui-text-label);
}

/* Configure modal shell (Comply p-dialog: 70vw × 85vh, centered overlay) */
@keyframes configureDialogIn {
  from {
    opacity: 0;
    transform: translateY(14px) scale(0.97);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.configure-dialog-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  box-sizing: border-box;
  background: var(--ui-overlay-backdrop);
}

.configure-dialog {
  --configure-dialog-max-height: min(85vh, calc(100vh - 48px));
  display: flex;
  flex-direction: column;
  width: min(70vw, calc(100vw - 48px));
  max-width: 70vw;
  height: auto;
  max-height: var(--configure-dialog-max-height);
  background: var(--ui-surface);
  border-radius: var(--border-radius);
  box-shadow: var(--ui-shadow-dialog);
  overflow: hidden;
  box-sizing: border-box;
  font-family: var(--font);
  font-size: var(--fs-base);
  color: var(--c-black);
  transform-origin: center center;
  animation: configureDialogIn 0.38s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

@media (prefers-reduced-motion: reduce) {
  .configure-dialog {
    animation: none;
  }
}
.configure-dialog .competitor-picker {
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 0 1 auto;
  min-height: 0;
}
.configure-dialog .modal-desc {
  color: var(--text2);
  margin: 0 0 20px;
  font-size: 14px;
  width: 100%;
}
.configure-dialog .config-mode-row {
  display: flex;
  align-items: center;
  gap: 16px;
  margin: 0 0 16px;
}
.configure-dialog .mode-option {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: var(--ui-text-body);
}
.configure-dialog .mode-option input {
  margin: 0;
  accent-color: var(--ui-accent-control);
}
.configure-dialog .config-hint {
  margin: 0 0 10px;
  font-size: 14px;
  color: var(--ui-text-primary);
  font-weight: 600;
}
.configure-dialog .competitor-columns {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  width: 100%;
}
.configure-dialog .competitor-column {
  border: 1px solid var(--ui-border-column);
  border-radius: var(--border-radius);
  background: var(--ui-surface);
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.configure-dialog .competitor-list {
  border: none;
  border-radius: 0 0 8px 8px;
  background: transparent;
  width: 100%;
}
.configure-dialog .competitor-list.single-select .competitor-item input[type=radio] {
  width: 17px;
  height: 17px;
  margin-top: 1px;
  accent-color: var(--c-teal-active);
}
.configure-dialog .competitor-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 10px 14px;
  border-bottom: 1px solid var(--ui-border-list);
  cursor: pointer;
  width: 100%;
  box-sizing: border-box;
}
.configure-dialog .competitor-item:last-child {
  border-bottom: none;
}
.configure-dialog .competitor-item:hover:not(.selected):not(:has(input:checked)) {
  background: var(--ui-surface-hover);
}
.configure-dialog .competitor-item.selected,
.configure-dialog .competitor-item:has(input:checked) {
  background: var(--bg-teal-soft);
  box-shadow: inset 3px 0 0 var(--c-teal-active);
}
.configure-dialog .competitor-item.selected:hover,
.configure-dialog .competitor-item:has(input:checked):hover {
  background: var(--bg-teal-soft);
}
.configure-dialog .competitor-item input {
  margin: 2px 0 0;
  accent-color: var(--c-teal-active);
  width: 16px;
  height: 16px;
  flex: 0 0 auto;
}
.configure-dialog .competitor-item .competitor-meta {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
.configure-dialog .competitor-item .competitor-name {
  font-size: 12px;
  color: var(--ui-text-primary);
  font-weight: 600;
  line-height: 1.2;
  word-break: break-word;
}
.configure-dialog .competitor-item .competitor-domain {
  font-size: 13px;
  color: var(--ui-text-domain);
  line-height: 1.2;
  word-break: break-word;
}
.configure-dialog .competitor-group-heading {
  flex: 0 0 auto;
  background: var(--ui-surface-panel);
  color: var(--ui-text-body);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  padding: 8px 14px;
  border-top: 1px solid var(--ui-border-list);
  border-bottom: 1px solid var(--ui-border-list);
  border-radius: var(--border-radius) var(--border-radius) 0 0;
}
.configure-dialog .state-jurisdiction-column {
  width: 100%;
  flex: 0 0 auto;
}
.configure-dialog .state-jurisdiction-column .state-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));
  gap: 10px;
  padding: 12px;
  align-content: start;
}
.configure-dialog .state-jurisdiction-column .state-card {
  display: flex;
  align-items: center;
  gap: 10px;
  border: 1px solid var(--ui-border-state);
  border-radius: var(--border-radius-md);
  padding: 10px 12px;
  background: var(--ui-surface);
  cursor: pointer;
  min-height: 64px;
}
.configure-dialog .state-jurisdiction-column .state-card:hover {
  border-color: var(--ui-border-state-hover);
  background: var(--ui-surface-hover);
}
.configure-dialog .state-jurisdiction-column .state-card.selected {
  border-color: var(--c-teal-active);
  background: var(--bg-teal-soft);
}
.configure-dialog .state-jurisdiction-column .state-card input {
  margin: 0;
  width: 16px;
  height: 16px;
  accent-color: var(--c-teal-active);
  flex: 0 0 auto;
}
.configure-dialog .state-jurisdiction-column .state-card-meta {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.configure-dialog .state-jurisdiction-column .state-card-name {
  color: var(--ui-text-heading);
  font-size: 13px;
  font-weight: 600;
  line-height: 1.3;
  word-break: break-word;
}
.configure-dialog .state-jurisdiction-column .state-card-abbrev {
  color: var(--ui-text-muted);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
.configure-dialog .custom-url-box {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}
.configure-dialog .custom-url-box label {
  font-size: 14px;
  color: var(--ui-text-label);
  font-weight: 500;
}
.configure-dialog .custom-url-box input,
.configure-dialog .custom-url-box select {
  padding: 10px 12px;
  border: 1px solid var(--ui-border-input);
  border-radius: 6px;
  font-size: 14px;
  width: 100%;
  background: var(--ui-surface);
}
.configure-dialog .custom-url-box input:focus,
.configure-dialog .custom-url-box select:focus {
  outline: none;
  border-color: var(--ui-accent-control);
}
.configure-dialog .no-config-message {
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 2.5rem 1.5rem;
  text-align: center;
  font-size: 24px;
  color: var(--ui-text-label);
}

.configure-dialog .no-config-message p {
  margin: 0;
}

.configure-dialog .no-config-message-illustration {
  display: block;
  width: 360px;
  height: auto;
  max-width: 100%;
  flex-shrink: 0;
  object-fit: contain;
}
.configure-dialog .p-dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-shrink: 0;
  padding: 1.5rem 1.5rem 1rem 1.5rem;
  border-bottom: 1px solid var(--ui-border-divider);
}
.configure-dialog .p-dialog-header .p-dialog-title {
  font-size: 1.15rem;
  font-weight: 500;
  font-family: var(--font-display);
  color: var(--ui-text-heading);
  display: flex;
  align-items: center;
  gap: 8px;
}
.configure-dialog .p-dialog-content {
  flex: 0 1 auto;
  min-height: 0;
  max-height: calc(var(--configure-dialog-max-height) - 11rem);
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  overflow-x: hidden;
  overflow-y: auto;
}

/*
 * Unconfigured agent — compact empty state (not 70vw wide).
 */
.configure-dialog.configure-dialog--unconfigured {
  width: min(100%, 840px);
  max-width: 840px;
  height: auto;
  max-height: min(100vh, calc(100vh - 48px));
  overflow: hidden;
}

.configure-dialog--unconfigured .p-dialog-content {
  flex: 0 0 auto;
  min-height: unset;
  max-height: none;
  overflow: visible;
}

.configure-dialog--unconfigured .no-config-message {
  padding: 2rem 1.25rem 2.25rem;
  font-size: 18px;
}

.configure-dialog--unconfigured .no-config-message-illustration {
  width: 360px;
}

/*
 * Competitor — tall 85vh shell; full lists (no per-column scroll). Body scrolls once if needed.
 */
.configure-dialog.configure-dialog--competitor {
  height: min(85vh, calc(100vh - 48px));
  max-height: min(85vh, calc(100vh - 48px));
  overflow: hidden;
}

.configure-dialog--competitor .p-dialog-content {
  flex: 1 1 auto;
  min-height: 0;
  max-height: none;
  overflow-x: hidden;
  overflow-y: auto;
}

.configure-dialog--competitor .competitor-picker {
  flex: 0 1 auto;
  min-height: 0;
}

.configure-dialog--competitor .competitor-columns {
  flex: 0 1 auto;
  align-items: stretch;
}

.configure-dialog--competitor .competitor-column {
  min-height: 0;
}

.configure-dialog--competitor .competitor-list {
  flex: 0 0 auto;
  overflow: visible;
}

/*
 * Jurisdiction: fit the state grid — use nearly full viewport, no inner body scroll.
 */
.configure-dialog--jurisdiction {
  --configure-dialog-max-height: calc(100vh - 24px);
  height: auto;
  max-height: var(--configure-dialog-max-height);
  overflow-x: hidden;
  overflow-y: auto;
}

.configure-dialog--jurisdiction .p-dialog-content {
  flex: 0 0 auto;
  min-height: unset;
  max-height: none;
  overflow: visible;
}

.configure-dialog--jurisdiction .competitor-picker,
.configure-dialog--jurisdiction .state-jurisdiction-column {
  flex: 0 0 auto;
  min-height: unset;
}

.configure-dialog .p-dialog-footer {
  flex-shrink: 0;
  padding: 1rem 1.5rem;
  border-top: 1px solid var(--ui-border-divider);
  display: flex;
  justify-content: flex-end;
}

@media (max-width: 1280px) {
  .configure-dialog .competitor-columns {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .configure-dialog .state-jurisdiction-column .state-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (max-width: 920px) {
  .configure-dialog .competitor-columns {
    grid-template-columns: minmax(0, 1fr);
  }
  .configure-dialog .state-jurisdiction-column .state-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
.cancel-btn {
  color: var(--c-black);
  border: 1px solid var(--border2);
  border-radius: 6px;
  padding: 8px 16px;
  background: transparent;
  cursor: pointer;
  font-family: var(--font);
  font-size: 14px;
  font-weight: 500;
  transition: all 0.15s ease;
}
.cancel-btn:hover {
  background: color-mix(in srgb, var(--c-white) 92%, var(--c-black));
  border-color: color-mix(in srgb, var(--ui-border-input) 85%, var(--c-black));
}

.add-btn {
  background-color: var(--c-neon);
  color: var(--c-black);
  border: none;
  border-radius: 6px;
  padding: 8px 24px;
  margin-left: 8px;
  cursor: pointer;
  font-family: var(--font);
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s ease, transform 0.2s ease;
}
.add-btn:hover:not(:disabled) {
  background-color: var(--neon-btn-bg-hover);
  transform: translateY(-1px);
}
.add-btn:active:not(:disabled) {
  transform: translateY(0);
}
.add-btn:focus-visible {
  outline: none;
  box-shadow: 0 0 0 2px var(--c-white), 0 0 0 4px var(--c-neon);
}
.add-btn:disabled {
  background-color: var(--border);
  color: var(--text3);
  box-shadow: none;
  cursor: not-allowed;
}


/* =============================================================================
   ASSISTANTS — Researcher shell (Koby chat routes)
   Colors: var(--mi-*), var(--c-*) from tokens.css
   ============================================================================= */

@keyframes miSourcesPanelIn {
  from {
    opacity: 0;
    transform: translateX(10px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.main > .mi-page {
  flex: 1 1;
  min-height: 0;
  height: 100%;
  max-height: 100%;
}

.mi-page {
  --mi-brand: var(--c-teal-active);
  --mi-brand-hover: var(--c-teal-3);
  --mi-brand-soft: var(--bg-teal-soft);
  --mi-shell-max: 990px;
  --mi-suggestions-max: 920px;
  --mi-prompt-radius: 28px;
  --mi-prompt-pad: 1rem 1.35rem 0.85rem;
  --mi-textarea-min-h: 98px;
  --mi-title-size: 2.2rem;
  --mi-subtitle-size: 1rem;

  margin: 0 auto;
  padding: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1 1;
  height: 100%;
  min-height: 0;
  box-sizing: border-box;
  overflow: hidden;
  font-family: var(--font);
  font-size: var(--fs-base);
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Enforce primary typography across nested elements (including markdown content). */
.mi-page,
.mi-page * {
  font-family: var(--font) !important;
}

.mi-sub {
  margin: 0;
  color: var(--mi-text-badge);
  font-size: 0.95rem;
  line-height: 1.45;
}

.mi-error {
  color: var(--mi-text-error);
  margin: 0 0 0.75rem;
  font-size: 0.9rem;
}

.mi-first-screen {
  flex: 1 1;
  min-height: 0;
  width: 100%;
  /* border: 1px solid var(--mi-border); */
  background: var(--ui-surface);
  /* box-shadow: var(--mi-shadow-xs); */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  box-sizing: border-box;
  animation: assistantsPageIn 0.42s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

.mi-first-shell {
  width: min(100%, var(--mi-shell-max));
  display: flex;
  flex-direction: column;
  align-items: center;
}

.mi-first-icon {
  width: 72px;
  height: 72px;
  border-radius: 999px;
  background: var(--mi-surface-icon);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.95rem;
}

.mi-first-icon i {
  color: var(--mi-text-icon);
  font-size: 1.65rem;
}

.mi-first-title {
  margin: 0 0 0.8rem;
  font-size: var(--mi-title-size);
  line-height: 1.15;
  font-weight: 400;
  font-family: var(--font-display) !important;
  color: var(--mi-text-title);
  text-align: center;
  font-family: inherit;
  animation: assistantsHeaderIn 0.48s cubic-bezier(0.16, 1, 0.3, 1) 0.06s backwards;
}

.mi-first-subtitle {
  margin: 0 0 1.5rem;
  font-size: var(--mi-subtitle-size);
  line-height: 1.45;
  color: var(--mi-text-secondary);
  text-align: center;
  animation: assistantsPageIn 0.42s cubic-bezier(0.16, 1, 0.3, 1) 0.1s backwards;
}

.mi-prompt-shell {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid var(--mi-border-prompt);
  border-radius: var(--mi-prompt-radius);
  background: var(--mi-surface-white);
  box-shadow: var(--mi-shadow-sm);
  padding: var(--mi-prompt-pad);
  animation: cardPopIn 0.44s cubic-bezier(0.16, 1, 0.3, 1) 0.14s backwards;
}

.mi-first-textarea {
  width: 100%;
  box-sizing: border-box;
  resize: none;
  min-height: var(--mi-textarea-min-h);
  border: none;
  background: transparent;
  font-family: inherit;
  font-size: 14.5px;
  line-height: 1.5;
  color: var(--mi-text-primary);
  padding: 0;
  margin: 0;
  display: block;
}

.mi-first-textarea::placeholder {
  color: var(--mi-text-placeholder);
}

.mi-first-textarea:focus {
  outline: none;
}

.mi-prompt-toolbar {
  border-top: 1px solid var(--mi-border-toolbar);
  padding-top: 0.7rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}

.mi-toolbar-context {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 0.45rem;
  flex-wrap: wrap;
}

.mi-first-suggestions {
  width: min(100%, var(--mi-suggestions-max));
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  align-self: center;
  animation: assistantsPageIn 0.4s cubic-bezier(0.16, 1, 0.3, 1) 0.18s backwards;
}

.mi-suggestion-item {
  width: 100%;
  max-width: var(--mi-suggestions-max);
  border: 1px solid transparent;
  border-radius: 10px;
  background: transparent;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.62rem 0.35rem;
  text-align: left;
  cursor: pointer;
  font-family: inherit;
  font-size: 14px;
  color: inherit;
  appearance: none;
  animation: cardPopIn 0.38s cubic-bezier(0.16, 1, 0.3, 1) backwards;
}

.mi-suggestion-item:nth-child(1) { animation-delay: 0.22s; }
.mi-suggestion-item:nth-child(2) { animation-delay: 0.28s; }
.mi-suggestion-item:nth-child(3) { animation-delay: 0.34s; }
.mi-suggestion-item:nth-child(4) { animation-delay: 0.4s; }
.mi-suggestion-item:nth-child(5) { animation-delay: 0.46s; }
.mi-suggestion-item:nth-child(n + 6) { animation-delay: 0.52s; }

.mi-suggestion-item:hover {
  background: var(--mi-surface-suggestion-hover);
  border-color: var(--mi-border-suggestion-hover);
}

.mi-suggestion-arrow {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.38rem;
  min-width: 1.38rem;
  height: 1.38rem;
  color: var(--mi-text-stone-light);
  margin-top: 0.4rem;
}
.mi-suggestion-arrow svg {
  width: 100%;
  height: 100%;
  display: block;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
  fill: none;
}

.mi-suggestion-item:hover .mi-suggestion-arrow {
  color: var(--mi-text-stone);
}

.mi-suggestion-copy {
  min-width: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.65rem;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
}

.mi-suggestion-title {
  flex: 0 0 auto;
  font-size: 14.5px;
  line-height: 1.35;
  color: var(--mi-text-heading);
}

.mi-suggestion-subtitle {
  flex: 1 1 auto;
  font-size: 14.5px;
  line-height: 1.35;
  color: var(--mi-text-subtitle);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (max-width: 860px) {
  .mi-first-title {
    font-size: 2.25rem;
  }
  .mi-prompt-shell {
    border-radius: 20px;
    padding: 0.85rem 0.9rem 0.7rem;
  }
  .mi-first-textarea {
    min-height: 82px;
    font-size: 1rem;
  }
  .mi-prompt-toolbar {
    align-items: flex-start;
    flex-direction: column;
  }
}
.mi-context-badges {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.45rem;
}

.mi-context-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.3rem;
  border: 1px solid var(--mi-border);
  border-radius: 999px;
  background: var(--mi-surface-white);
  color: var(--mi-text-body);
  font-size: 0.8rem;
  line-height: 1.1;
  padding: 0.24rem 0.58rem;
}

.mi-context-badge-main {
  display: inline-flex;
  align-items: center;
  max-width: min(420px, 55vw);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--mi-text-primary);
}

.mi-context-badge-agent {
  border-color: transparent;
  max-width: min(360px, 46vw);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 500;
}

.mi-context-badge-emphasis {
  font-weight: 500;
}

.mi-context-dot {
  display: inline-block;
  width: 0.45rem;
  height: 0.45rem;
  border-radius: 999px;
  background: var(--c-teal-active);
  margin-right: 0;
  flex: 0 0 auto;
}

.mi-chat {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
  /* border: 1px solid var(--mi-border); */
  /* border-radius: 12px; */
  /* background: var(--mi-surface); */
  /* box-shadow: var(--mi-shadow-xs); */
  overflow: hidden;
  animation: cardPopIn 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

.mi-chat-body {
  flex: 1 1;
  min-height: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr) clamp(240px, 22vw, 320px);
  align-items: stretch;
  position: relative;
}

/* Full-height column divider (panel border-left was clipped short of the input bar) */
.mi-chat-body::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  right: clamp(240px, 22vw, 320px);
  width: 1px;
  background: var(--mi-border);
  pointer-events: none;
}

.mi-chat-main {
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.mi-messages {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  padding: 0.9rem 0.95rem;
  scroll-behavior: smooth;
}

.mi-messages-layout {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.mi-sources-panel {
  background: var(--mi-surface-white);
  display: flex;
  flex-direction: column;
  min-height: 0;
  align-self: stretch;
  animation: miSourcesPanelIn 0.38s cubic-bezier(0.16, 1, 0.3, 1) 0.08s backwards;
}

@media (prefers-reduced-motion: reduce) {
  .mi-first-screen,
  .mi-first-title,
  .mi-first-subtitle,
  .mi-prompt-shell,
  .mi-first-suggestions,
  .mi-suggestion-item,
  .mi-chat,
  .mi-sources-panel {
    animation: none;
  }
}

.mi-sources-header {
  padding: 0.9rem 0.95rem;
  border-bottom: 1px solid var(--mi-border-divider);
}

.mi-sources-header h3 {
  margin: 0;
  font-size: 1rem;
  color: var(--mi-text-primary);
  font-weight: 600;
}

.mi-sources-list {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  padding: 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
}

.mi-source-item {
  border: 1px solid var(--mi-border-source);
  border-radius: 10px;
  padding: 0.55rem 0.6rem;
  display: flex;
  align-items: flex-start;
  gap: 0.55rem;
  text-decoration: none;
  color: inherit;
  background: var(--mi-surface-white);
}

.mi-source-item:hover {
  border-color: var(--mi-border-input);
  background: var(--mi-surface-warm);
}

.mi-source-index {
  min-width: 1.1rem;
  height: 1.1rem;
  border-radius: 999px;
  background: var(--bg-teal-soft);
  border: 1px solid var(--mi-border-teal);
  color: var(--c-teal-active);
  font-size: 0.72rem;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  margin-top: 0.1rem;
}

.mi-source-host {
  flex: 1 1;
  min-width: 0;
  font-size: 0.95rem;
  font-weight: 500;
  color: var(--mi-text-source);
  line-height: 1.3;
  overflow-wrap: anywhere;
}

.mi-sources-empty {
  margin: 0;
  padding: 0.88rem;
  color: var(--mi-text-stone);
  font-size: 0.84rem;
}

.mi-bubble {
  border-radius: 10px;
  padding: 0.75rem 1rem;
  max-width: 100%;
  min-width: 0;
}

.mi-bubble.user {
  background: var(--bg-teal-soft);
  border: 1px solid var(--mi-border-teal);
  align-self: flex-end;
  max-width: 90%;
  margin-left: 0;
}

.mi-bubble.assistant {
  background: var(--mi-surface-white);
  border: 1px solid var(--mi-border);
  align-self: stretch;
  width: 100%;
  margin-right: 0;
  box-shadow: var(--mi-shadow-bubble);
}

.mi-assistant-turn {
  width: 95%;
  align-self: flex-start;
  display: flex;
  flex-direction: column;
}

.mi-assistant-turn-live {
  gap: 0.35rem;
}

.mi-role {
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--mi-text-stone);
  margin-bottom: 0.35rem;
}

.mi-assistant-head {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  margin: 0 0 0.35rem;
}

.mi-assistant-head-live {
  margin-bottom: 0.4rem;
}

.mi-assistant-avatar {
  box-sizing: border-box;
  width: 22px;
  height: 22px;
  border-radius: 6px;
  border: 1px solid var(--border-color-strong);
  background: var(--c-neon);
  color: var(--mi-avatar-text);
  display: inline-grid;
  place-items: center;
  flex-shrink: 0;
  font-size: 9px;
  font-weight: 600;
  letter-spacing: -0.04em;
  line-height: 1;
  padding-top: 1px;
}

.mi-assistant-name {
  font-size: 12px;
  line-height: 1;
  font-weight: 600;
  color: var(--mi-text-secondary);
}

.mi-user-text {
  margin: 0;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  word-break: break-word;
  font-family: inherit;
  font-size: 14.5px;
  color: var(--mi-text-primary);
}

.mi-md {
  display: block;
  width: 100%;
  font-family: var(--font) !important;
  font-size: 14.5px !important;
  line-height: 1.65;
  color: var(--mi-text-primary);
  overflow-wrap: anywhere;
  word-break: break-word;
}

.mi-md,
.mi-md p,
.mi-md li,
.mi-md td,
.mi-md th,
.mi-md blockquote,
.mi-draft-md,
.mi-draft-md p,
.mi-draft-md li,
.mi-draft-md td,
.mi-draft-md th,
.mi-draft-md blockquote {
  font-family: var(--font) !important;
  font-size: 14.5px !important;
}

.mi-md p,
.mi-draft-md p {
  margin: 0 0 0.65rem;
  line-height: 1.65;
}

.mi-md p:last-child,
.mi-draft-md p:last-child {
  margin-bottom: 0;
}

.mi-md li,
.mi-draft-md li {
  line-height: 1.65;
  margin-bottom: 0.3rem;
}

.mi-md li:last-child,
.mi-draft-md li:last-child {
  margin-bottom: 0;
}

.mi-md-spacer {
  height: 0.35rem;
}

.mi-md p strong,
.mi-md li strong,
.mi-draft-md p strong,
.mi-draft-md li strong {
  font-weight: 600;
  color: var(--mi-text-primary);
}

.mi-md p em,
.mi-md li em,
.mi-draft-md p em,
.mi-draft-md li em {
  font-style: italic;
}

.mi-md code,
.mi-draft-md code {
  font-family: var(--font) !important;
  font-size: 0.92em;
  padding: 1px 0.38em;
  border-radius: var(--border-radius-sm);
  background: var(--bar-track-bg);
}

/* Make markdown structure readable (enterprise doc style). */
.mi-md h1,
.mi-draft-md h1 {
  margin: 0.3rem 0 0.7rem;
  font-size: 1.12rem;
  line-height: 1.45;
  font-weight: 500;
  font-family: var(--font-display) !important;
  color: var(--mi-text-heading);
}

.mi-md h2,
.mi-draft-md h2 {
  margin: 0.25rem 0 0.6rem;
  font-size: 1rem;
  line-height: 1.45;
  font-weight: 700;
  font-family: var(--font-display) !important;
  color: var(--mi-text-primary);
}

.mi-md h3,
.mi-draft-md h3 {
  margin: 0.2rem 0 0.55rem;
  font-size: 0.88rem;
  line-height: 1.45;
  font-weight: 500;
  font-family: var(--font-display) !important;
  color: var(--mi-text-body-muted);
}

.mi-md ul,
.mi-md ol,
.mi-draft-md ul,
.mi-draft-md ol {
  margin: 0.45rem 0 0.65rem;
  padding-left: 1.2rem;
}

.mi-md ul li::marker,
.mi-draft-md ul li::marker {
  font-size: 1.12em;
}

.mi-md blockquote,
.mi-draft-md blockquote {
  margin: 0 0 0.7rem;
  padding: 0.25rem 0.8rem;
  border-left: var(--border-width-thick) solid var(--mi-border-strong);
  color: var(--mi-text-secondary);
  background: var(--answers-black-03);
  border-radius: 0 var(--border-radius-sm) var(--border-radius-sm) 0;
}

.mi-md-hr {
  margin: 0.9rem 0;
  border: none;
  border-top: var(--border-width) solid var(--mi-border);
}

.mi-md-table-wrap,
.mi-draft-md .mi-md-table-wrap {
  margin: 0 0 var(--space-3);
  overflow-x: auto;
  border: var(--border-width) solid var(--mi-border);
  border-radius: var(--border-radius);
}

.mi-md-table,
.mi-draft-md .mi-md-table {
  width: 100%;
  min-width: 480px;
  border-collapse: collapse;
  font-size: var(--fs-sm);
  line-height: 1.45;
}

.mi-md-table th,
.mi-md-table td,
.mi-draft-md .mi-md-table th,
.mi-draft-md .mi-md-table td {
  padding: var(--space-2) var(--space-3);
  border: var(--border-width) solid var(--mi-border);
  text-align: left;
  vertical-align: top;
  max-width: 0;
}

.mi-md-table .md-table-cell-inner,
.mi-draft-md .mi-md-table .md-table-cell-inner {
  display: block;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mi-md-table th,
.mi-draft-md .mi-md-table th {
  font-weight: 600;
  color: var(--c-black);
  background: var(--bar-track-bg);
}

.mi-md-table tbody tr:nth-child(even),
.mi-draft-md .mi-md-table tbody tr:nth-child(even) {
  background: var(--answers-black-03);
}

.mi-md-list-item {
  margin: 0 0 0.5rem;
}

.mi-typing {
  display: flex;
  align-items: flex-start;
  gap: 0;
  color: var(--mi-text-body-muted);
  font-size: 0.9rem;
  background: var(--mi-surface-typing);
  border: 1px solid var(--mi-border-source);
  border-radius: 10px;
  padding: 0.75rem 0.85rem;
}

.mi-live-wrap {
  flex: 1 1;
  min-width: 0;
}

.mi-live-loader {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  margin-bottom: 1rem;
}

.mi-live-loader-dot {
  width: 0.38rem;
  height: 0.38rem;
  border-radius: 999px;
  background: var(--mi-loader-dot);
  opacity: 0.35;
  animation: mi-loader-pulse 1s infinite ease-in-out;
}

.mi-live-loader-dot:nth-child(2) {
  animation-delay: 0.15s;
}

.mi-live-loader-dot:nth-child(3) {
  animation-delay: 0.3s;
}

@keyframes mi-loader-pulse {
  0%, 80%, 100% {
    transform: scale(0.85);
    opacity: 0.35;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}
.mi-live-title {
  display: block;
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--mi-text-stone);
  margin-bottom: 0.4rem;
  font-weight: 600;
}

.mi-live-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem 0.45rem;
  margin-bottom: 0.55rem;
}

.mi-live-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.2rem 0.45rem;
  border: 1px solid var(--mi-border);
  border-radius: 999px;
  background: var(--mi-surface-white);
  color: var(--mi-text-badge);
  font-size: 0.76rem;
  line-height: 1.2;
}

.mi-live-chip strong {
  color: var(--mi-text-primary);
  font-weight: 600;
}

.mi-live-chip-phase {
  border-width: 1px;
}

.mi-live-chip-phase.is-initializing,
.mi-live-chip-phase.is-processing {
  background: var(--mi-phase-idle-bg);
  border-color: var(--mi-border-input);
  color: var(--mi-text-body-muted);
}

.mi-live-chip-phase.is-research {
  background: var(--mi-phase-research-bg);
  border-color: var(--mi-phase-research-border);
  color: var(--mi-phase-research-text);
}

.mi-live-chip-phase.is-reading {
  background: var(--mi-phase-reading-bg);
  border-color: var(--mi-phase-reading-border);
  color: var(--mi-phase-reading-text);
}

.mi-live-chip-phase.is-analysis {
  background: var(--mi-phase-analysis-bg);
  border-color: var(--mi-phase-analysis-border);
  color: var(--mi-phase-analysis-text);
}

.mi-live-chip-phase.is-drafting {
  background: var(--mi-phase-drafting-bg);
  border-color: var(--mi-phase-drafting-border);
  color: var(--mi-phase-drafting-text);
}

.mi-live-reasoning {
  margin-bottom: 0.55rem;
}

.mi-live-reasoning-list {
  margin: 0;
  padding-left: 1rem;
  font-size: 0.83rem;
  color: var(--mi-text-body-muted);
  line-height: 1.45;
}

.mi-live-reasoning-list li {
  margin-bottom: 0.2rem;
}

.mi-live-evidence {
  margin: 0.15rem 0 0.55rem;
}

.mi-evidence-list {
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  gap: 0.4rem;
}

.mi-evidence-item {
  border: 1px solid var(--mi-border);
  background: var(--mi-surface-white);
  border-radius: 8px;
  padding: 0.4rem 0.55rem;
}

.mi-evidence-host {
  display: inline-block;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--mi-evidence-link);
  text-decoration: none;
  margin-bottom: 0.15rem;
}

.mi-evidence-host:hover {
  color: var(--mi-evidence-link-hover);
  text-decoration: underline;
}

.mi-evidence-title {
  margin: 0 0 0.12rem;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--mi-text-primary);
  line-height: 1.35;
}

.mi-evidence-snippet {
  margin: 0;
  font-size: 0.82rem;
  line-height: 1.4;
  color: var(--mi-text-body-muted);
}

.mi-live-fallback {
  margin: 0;
  color: var(--mi-text-stone-light);
  font-size: 0.85rem;
}

.mi-live-draft {
  margin-top: 0.45rem;
  padding-top: 0.55rem;
  border-top: 1px dashed var(--mi-border-dashed);
}

.mi-draft-md {
  font-size: 14.5px;
  opacity: 1;
  color: var(--mi-text-draft);
}

.mi-draft-md p,
.mi-draft-md ul,
.mi-draft-md ol {
  margin-bottom: 0.45rem;
}

/* Input docked to bottom of chat card */
.mi-input-bar {
  display: flex;
  gap: 0.75rem;
  padding: 0.875rem 1rem;
  border-top: 1px solid var(--mi-border);
  background: var(--mi-surface-white);
  flex-shrink: 0;
  box-shadow: var(--mi-shadow-input-bar);
  align-items: flex-end;
}

.mi-input-main {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.mi-input-context-badges {
  gap: 0.4rem;
}

.mi-textarea {
  width: 100%;
  resize: vertical;
  min-height: 52px;
  max-height: 160px;
  padding: 0.65rem 0.85rem;
  border-radius: 8px;
  border: 1px solid var(--mi-border-input);
  font-family: inherit;
  font-size: 14.5px;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.mi-textarea:hover:not(:disabled) {
  border-color: var(--mi-text-stone-light);
}

.mi-textarea:focus {
  outline: none;
  border-color: var(--mi-focus-accent-border);
  box-shadow: var(--mi-focus-accent-ring);
}

/* Stop — neutral outline so it reads as “cancel”, not primary action */
button.mi-stop,
.mi-stop.p-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  background: var(--mi-surface-white);
  border: 1px solid var(--mi-border-input);
  color: var(--mi-text-body-muted);
  font-weight: 600;
  font-size: 0.95rem;
  font-family: inherit;
  line-height: 1.2;
  padding: 0.65rem 1.1rem;
  border-radius: 8px;
  cursor: pointer;
  flex-shrink: 0;
}

button.mi-stop:hover:not(:disabled),
.mi-stop.p-button:hover {
  background: var(--mi-phase-idle-bg);
  border-color: var(--mi-text-stone-light);
  color: var(--mi-text-heading);
}

button.mi-stop:focus-visible,
.mi-stop.p-button:focus-visible {
  outline: none;
  box-shadow: var(--mi-focus-neutral-ring);
}

button.mi-stop:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

/* Send — teal primary (matches Assistants / Answers CTA) */
button.mi-send,
.mi-send.p-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  background: var(--mi-brand);
  border: 1px solid var(--mi-brand);
  color: var(--c-white);
  font-weight: 600;
  font-size: 0.95rem;
  font-family: inherit;
  line-height: 1.2;
  padding: 0.65rem 1.1rem;
  border-radius: 8px;
  cursor: pointer;
  flex-shrink: 0;
  white-space: nowrap;
  transition: background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
  box-shadow: var(--mi-shadow-send);
}

button.mi-send:hover:not(:disabled),
.mi-send.p-button:not(:disabled):hover {
  background: var(--mi-brand-hover);
  border-color: var(--mi-brand-hover);
  box-shadow: var(--mi-shadow-send-hover);
}

button.mi-send:focus-visible,
.mi-send.p-button:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px var(--bg-teal-soft), 0 0 0 5px var(--c-teal-active);
}

button.mi-send:disabled,
.mi-send.p-button:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.mi-send-icon,
.mi-stop-icon {
  width: 1rem;
  height: 1rem;
  flex-shrink: 0;
  display: block;
}

.mi-hint {
  color: var(--mi-text-stone);
  font-size: 0.95rem;
  margin-top: 1rem;
}

.mi-disclaimer {
  margin: 0.3rem 0 0.3rem;
  text-align: center;
  color: var(--mi-text-secondary);
  font-size: 0.82rem;
  line-height: 1.25;
  flex-shrink: 0;
}

.mi-chat-main > .mi-disclaimer {
  margin: 0;
  padding: 0.35rem 0.95rem 0.5rem;
  background: var(--mi-surface-white);
}

@media (max-width: 900px) {
  .mi-first-title {
    font-size: 1.6rem;
  }
  .mi-chat-body {
    grid-template-columns: minmax(0, 1fr);
  }
  .mi-chat-main {
    min-height: 0;
  }
  .mi-messages {
    padding: 0.9rem 0.9rem;
  }
  .mi-messages-layout {
    width: 100%;
  }
  .mi-chat-body::after {
    display: none;
  }

  .mi-sources-panel {
    border-top: 1px solid var(--mi-border);
    max-height: 220px;
  }
}
@media (max-width: 640px) {
  .mi-first-screen {
    padding: 1rem 0.75rem;
  }
  .mi-first-title {
    font-size: 1.35rem;
    margin-bottom: 0.8rem;
  }
  .mi-first-textarea {
    min-height: 104px;
    font-size: 0.92rem;
  }
  .mi-context-badge-main {
    max-width: min(88vw, 300px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/markdown.css"],"names":[],"mappings":"AAAA;;;;;;;;;;kFAUkF;;AAElF;;kFAEkF;;AAElF,kFAAkF;AAClF;;;;;EAKE,wEAAwE;EACxE,8EAA8E;EAC9E,2EAA2E;EAC3E,2EAA2E;EAC3E,2EAA2E;EAC3E,4EAA4E;EAC5E,4EAA4E;EAC5E,4EAA4E;EAC5E,4EAA4E;EAC5E,4EAA4E;EAC5E,4EAA4E;EAC5E,4EAA4E;EAC5E,4EAA4E;EAC5E,4EAA4E;EAC5E,4EAA4E;EAC5E,4EAA4E;EAC5E,yEAAyE;EACzE,sEAAsE;EACtE,sEAAsE;EACtE,uEAAuE;EACvE,uEAAuE;EACvE,uEAAuE;EACvE,uEAAuE;EACvE,yEAAyE;EACzE,yEAAyE;EACzE,yEAAyE;EACzE,yEAAyE;EACzE,yEAAyE;EACzE,yEAAyE;EACzE,sEAAsE;EACtE,yEAAyE;EACzE,sEAAsE;EACtE,yEAAyE;EACzE,sEAAsE;EACtE,sEAAsE;EACtE,uEAAuE;EACvE,uEAAuE;AACzE;;AAEA;EACE,4CAA4C;EAC5C,iCAAiC;EACjC,0BAA0B;;EAE1B,wBAAwB;EACxB,8BAA8B;EAC9B,iCAAiC;EACjC,sCAAsC;AACxC;;AAEA;;EAEE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,iCAAiC;EACjC,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;;;EAGE,uCAAuC;EACvC,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA;;EAEE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,yCAAyC;EACzC,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,qDAAqD;EACrD,mCAAmC;EACnC,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,gEAAgE;EAChE,mBAAmB;EACnB,mCAAmC;EACnC,kEAAkE;AACpE;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,yDAAyD;AAC3D;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,qDAAqD;EACrD,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;;EAEE,sCAAsC;EACtC,qDAAqD;EACrD,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;;;AAIA;;kFAEkF;;AAElF;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;EACrB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;;;;;EAKE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,sCAAsC;EACtC;;iEAE+D;EAC/D,qDAAqD;EACrD,oFAAoF;EACpF,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,qBAAqB;EACrB,gCAAgC;EAChC,gBAAgB;EAChB,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;EACtC,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;EACrB,gCAAgC;EAChC,YAAY;EACZ,sCAAsC;EACtC,eAAe;EACf,qBAAqB;EACrB,sDAAsD;EACtD,qGAAqG;AACvG;;AAEA;EACE,2BAA2B;EAC3B,qGAAqG;AACvG;;AAEA;EACE,6DAA6D;EAC7D,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,6BAA6B;EAC7B,yDAAyD;AAC3D;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,sBAAsB;EACtB,wCAAwC;EACxC,gCAAgC;EAChC,0BAA0B;EAC1B,YAAY;AACd;;AAEA;;kFAEkF;;AAElF;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,0CAA0C;EAC1C,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,0BAA0B;EAC1B,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,iFAAiF;AACnF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,8EAA8E;AAChF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,0BAA0B;EAC1B,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,+EAA+E;AACjF;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA,0EAA0E;AAC1E;EACE,WAAW;EACX,sBAAsB;EACtB,uCAAuC;EACvC,0BAA0B;EAC1B,yCAAyC;EACzC,mBAAmB;EACnB,kCAAkC;EAClC,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,wEAAwE;AAC1E;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,yCAAyC;EACzC,SAAS;EACT,UAAU;EACV,cAAc;EACd,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,8CAA8C;EAC9C,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,iBAAiB;EACjB,wDAAwD;EACxD,wCAAwC;EACxC,0BAA0B;EAC1B,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE;IACE,6BAA6B;IAC7B,2CAA2C;IAC3C,8BAA8B;EAChC;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,cAAc;EACd,yDAAyD;AAC3D;;AAEA;EACE,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,iDAAiD;EACjD,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,0BAA0B;EAC1B,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,+DAA+D;EAC/D,6BAA6B;AAC/B;;AAEA;EACE,iEAAiE;EACjE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,8EAA8E;AAChF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,eAAe;EACf,yGAAyG;EACzG,8CAA8C;EAC9C,kEAAkE;AACpE;;AAEA,wBAAwB,sBAAsB,EAAE;AAChD,wBAAwB,sBAAsB,EAAE;AAChD,wBAAwB,sBAAsB,EAAE;AAChD,4BAA4B,qBAAqB,EAAE;;AAEnD;EACE;;;;;;;;;;;IAWE,eAAe;EACjB;AACF;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+DAA+D;AACjE;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iEAAiE;AACnE;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;;AAGA;;kFAEkF;;AAElF;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,aAAa;EACb,0BAA0B;EAC1B,qBAAqB;EACrB,wBAAwB;EACxB,gBAAgB;EAChB,wEAAwE;AAC1E;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,sCAAsC;EACtC,iFAAiF;AACnF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,QAAQ;EACR,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,qCAAqC;EACrC,uEAAuE;AACzE;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,qBAAqB;EACrB,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,iEAAiE;AACnE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,mCAAmC;AACrC;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,8CAA8C;EAC9C,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,aAAa;EACb,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,8EAA8E;AAChF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,sCAAsC;EACtC,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,iEAAiE;EACjE,UAAU;EACV,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,iEAAiE;AACnE;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iEAAiE;EACjE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;EACb,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,uGAAuG;AACzG;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,gCAAgC;EAChC,mCAAmC;EACnC,+BAA+B;EAC/B,gGAAgG;AAClG;;AAEA;EACE,WAAW,qBAAqB,EAAE,YAAY,EAAE;EAChD,MAAM,sBAAsB,EAAE,UAAU,EAAE;AAC5C;;AAEA;EACE,WAAW,6BAA6B,EAAE,2CAA2C,EAAE;EACvF,MAAM,8BAA8B,EAAE,yCAAyC,EAAE;EACjF,MAAM,2BAA2B,EAAE,yCAAyC,EAAE;EAC9E,MAAM,6BAA6B,EAAE,2CAA2C,EAAE;AACpF;;AAEA;EACE,WAAW,mCAAmC,EAAE;EAChD,MAAM,oCAAoC,EAAE;EAC5C,MAAM,iCAAiC,EAAE;EACzC,MAAM,mCAAmC,EAAE;AAC7C;;AAEA;;;;EAIE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;;AAGA;;kFAEkF;;AAElF;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,qBAAqB;EACrB,wBAAwB;EACxB,yBAAyB;EACzB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;;;;;EAKE,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,sCAAsC;EACtC,0BAA0B;EAC1B,4DAA4D;AAC9D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;;;;EAIE,SAAS;EACT,qBAAqB;EACrB,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,QAAQ;EACR,wDAAwD;EACxD,kBAAkB;EAClB,0BAA0B;EAC1B,qBAAqB;EACrB,wBAAwB;EACxB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,mCAAmC;EACnC,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,6DAA6D;EAC7D,0CAA0C;EAC1C,4EAA4E;AAC9E;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,qDAAqD;EACrD,6DAA6D;EAC7D,0BAA0B;EAC1B,0FAA0F;AAC5F;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,4EAA4E;EAC5E,0BAA0B;AAC5B;;AAEA;;EAEE,oDAAoD;EACpD,6DAA6D;EAC7D,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA;EACE,0DAA0D;EAC1D,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,UAAU;EACV,WAAW;EACX,wCAAwC;EACxC,gCAAgC;EAChC,iDAAiD;AACnD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,qBAAqB;EACvB;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,8CAA8C;EAC9C,gBAAgB;EAChB,wDAAwD;EACxD,6DAA6D;EAC7D,0BAA0B;EAC1B,2FAA2F;AAC7F;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qDAAqD;EACrD,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;EACtC,mBAAmB;EACnB,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,mBAAmB;EACnB,iDAAiD;EACjD,qEAAqE;EACrE,yDAAyD;EACzD,sCAAsC;EACtC,0BAA0B;EAC1B,0FAA0F;AAC5F;;AAEA;EACE,oCAAoC;EACpC;;yGAEuG;AACzG;;AAEA;EACE,YAAY;EACZ,iDAAiD;EACjD,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gDAAgD;EAChD,6CAA6C;EAC7C,YAAY;EACZ,sCAAsC;EACtC,0BAA0B;EAC1B,qBAAqB;EACrB,eAAe;EACf,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;;EAEE,iDAAiD;EACjD,qDAAqD;EACrD,wCAAwC;EACxC,0BAA0B;EAC1B,qBAAqB;EACrB,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;;EAEE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,oDAAoD;AACtD;;AAEA;EACE,0BAA0B;EAC1B,6DAA6D;EAC7D,wDAAwD;EACxD,mLAAmL;EACnL,0BAA0B;EAC1B,qBAAqB;EACrB,qCAAqC;EACrC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;;;EAIE,qDAAqD;EACrD,6DAA6D;EAC7D,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,oCAAoC;EACpC,2FAA2F;AAC7F;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,0CAA0C;EAC1C,6EAA6E;EAC7E,4DAA4D;EAC5D,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,gCAAgC;EAChC,uBAAuB;EACvB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,wDAAwD;EACxD,wCAAwC;EACxC,0BAA0B;EAC1B,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,4EAA4E;AAC9E;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,wCAAwC;EACxC,+BAA+B;EAC/B,yDAAyD;AAC3D;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;;IAEE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,yEAAyE;EACzE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,yDAAyD;EACzD,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,yEAAyE;EACzE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB;;sBAEoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iDAAiD;EACjD,aAAa;EACb,gEAAgE;EAChE,QAAQ;EACR,uBAAuB;EACvB,qDAAqD;EACrD,sCAAsC;EACtC,0BAA0B;EAC1B,qBAAqB;EACrB,eAAe;EACf,kDAAkD;EAClD,gBAAgB;EAChB,gFAAgF;AAClF;;AAEA;EACE,oCAAoC;EACpC,0FAA0F;EAC1F,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,kEAAkE;AACpE;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;EACxC,kCAAkC;EAClC,2BAA2B;EAC3B,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mGAAmG;EACnG,yDAAyD;EACzD,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iDAAiD;EACjD,yDAAyD;EACzD,6DAA6D;EAC7D,0BAA0B;EAC1B,gFAAgF;AAClF;;AAEA;EACE,oCAAoC;EACpC,uDAAuD;AACzD;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gDAAgD;EAChD,sBAAsB;EACtB,YAAY;EACZ,sCAAsC;EACtC,gCAAgC;EAChC,qBAAqB;EACrB,eAAe;EACf,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,6EAA6E;EAC7E,4DAA4D;EAC5D,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,6CAA6C;EAC7C,6DAA6D;EAC7D,yDAAyD;EACzD,6DAA6D;EAC7D,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iEAAiE;EACjE,4DAA4D;AAC9D;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,iDAAiD;EACjD,0BAA0B;EAC1B,mCAAmC;EACnC,kCAAkC;EAClC,sBAAsB;EACtB,mCAAmC;EACnC,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,6CAA6C;EAC7C,qDAAqD;EACrD,6DAA6D;EAC7D,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,6CAA6C;EAC7C,6DAA6D;EAC7D,0DAA0D;EAC1D,sCAAsC;EACtC,4BAA4B;EAC5B,sBAAsB;EACtB,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,qDAAqD;EACrD,6DAA6D;EAC7D,0BAA0B;AAC5B;;AAEA;EACE,iDAAiD;EACjD,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,sCAAsC;EACtC,4DAA4D;EAC5D,0BAA0B;EAC1B,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,iDAAiD;EACjD,qDAAqD;EACrD,mCAAmC;EACnC,0BAA0B;EAC1B,qBAAqB;EACrB,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;EACjC,8CAA8C;EAC9C,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;EACtC,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,sCAAsC;EACtC,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,0BAA0B;EAC1B;;sEAEoE;AACtE;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,4DAA4D;EAC5D,sCAAsC;EACtC,kCAAkC;EAClC,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;EACtC,gFAAgF;AAClF;;;AAGA;EACE;IACE,2CAA2C;IAC3C,8CAA8C;EAChD;;EAEA;IACE,8CAA8C;EAChD;;EAEA;IACE,mGAAmG;EACrG;AACF;;AAEA;EACE;IACE,YAAY;IACZ,iDAAiD;IACjD,uBAAuB;IACvB,sBAAsB;IACtB,6DAA6D;EAC/D;;EAEA;IACE,WAAW;IACX,cAAc;IACd,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,8CAA8C;EAChD;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;;AAGA;;;kFAGkF;;AAElF;;EAEE,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;;EAGE,0BAA0B;EAC1B,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;;;;;EAKE,uCAAuC;EACvC,qBAAqB;EACrB,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;;EAEE,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;;EAEE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;EAGE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;;EAEE,sBAAsB;EACtB,gBAAgB;EAChB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,+CAA+C;EAC/C,mCAAmC;EACnC,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;;AAGA;;;kFAGkF;;AAElF;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,SAAO;EACP,aAAa;EACb,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;EACrB,mCAAmC;EACnC,kCAAkC;EAClC,wEAAwE;AAC1E;;AAEA;;;;;EAKE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,wCAAwC;EACxC,mCAAmC;EACnC,qCAAqC;EACrC,gBAAgB;EAChB,aAAa;EACb,8EAA8E;AAChF;;AAEA;EACE,mBAAmB;EACnB,+EAA+E;AACjF;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,uCAAuC;EACvC,mCAAmC;EACnC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,2CAA2C;EAC3C,iBAAiB;EACjB,kEAAkE;AACpE;;AAEA,2BAA2B,sBAAsB,EAAE;AACnD,2BAA2B,qBAAqB,EAAE;AAClD,2BAA2B,sBAAsB,EAAE;AACnD,2BAA2B,sBAAsB,EAAE;AACnD,2BAA2B,sBAAsB,EAAE;AACnD,2BAA2B,sBAAsB,EAAE;AACnD,+BAA+B,qBAAqB,EAAE;AACtD;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,YAAY;AACd;AACA;EACE,UAAU;EACV,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,SAAS;EACT,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,0BAA0B;EAC1B,eAAe;EACf,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,8CAA8C;EAC9C,gCAAgC;EAChC,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,4CAA4C;EAC5C,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,2DAA2D;EAC3D,aAAa;AACf;AACA;EACE,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,6DAA6D;AAC/D;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA,2EAA2E;AAC3E;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;;EAEA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,4DAA4D;EAC5D,aAAa;EACb,sBAAsB;EACtB,oCAAoC;EACpC,eAAe;EACf,YAAY;EACZ,8CAA8C;EAC9C,6BAA6B;EAC7B,mCAAmC;EACnC,mCAAmC;EACnC,gBAAgB;EAChB,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;EACrB,+BAA+B;EAC/B,yEAAyE;AAC3E;;AAEA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,SAAS;EACT,sCAAsC;AACxC;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,WAAW;AACb;AACA;EACE,yCAAyC;EACzC,mCAAmC;EACnC,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,0BAA0B;EAC1B,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,8CAA8C;EAC9C,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mCAAmC;AACrC;AACA;;EAEE,+BAA+B;EAC/B,8CAA8C;AAChD;AACA;;EAEE,+BAA+B;AACjC;AACA;EACE,eAAe;EACf,kCAAkC;EAClC,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;AACA;EACE,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,mCAAmC;EACnC,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,2CAA2C;EAC3C,8CAA8C;EAC9C,4DAA4D;AAC9D;AACA;EACE,WAAW;EACX,cAAc;AAChB;AACA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,wCAAwC;EACxC,sCAAsC;EACtC,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,0CAA0C;EAC1C,mCAAmC;AACrC;AACA;EACE,kCAAkC;EAClC,+BAA+B;AACjC;AACA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,cAAc;AAChB;AACA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;AACA;EACE,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,6BAA6B;AAC/B;AACA;;EAEE,aAAa;EACb,sCAAsC;AACxC;AACA;EACE,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,cAAc;EACd,kCAAkC;EAClC,iDAAiD;AACnD;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,cAAc;EACd,aAAa;EACb,4DAA4D;EAC5D,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE;AACF;EACE,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE;AACF;EACE,qCAAqC;EACrC,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE;AACF;EACE,iDAAiD;EACjD,YAAY;EACZ,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,8CAA8C;EAC9C,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;AACF;AACA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,gDAAgD;EAClD;AACF;AACA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,kEAAkE;EAClE,4EAA4E;AAC9E;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,2DAA2D;AAC7D;AACA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,6DAA6D;AAC/D;AACA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;;AAGA;;;kFAGkF;;AAElF;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,SAAO;EACP,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,oCAAoC;EACpC,qBAAqB;EACrB,2BAA2B;EAC3B,wBAAwB;EACxB,qCAAqC;EACrC,yBAAyB;EACzB,uBAAuB;EACvB,wBAAwB;;EAExB,cAAc;EACd,UAAU;EACV,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,gBAAgB;EAChB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA,oFAAoF;AACpF;;EAEE,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,WAAW;EACX,wCAAwC;EACxC,6BAA6B;EAC7B,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,sBAAsB;EACtB,wEAAwE;AAC1E;;AAEA;EACE,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,kCAAkC;EAClC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,2CAA2C;EAC3C,2BAA2B;EAC3B,kBAAkB;EAClB,oBAAoB;EACpB,iFAAiF;AACnF;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,8EAA8E;AAChF;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,yCAAyC;EACzC,sCAAsC;EACtC,mCAAmC;EACnC,+BAA+B;EAC/B,6BAA6B;EAC7B,wEAAwE;AAC1E;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,oCAAoC;EACpC,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;EAC7B,UAAU;EACV,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8CAA8C;EAC9C,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,2CAA2C;EAC3C,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,8EAA8E;AAChF;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,6BAA6B;EAC7B,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,cAAc;EAEd,gBAAgB;EAChB,kEAAkE;AACpE;;AAEA,mCAAmC,sBAAsB,EAAE;AAC3D,mCAAmC,sBAAsB,EAAE;AAC3D,mCAAmC,sBAAsB,EAAE;AAC3D,mCAAmC,qBAAqB,EAAE;AAC1D,mCAAmC,sBAAsB,EAAE;AAC3D,uCAAuC,sBAAsB,EAAE;;AAE/D;EACE,8CAA8C;EAC9C,+CAA+C;AACjD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;IACnB,8BAA8B;EAChC;EACA;IACE,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kCAAkC;EAClC,oBAAoB;EACpB,mCAAmC;EACnC,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,gCAAgC;EAChC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,aAAa;EACb,wCAAwC;EACxC,yBAAyB;EACzB,mCAAmC;EACnC,qCAAqC;EACrC,gBAAgB;EAChB,gEAAgE;AAClE;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,+DAA+D;EAC/D,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA,sFAAsF;AACtF;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,+EAA+E;AACjF;;AAEA;EACE;;;;;;;;IAQE,eAAe;EACjB;AACF;;AAEA;EACE,uBAAuB;EACvB,iDAAiD;AACnD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,+BAA+B;EAC/B,uCAAuC;EACvC,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,uCAAuC;EACvC,oBAAoB;EACpB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;EAClC,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4CAA4C;EAC5C,yBAAyB;EACzB,4BAA4B;EAC5B,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;EACpB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mCAAmC;EACnC,4BAA4B;EAC5B,iBAAiB;EACjB,6BAA6B;EAC7B,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;;;;;;;;;;;;EAYE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;;EAEE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;EAIE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;;;;EAIE,kBAAkB;AACpB;;AAEA;;EAEE,mCAAmC;EACnC,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA,6DAA6D;AAC7D;;EAEE,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,2CAA2C;EAC3C,6BAA6B;AAC/B;;AAEA;;EAEE,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,2CAA2C;EAC3C,6BAA6B;AAC/B;;AAEA;;EAEE,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,2CAA2C;EAC3C,gCAAgC;AAClC;;AAEA;;;;EAIE,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,uBAAuB;EACvB,oEAAoE;EACpE,+BAA+B;EAC/B,mCAAmC;EACnC,kEAAkE;AACpE;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,sDAAsD;AACxD;;AAEA;;EAEE,0BAA0B;EAC1B,gBAAgB;EAChB,kDAAkD;EAClD,mCAAmC;AACrC;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;;;;EAIE,sCAAsC;EACtC,kDAAkD;EAClD,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,MAAM;EACN,gCAAgC;EAChC,iBAAiB;EACjB,oCAAoC;EACpC,yCAAyC;EACzC,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,gCAAgC;EAChC,aAAa;EACb,kDAAkD;AACpD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,sBAAsB;IACtB,aAAa;EACf;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;EAC3B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,kCAAkC;EAClC,oBAAoB;EACpB,mCAAmC;EACnC,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,mCAAmC;EACnC,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,uCAAuC;EACvC,6CAA6C;EAC7C,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;EACtC,4CAA4C;EAC5C,mCAAmC;AACrC;;AAEA;EACE,uCAAuC;EACvC,6CAA6C;EAC7C,oCAAoC;AACtC;;AAEA;EACE,uCAAuC;EACvC,6CAA6C;EAC7C,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;EACnC,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,2BAA2B;AAC7B;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,sCAAsC;EACtC,mCAAmC;EACnC,cAAc;EACd,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,wCAAwC;EACxC,oBAAoB;EACpB,iBAAiB;EACjB,gDAAgD;AAClD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,uCAAuC;AACzC;;AAEA,uEAAuE;AACvE;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,mCAAmC;EACnC,wCAAwC;EACxC,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,mCAAmC;EACnC,wCAAwC;EACxC,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,2DAA2D;AAC3D;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,2BAA2B;EAC3B,iCAAiC;EACjC,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,oFAAoF;EACpF,iCAAiC;AACnC;;AAEA;;EAEE,iCAAiC;EACjC,mCAAmC;EACnC,uCAAuC;AACzC;;AAEA;;EAEE,aAAa;EACb,yEAAyE;AAC3E;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,qCAAqC;EACvC;EACA;IACE,aAAa;EACf;EACA;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;;EAEA;IACE,sCAAsC;IACtC,iBAAiB;EACnB;AACF;AACA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,2BAA2B;EAC7B;AACF","sourcesContent":["/* =============================================================================\n   markdown.css — Answers, Assistants, Documents\n\n   Colors: use var(--c-*), var(--ui-*), var(--doc-*), var(--mi-*) from tokens.css\n   Type:  var(--font), var(--font-display), var(--mono) from tokens.css\n   (loaded globally via index.css — no @import needed here)\n\n   Answers:     .answers-md, .welcome-*, .answers-* (local --answers-* mixes on shell)\n   Assistants:  .assistants-page, .configure-dialog, .mi-* researcher shell\n   Documents:   .markdown-content, .doc-body\n   ============================================================================= */\n\n/* =============================================================================\n   ANSWERS — Comply Answers only\n   ============================================================================= */\n\n/* Tints and neutrals derived only from tokens.css (--c-*, --c-black, --c-white) */\n.welcome-page,\n.answers-landing-page,\n.answers-copy-shell,\n.answers-copy-view,\n.answers-shell {\n  --answers-text-rich: color-mix(in srgb, var(--c-black) 88%, transparent);\n  --answers-teal-045: color-mix(in srgb, var(--c-teal-active) 4.5%, transparent);\n  --answers-teal-06: color-mix(in srgb, var(--c-teal-active) 6%, transparent);\n  --answers-teal-07: color-mix(in srgb, var(--c-teal-active) 7%, transparent);\n  --answers-teal-08: color-mix(in srgb, var(--c-teal-active) 8%, transparent);\n  --answers-teal-10: color-mix(in srgb, var(--c-teal-active) 10%, transparent);\n  --answers-teal-12: color-mix(in srgb, var(--c-teal-active) 12%, transparent);\n  --answers-teal-14: color-mix(in srgb, var(--c-teal-active) 14%, transparent);\n  --answers-teal-16: color-mix(in srgb, var(--c-teal-active) 16%, transparent);\n  --answers-teal-20: color-mix(in srgb, var(--c-teal-active) 20%, transparent);\n  --answers-teal-24: color-mix(in srgb, var(--c-teal-active) 24%, transparent);\n  --answers-teal-28: color-mix(in srgb, var(--c-teal-active) 28%, transparent);\n  --answers-teal-36: color-mix(in srgb, var(--c-teal-active) 36%, transparent);\n  --answers-teal-38: color-mix(in srgb, var(--c-teal-active) 38%, transparent);\n  --answers-teal-42: color-mix(in srgb, var(--c-teal-active) 42%, transparent);\n  --answers-teal-48: color-mix(in srgb, var(--c-teal-active) 48%, transparent);\n  --answers-blue-035: color-mix(in srgb, var(--c-blue-1) 3.5%, transparent);\n  --answers-blue-07: color-mix(in srgb, var(--c-blue-1) 7%, transparent);\n  --answers-blue-08: color-mix(in srgb, var(--c-blue-1) 8%, transparent);\n  --answers-blue-10: color-mix(in srgb, var(--c-blue-1) 10%, transparent);\n  --answers-blue-14: color-mix(in srgb, var(--c-blue-1) 14%, transparent);\n  --answers-blue-20: color-mix(in srgb, var(--c-blue-1) 20%, transparent);\n  --answers-blue-24: color-mix(in srgb, var(--c-blue-1) 24%, transparent);\n  --answers-orange-10: color-mix(in srgb, var(--c-orange) 10%, transparent);\n  --answers-orange-28: color-mix(in srgb, var(--c-orange) 28%, transparent);\n  --answers-orange-30: color-mix(in srgb, var(--c-orange) 30%, transparent);\n  --answers-black-014: color-mix(in srgb, var(--c-black) 1.4%, transparent);\n  --answers-black-018: color-mix(in srgb, var(--c-black) 1.8%, transparent);\n  --answers-black-025: color-mix(in srgb, var(--c-black) 2.5%, transparent);\n  --answers-black-03: color-mix(in srgb, var(--c-black) 3%, transparent);\n  --answers-black-035: color-mix(in srgb, var(--c-black) 3.5%, transparent);\n  --answers-black-05: color-mix(in srgb, var(--c-black) 5%, transparent);\n  --answers-black-055: color-mix(in srgb, var(--c-black) 5.5%, transparent);\n  --answers-black-06: color-mix(in srgb, var(--c-black) 6%, transparent);\n  --answers-black-08: color-mix(in srgb, var(--c-black) 8%, transparent);\n  --answers-black-12: color-mix(in srgb, var(--c-black) 12%, transparent);\n  --answers-white-92: color-mix(in srgb, var(--c-white) 92%, transparent);\n}\n\n.answers-md {\n  --answers-md-color: var(--answers-text-rich);\n  --answers-md-size: var(--fs-base);\n  --answers-md-leading: 1.58;\n\n  font-family: var(--font);\n  color: var(--answers-md-color);\n  font-size: var(--answers-md-size);\n  line-height: var(--answers-md-leading);\n}\n\n.answers-md,\n.answers-md * {\n  font-family: var(--font);\n  font-size: 15px;\n}\n\n.answers-md p {\n  margin: 0 0 var(--space-2);\n  font-size: var(--answers-md-size);\n  line-height: var(--answers-md-leading);\n  color: var(--answers-md-color);\n}\n\n.answers-md h1,\n.answers-md h2,\n.answers-md h3 {\n  margin: var(--space-4) 0 var(--space-2);\n  color: var(--c-black);\n  letter-spacing: -0.03em;\n  font-weight: 600;\n  font-size: 16px;\n}\n\n.answers-md h1 {\n  font-size: var(--fs-2xl);\n  font-weight: 500;\n  line-height: 1.3;\n  margin-bottom: var(--space-6);\n}\n\n.answers-md h2 {\n  font-size: var(--fs-md);\n  line-height: 1.2;\n}\n\n.answers-md h3 {\n  font-size: calc(var(--fs-base) + 1px);\n  line-height: 1.25;\n}\n\n.answers-md ul,\n.answers-md ol {\n  margin: 0 0 var(--space-3);\n  padding-left: var(--space-7);\n}\n\n.answers-md li {\n  margin: 0 0 var(--space-2) var(--space-4);\n  padding-left: 2px;\n}\n\n.answers-md li::marker {\n  color: var(--text3);\n}\n\n.answers-md a {\n  color: var(--c-blue-1);\n  font-weight: 600;\n  text-decoration: underline;\n  text-underline-offset: var(--space-1);\n}\n\n.answers-md a:hover {\n  color: var(--c-blue-2);\n}\n\n.answers-md strong,\n.answers-md b {\n  font-weight: 500;\n  color: var(--c-black);\n}\n\n.answers-md code {\n  font-size: 0.92em;\n  padding: 1px var(--space-2);\n  border-radius: var(--border-radius-sm);\n  background: var(--bar-track-bg);\n}\n\n.answers-md pre {\n  margin: 0 0 var(--space-3);\n  padding: var(--space-3);\n  border: var(--border-width) solid var(--border-color);\n  border-radius: var(--border-radius);\n  background: var(--answers-black-03);\n  overflow-x: auto;\n}\n\n.answers-md pre code {\n  padding: 0;\n  background: transparent;\n}\n\n.answers-md blockquote {\n  margin: 0 0 var(--space-3);\n  padding-left: var(--space-3);\n  border-left: var(--border-width-thick) solid var(--border-color);\n  color: var(--text2);\n  background: var(--answers-black-03);\n  border-radius: 0 var(--border-radius-sm) var(--border-radius-sm) 0;\n}\n\n.answers-md .answers-md-list-item {\n  margin: 0 0 var(--space-2);\n  padding-left: var(--space-2);\n}\n\n.answers-md .answers-md-citation-group {\n  margin: 0 0 var(--space-2);\n}\n\n.answers-md .answers-md-list-bullet {\n  display: inline-block;\n  margin-right: 0.4em;\n  font-size: 1.2em;\n  line-height: 1;\n  vertical-align: baseline;\n}\n\n.answers-md .answers-md-hr {\n  margin: var(--space-4) 0;\n  border: none;\n  border-top: var(--border-width) solid var(--border-color);\n}\n\n.answers-md-table-wrap {\n  margin: 0 0 var(--space-3);\n  overflow-x: auto;\n  border: var(--border-width) solid var(--border-color);\n  border-radius: var(--border-radius);\n}\n\n.answers-md-table {\n  width: 100%;\n  min-width: 480px;\n  border-collapse: collapse;\n  font-size: var(--fs-sm);\n  line-height: 1.45;\n}\n\n.answers-md-table th,\n.answers-md-table td {\n  padding: var(--space-2) var(--space-3);\n  border: var(--border-width) solid var(--border-color);\n  text-align: left;\n  vertical-align: top;\n  max-width: 0;\n}\n\n.answers-md-table .md-table-cell-inner {\n  display: block;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.answers-md-table th {\n  font-weight: 600;\n  color: var(--c-black);\n  background: var(--bar-track-bg);\n}\n\n.answers-md-table tbody tr:nth-child(even) {\n  background: var(--answers-black-03);\n}\n\n.answers-md-spacer {\n  height: var(--space-2);\n}\n\n.answers-md-citation {\n  margin: 0;\n  padding: 0;\n  border: none;\n  border-radius: 0;\n  background: none;\n  color: var(--c-teal-active);\n  cursor: pointer;\n  font: inherit;\n  font-size: inherit;\n  font-weight: inherit;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n}\n\n.answers-md-citation + .answers-md-citation {\n  margin-left: 0.35em;\n}\n\n.answers-md-citation:hover {\n  background: none;\n  color: var(--c-teal-3);\n}\n\n.answers-md-cursor {\n  display: inline-block;\n  color: var(--c-teal-active);\n  animation: answersMdBlink 1s step-end infinite;\n}\n\n@keyframes answersMdBlink {\n  50% {\n    opacity: 0;\n  }\n}\n\n\n\n/* =============================================================================\n   ANSWERS — Welcome page (/answers)\n   ============================================================================= */\n\n.welcome-page {\n  min-height: 100%;\n  background: var(--c-white);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--space-8) var(--space-6);\n  box-sizing: border-box;\n  font-family: var(--font);\n  font-size: var(--fs-base);\n  color: var(--c-black);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.welcome-page *,\n.welcome-page button,\n.welcome-page input,\n.welcome-page select,\n.welcome-page textarea {\n  font-family: var(--font);\n}\n\n.welcome-inner {\n  width: 100%;\n  max-width: 560px;\n  margin: 0 auto;\n}\n\n.welcome-main {\n  background: var(--c-white);\n  border-radius: var(--border-radius-xl);\n  box-shadow:\n    0 var(--space-2) var(--space-7) var(--answers-black-06),\n    0 var(--border-width) var(--space-2) var(--answers-black-035);\n  border: var(--border-width) solid var(--border-color);\n  padding: calc(var(--space-7) + var(--space-3)) calc(var(--space-7) + var(--space-1));\n  overflow: hidden;\n}\n\n.welcome-hero {\n  text-align: center;\n  margin-bottom: var(--space-7);\n}\n\n.hero-icon {\n  width: var(--space-10);\n  height: var(--space-10);\n  margin: 0 auto var(--space-6);\n  color: var(--c-teal-active);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.hero-icon svg {\n  width: 100%;\n  height: 100%;\n}\n\n.hero-title {\n  font-size: var(--fs-3xl);\n  font-weight: 600;\n  color: var(--c-black);\n  font-family: var(--font-display);\n  line-height: 1.3;\n  margin: 0 0 var(--space-3) 0;\n  letter-spacing: -0.02em;\n}\n\n.hero-subtitle {\n  font-size: var(--fs-md);\n  color: var(--text2);\n  line-height: 1.6;\n  margin: 0 auto var(--space-6) auto;\n  max-width: 420px;\n}\n\n.cta-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-2);\n  padding: var(--space-3) var(--space-7);\n  font-size: var(--fs-md);\n  font-weight: 600;\n  color: var(--c-white);\n  background: var(--c-teal-active);\n  border: none;\n  border-radius: var(--border-radius-md);\n  cursor: pointer;\n  text-decoration: none;\n  transition: background 0.2s ease, box-shadow 0.2s ease;\n  box-shadow: 0 var(--space-2) var(--space-2) color-mix(in srgb, var(--c-teal-active) 24%, transparent);\n}\n\n.cta-button:hover {\n  background: var(--c-teal-3);\n  box-shadow: 0 var(--space-2) var(--space-3) color-mix(in srgb, var(--c-teal-active) 28%, transparent);\n}\n\n.cta-button:focus-visible {\n  outline: var(--border-width-thick) solid var(--c-teal-active);\n  outline-offset: var(--space-2);\n}\n\n.cta-label {\n  letter-spacing: 0.01em;\n  font-size: var(--fs-2xl);\n}\n\n.cta-arrow {\n  flex-shrink: 0;\n  opacity: 0.9;\n}\n\n.welcome-features {\n  list-style: none;\n  margin: 0;\n  padding: var(--space-6) 0 0 0;\n  border-top: var(--border-width) solid var(--border-color);\n}\n\n.feature-item {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--space-3);\n  font-size: var(--fs-base);\n  color: var(--text2);\n  line-height: 1.5;\n  margin-bottom: var(--space-3);\n}\n\n.feature-item:last-child {\n  margin-bottom: 0;\n}\n\n.feature-dot {\n  flex-shrink: 0;\n  width: var(--space-2);\n  height: var(--space-2);\n  border-radius: var(--border-radius-pill);\n  background: var(--c-teal-active);\n  margin-top: var(--space-2);\n  opacity: 0.9;\n}\n\n/* =============================================================================\n   ANSWERS — Landing page (/answers/copy, answers-assitant-13-May-2026)\n   ============================================================================= */\n\n@keyframes answersFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.answers-landing-page {\n  --answers-prompt-max: 990px;\n  --answers-prompt-radius: 28px;\n  --answers-prompt-pad: 1rem 1.35rem 0.85rem;\n  --answers-textarea-min-h: 98px;\n  min-height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.landing-container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 200px 24px 32px;\n  background: var(--c-white);\n  overflow-y: auto;\n  font-family: var(--font);\n}\n\n.landing-title {\n  font-family: var(--font-display);\n  font-size: 2.2rem;\n  font-weight: 400;\n  color: var(--c-black);\n  letter-spacing: -0.3px;\n  line-height: 1.15;\n  margin: 0 0 16px;\n  text-align: center;\n  animation: assistantsHeaderIn 0.48s cubic-bezier(0.16, 1, 0.3, 1) 0.06s backwards;\n}\n\n.landing-subtitle {\n  max-width: 720px;\n  margin: 0 auto 16px;\n  font-size: 15px;\n  line-height: 1.55;\n  color: var(--text2);\n  text-align: center;\n  animation: assistantsPageIn 0.42s cubic-bezier(0.16, 1, 0.3, 1) 0.1s backwards;\n}\n\n.landing-features {\n  max-width: 560px;\n  margin: 0 auto 28px;\n  padding: 0;\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.landing-features li {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  font-size: 13px;\n  color: var(--text2);\n  line-height: 1.45;\n}\n\n.landing-feature-dot {\n  flex-shrink: 0;\n  width: 6px;\n  height: 6px;\n  margin-top: 6px;\n  border-radius: 50%;\n  background: var(--c-teal-active);\n}\n\n.landing-quick-actions {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 48px;\n}\n\n.lqa-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  background: var(--c-white);\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--c-black);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.lqa-btn:hover {\n  background: var(--answers-blue-035);\n  border-color: var(--c-blue-1);\n}\n\n.landing-search-wrapper {\n  width: 100%;\n  max-width: var(--answers-prompt-max);\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-5);\n  padding: 0 var(--space-5);\n  box-sizing: border-box;\n  animation: assistantsPageIn 0.42s cubic-bezier(0.16, 1, 0.3, 1) 0.12s backwards;\n}\n\n.lsw-top-bar {\n  display: flex;\n  gap: 16px;\n  font-size: 13px;\n  color: var(--c-black);\n}\n\n.lsw-pill-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  color: var(--c-black);\n  font-weight: 500;\n  font-family: var(--font);\n  font-size: 13px;\n}\n\n/* Match Assistants `.mi-prompt-shell` / `.mi-first-textarea` dimensions */\n.main-search-box {\n  width: 100%;\n  box-sizing: border-box;\n  margin: var(--space-7) 0 var(--space-8);\n  background: var(--c-white);\n  border: 1px solid var(--mi-border-prompt);\n  border-radius: 18px;\n  padding: var(--answers-prompt-pad);\n  display: flex;\n  flex-direction: column;\n  box-shadow: var(--mi-shadow-sm);\n  animation: cardPopIn 0.44s cubic-bezier(0.16, 1, 0.3, 1) 0.14s backwards;\n}\n\n.main-search-textarea {\n  width: 100%;\n  box-sizing: border-box;\n  background: transparent;\n  border: none;\n  resize: none;\n  min-height: var(--answers-textarea-min-h);\n  margin: 0;\n  padding: 0;\n  display: block;\n  font-family: var(--font);\n  font-size: 14.5px;\n  line-height: 1.5;\n  color: var(--mi-text-primary);\n  outline: none;\n}\n\n.main-search-textarea::placeholder {\n  color: var(--mi-text-placeholder);\n}\n\n.main-search-textarea:focus {\n  outline: none;\n}\n\n.main-search-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 0;\n  padding-top: 0.7rem;\n  border-top: 1px solid var(--mi-border-toolbar);\n  gap: 0.75rem;\n  min-width: 0;\n}\n\n.main-search-footer .msf-left {\n  flex: 1;\n  min-width: 0;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 1.4;\n}\n\n.main-search-footer .answers-scope-chips {\n  flex: 1;\n  min-width: 0;\n  justify-content: flex-start;\n}\n\n.main-search-footer button.msf-action {\n  font-size: inherit;\n  font-weight: inherit;\n  line-height: inherit;\n}\n\n/* Scope chips in search footer — typographically match Configure scope */\n.main-search-footer .answers-scope-chip {\n  min-height: 0;\n  padding: 4px 10px;\n  border: var(--border-width) solid var(--answers-teal-16);\n  border-radius: var(--border-radius-pill);\n  background: var(--c-white);\n  font-family: var(--font);\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 1.4;\n  letter-spacing: normal;\n  color: var(--text2);\n  -webkit-font-smoothing: antialiased;\n}\n\n.main-search-footer .answers-scope-chip-value {\n  font: inherit;\n  color: inherit;\n}\n\n.main-search-footer .answers-scope-chip-label {\n  font-size: inherit;\n  font-weight: inherit;\n  color: var(--text3);\n}\n\n.main-search-footer .answers-scope-chip-count {\n  font-size: inherit;\n  font-weight: 600;\n  line-height: inherit;\n  color: var(--c-teal-active);\n}\n\n@media (max-width: 860px) {\n  .answers-landing-page {\n    --answers-prompt-radius: 20px;\n    --answers-prompt-pad: 0.85rem 0.9rem 0.7rem;\n    --answers-textarea-min-h: 82px;\n  }\n\n  .main-search-textarea {\n    font-size: 1rem;\n  }\n}\n\n.msf-left {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  font-size: 13px;\n  color: var(--text2);\n  flex-wrap: wrap;\n}\n\n.msf-action {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n}\n\nbutton.msf-action {\n  flex-shrink: 0;\n  background: transparent;\n  border: none;\n  border-radius: 6px;\n  padding: 4px 8px;\n  margin: -4px -8px;\n  font: inherit;\n  color: inherit;\n  transition: color 0.15s ease, background-color 0.15s ease;\n}\n\nbutton.msf-action:hover {\n  color: var(--c-black);\n  background-color: var(--answers-teal-08);\n}\n\nbutton.msf-action:focus-visible {\n  outline: 2px solid var(--c-teal-active);\n  outline-offset: 2px;\n}\n\n.msf-divider {\n  color: var(--text3);\n  user-select: none;\n}\n\n.msf-btn-primary {\n  background: var(--c-neon);\n  color: var(--c-black);\n  border: none;\n  border-radius: 8px;\n  padding: 0 16px;\n  height: 36px;\n  font-weight: 500;\n  font-size: 12px;\n  cursor: pointer;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  font-family: var(--font);\n}\n\n.msf-btn-primary:hover:not(:disabled) {\n  background: var(--neon-btn-bg-hover);\n  color: var(--c-black);\n}\n\n.msf-btn-primary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.landing-sources-row {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 10px;\n  margin-top: 20px;\n  width: 100%;\n  max-width: 960px;\n  padding: 0 20px;\n  box-sizing: border-box;\n}\n\n.source-chip {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 12px;\n  background: var(--c-white);\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--c-black);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.answers-landing-source-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.answers-landing-source-dot--teal {\n  background: var(--c-teal-active);\n}\n\n.answers-landing-source-dot--blue {\n  background: var(--c-blue-1);\n}\n\n.source-chip:nth-child(1):hover {\n  background: var(--answers-teal-045);\n  border-color: var(--c-teal-active);\n}\n\n.source-chip:nth-child(2):hover {\n  background: var(--answers-blue-035);\n  border-color: var(--c-blue-1);\n}\n\n.source-chip:nth-child(3):hover {\n  background: color-mix(in srgb, var(--c-cyan-3) 4%, transparent);\n  border-color: var(--c-cyan-3);\n}\n\n.source-chip:nth-child(4):hover {\n  background: color-mix(in srgb, var(--c-purple-1) 4%, transparent);\n  border-color: var(--c-purple-1);\n}\n\n.recommended-section {\n  width: 100%;\n  margin-top: 0;\n  padding: 0 0 48px;\n  box-sizing: border-box;\n  animation: assistantsPageIn 0.4s cubic-bezier(0.16, 1, 0.3, 1) 0.18s backwards;\n}\n\n.rs-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.rs-title {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--text2);\n}\n\n.rs-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 16px;\n}\n\n@media (max-width: 900px) {\n  .rs-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 600px) {\n  .landing-title {\n    font-size: 1.6rem;\n  }\n\n  .rs-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.rs-card {\n  background: var(--c-white);\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  padding: 24px;\n  min-height: 80px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  cursor: pointer;\n  transition: border-color 0.2s ease, background-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;\n  box-shadow: 0 1px 2px var(--answers-black-018);\n  animation: cardPopIn 0.38s cubic-bezier(0.16, 1, 0.3, 1) backwards;\n}\n\n.rs-card:nth-child(1) { animation-delay: 0.22s; }\n.rs-card:nth-child(2) { animation-delay: 0.28s; }\n.rs-card:nth-child(3) { animation-delay: 0.34s; }\n.rs-card:nth-child(n + 4) { animation-delay: 0.4s; }\n\n@media (prefers-reduced-motion: reduce) {\n  .landing-title,\n  .landing-subtitle,\n  .landing-search-wrapper,\n  .main-search-box,\n  .recommended-section,\n  .rs-card,\n  .answers-copy-view,\n  .answers-copy-view .answers-header,\n  .answers-copy-view .ap-left,\n  .answers-copy-view .ap-right,\n  .answers-copy-view .version-card {\n    animation: none;\n  }\n}\n\nbutton.rs-card {\n  width: 100%;\n  text-align: left;\n  font: inherit;\n}\n\n.rs-card:nth-child(1) {\n  border-color: var(--c-teal-active);\n}\n\n.rs-card:nth-child(1):hover {\n  background: var(--answers-teal-045);\n}\n\n.rs-card:nth-child(2) {\n  border-color: var(--c-blue-1);\n}\n\n.rs-card:nth-child(2):hover {\n  background: var(--answers-blue-035);\n}\n\n.rs-card:nth-child(3) {\n  border-color: var(--c-cyan-3);\n}\n\n.rs-card:nth-child(3):hover {\n  background: color-mix(in srgb, var(--c-cyan-3) 4%, transparent);\n}\n\n.rs-card:nth-child(4) {\n  border-color: var(--c-purple-1);\n}\n\n.rs-card:nth-child(4):hover {\n  background: color-mix(in srgb, var(--c-purple-1) 4%, transparent);\n}\n\n.rs-card:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 4px 12px var(--answers-black-035);\n}\n\n.rs-card-title {\n  font-family: var(--font-display);\n  font-size: 16px;\n  font-weight: 500;\n  color: var(--c-black);\n  line-height: 1.4;\n}\n\n.rs-card-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 11px;\n  color: var(--text2);\n}\n\n.rs-card-meta {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.rs-card-action-icon {\n  flex-shrink: 0;\n  color: var(--text3);\n}\n\n\n/* =============================================================================\n   ANSWERS COPY — Workspace + morph (answers-assitant-13-May-2026)\n   ============================================================================= */\n\n.answers-copy-shell {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.answers-copy-view {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  background: var(--c-white);\n  color: var(--c-black);\n  font-family: var(--font);\n  overflow: hidden;\n  animation: assistantsPageIn 0.42s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n}\n\n.answers-copy-view .answers-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 20px;\n  border-bottom: 1px solid var(--border);\n  animation: assistantsHeaderIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) 0.06s backwards;\n}\n\n.answers-copy-view .ah-title-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.answers-copy-view .ah-title {\n  font-family: var(--font-display);\n  font-size: 16px;\n  font-weight: 500;\n  color: var(--c-black);\n  margin: 0;\n}\n\n.answers-copy-view .ah-left {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 0;\n}\n\n.answers-copy-view .ah-left .answers-scope-chips {\n  max-width: min(720px, 100%);\n}\n\n.answers-copy-view .ah-meta {\n  font-size: 11px;\n  color: var(--text2);\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.answers-copy-filter-summary {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 2px;\n  font-size: 12px;\n  color: var(--text2);\n  max-width: 180px;\n}\n\n.answers-copy-filter-summary span {\n  font-weight: 600;\n  color: var(--c-teal-active);\n}\n\n.answers-copy-filter-summary small {\n  font-size: 12px;\n  line-height: 1.2;\n  text-align: right;\n}\n\n.answers-copy-view .answers-references-card--copy {\n  margin-top: 12px;\n  border: none;\n  background: none;\n  border-radius: 0;\n  overflow: visible;\n}\n\n.answers-copy-view .answers-references-card--copy .answers-references-header {\n  appearance: none;\n  box-shadow: none;\n  outline: none;\n}\n\n.answers-copy-view .answers-references-card--copy .answers-references-header:focus-visible {\n  outline: 2px solid var(--c-teal-active);\n  outline-offset: 2px;\n}\n\n.answers-copy-view .answers-references-card--copy .answers-reference-grid {\n  grid-template-columns: 1fr;\n  gap: 8px;\n  padding: 8px 10px 10px;\n  max-height: 320px;\n  overflow-y: auto;\n}\n\n.ah-meta-filters-active {\n  color: var(--c-teal-active);\n  font-weight: 500;\n}\n\n.answers-copy-view .ah-right {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.answers-copy-view .answers-body {\n  display: flex;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.answers-copy-view .ap-left {\n  flex: 1;\n  min-width: 360px;\n  display: flex;\n  flex-direction: column;\n  background: var(--c-white);\n  border-right: 1px solid var(--border);\n  animation: cardPopIn 0.4s cubic-bezier(0.16, 1, 0.3, 1) 0.04s backwards;\n}\n\n.answers-copy-view .ap-left-scroll {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.answers-copy-user-bubble {\n  align-self: flex-end;\n  background: var(--c-black);\n  color: var(--c-white);\n  padding: 10px 14px;\n  border-radius: 16px 16px 2px 16px;\n  font-size: 13px;\n  max-width: 85%;\n  line-height: 1.4;\n  box-shadow: 0 2px 4px var(--answers-black-035);\n}\n\n.answers-copy-view .version-card {\n  align-self: stretch;\n  width: 100%;\n  margin-top: 0;\n  text-align: left;\n  animation: cardPopIn 0.5s cubic-bezier(0.16, 1, 0.3, 1) backwards;\n}\n\n.answers-copy-view .version-card--loading {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  color: var(--text3);\n  font-size: 13px;\n}\n\n.answers-copy-view .vc-header {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n  margin-bottom: 8px;\n}\n\n.answers-copy-view .vc-header .mi-assistant-head {\n  margin: 0;\n}\n\n.answers-copy-view .vc-response-time {\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--text3);\n  line-height: 1.2;\n}\n\n.vc-header-brand {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-weight: 600;\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.answers-copy-view .vc-time {\n  color: var(--text3);\n  font-size: 12px;\n  font-weight: 400;\n}\n\n.answers-copy-view .answers-thinking-card--copy {\n  margin-bottom: 12px;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.answers-copy-view .answers-thinking-card--copy .answers-thinking-body {\n  max-height: 280px;\n  overflow-y: auto;\n}\n\n.answers-copy-view .vc-content {\n  font-size: 13px;\n  line-height: 1.5;\n  color: var(--c-black);\n}\n\n.answers-copy-view .vc-content--loading {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.vc-content-placeholder {\n  color: var(--text3);\n  font-size: 12px;\n}\n\n.answers-copy-view .vc-footer {\n  margin-top: 12px;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.answers-copy-view .vc-footer-left {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n}\n\n.answers-copy-view .vc-metrics {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  font-size: 11px;\n  color: var(--text3);\n}\n\n.answers-copy-view .vc-metrics span {\n  font-weight: 600;\n  color: var(--c-teal-active);\n}\n\n.answers-copy-view .vc-filter-stats {\n  margin: 8px 0 0;\n  font-size: 11px;\n  line-height: 1.45;\n  color: var(--text2);\n}\n\nbutton.source-chip--btn {\n  border: none;\n  background: transparent;\n  font: inherit;\n  cursor: pointer;\n}\n\nbutton.source-chip--btn:hover {\n  border-color: var(--c-teal-active);\n}\n\n.answers-copy-view .vc-actions {\n  display: flex;\n  gap: 12px;\n  color: var(--text3);\n}\n\n.answers-copy-view .vc-action-btn {\n  cursor: pointer;\n  opacity: 0.7;\n  background: transparent;\n  border: none;\n  padding: 0;\n}\n\n.answers-copy-view .vc-action-btn:hover {\n  opacity: 1;\n  color: var(--c-black);\n}\n\n.answers-copy-query-error {\n  color: var(--c-orange);\n  font-size: 12px;\n  padding: 10px;\n  background: var(--orange-bg);\n  border-radius: 8px;\n  margin-top: 10px;\n}\n\n.answers-copy-view .ap-left-input-area {\n  padding: 12px 16px 12px 20px;\n  border-top: 1px solid var(--border);\n}\n\n.answers-copy-view .ask-box {\n  background: var(--c-white);\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  padding: 6px 12px;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 1px 4px var(--answers-black-018);\n  gap: 6px;\n}\n\n.answers-copy-view .ask-textarea {\n  background: transparent;\n  border: none;\n  resize: none;\n  font-size: 13px;\n  line-height: 1.45;\n  color: var(--c-black);\n  min-height: 36px;\n  height: 36px;\n  max-height: 120px;\n  padding: 0;\n  outline: none;\n  font-family: var(--font);\n  width: 100%;\n}\n\n.answers-copy-view .ask-textarea::placeholder {\n  color: var(--text3);\n}\n\n.answers-copy-view .ask-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 2px;\n}\n\n.answers-copy-view .ask-tb-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.answers-copy-view .ask-send-btn {\n  background: var(--c-neon);\n  color: var(--c-black);\n  border: none;\n  width: 26px;\n  height: 26px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.answers-copy-view .ask-send-btn svg {\n  color: var(--c-black);\n}\n\n.answers-copy-view .ap-right {\n  width: min(840px, 52vw);\n  flex-shrink: 0;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  background: var(--c-white);\n  animation: miSourcesPanelIn 0.38s cubic-bezier(0.16, 1, 0.3, 1) 0.1s backwards;\n}\n\n.answers-copy-view .ap-right-toolbar {\n  display: flex;\n  align-items: center;\n  height: 54px;\n  padding: 0 16px;\n  flex-shrink: 0;\n  border-bottom: 1px solid var(--border);\n  background: var(--c-white);\n  overflow-x: auto;\n}\n\n.ap-right-citations {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  flex: 1;\n  overflow-x: auto;\n}\n\n.ap-right-citations-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--c-black);\n  margin-right: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  flex-shrink: 0;\n}\n\n.ap-right-citation-tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: transparent;\n  color: var(--text2);\n  border: 1px solid var(--border);\n  border-radius: 6px;\n  padding: 6px 12px;\n  font-size: 11px;\n  font-weight: 500;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: all 0.2s;\n  font-family: var(--font);\n}\n\n.ap-right-citation-tab.is-selected {\n  background: var(--answers-teal-10);\n  color: var(--c-teal-active);\n  border-color: var(--c-teal-active);\n  font-weight: 600;\n}\n\n.ap-right-citation-score {\n  font-size: 10px;\n  font-weight: 600;\n  color: var(--c-teal-active);\n}\n\n.ap-right-citation-page {\n  opacity: 0.7;\n  font-size: 10px;\n  background: var(--answers-black-018);\n  padding: 1px 4px;\n  border-radius: 3px;\n}\n\n.answers-copy-view .ap-right-content {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  background: color-mix(in srgb, var(--c-black) 3%, var(--c-white));\n  padding: 0;\n  overflow: hidden;\n  position: relative;\n}\n\n.ap-right-pdf-frame {\n  width: 100%;\n  height: 100%;\n  border: none;\n  background: color-mix(in srgb, var(--c-black) 3%, var(--c-white));\n}\n\n.ap-right-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  color: var(--text3);\n  padding: 40px;\n}\n\n.ap-right-empty-icon {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  background: color-mix(in srgb, var(--c-black) 4%, var(--c-white));\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 16px;\n}\n\n.ap-right-empty-icon svg {\n  opacity: 0.3;\n  color: var(--c-black);\n}\n\n.ap-right-empty-title {\n  font-size: 14px;\n  color: var(--text2);\n  font-weight: 500;\n  text-align: center;\n}\n\n.ap-right-empty-sub {\n  font-size: 12px;\n  color: var(--text3);\n  margin-top: 8px;\n  text-align: center;\n  max-width: 300px;\n}\n\n.answers-copy-view .doc-h1 {\n  font-family: var(--font-display);\n  font-size: 24px;\n  font-weight: 500;\n  line-height: 1.3;\n  margin: 0 0 24px;\n  color: var(--c-black);\n}\n\n.answers-copy-view .doc-h2 {\n  font-size: 14px;\n  font-weight: 500;\n  margin: 32px 0 12px;\n  color: var(--c-black);\n}\n\n.answers-copy-view .doc-p {\n  font-size: 14px;\n  line-height: 1.6;\n  color: var(--ink-emphasis);\n  margin: 0 0 16px;\n}\n\n.doc-p--inline {\n  margin: 0;\n}\n\n.doc-li-row {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 8px;\n  padding-left: 16px;\n}\n\n.morph-ghost {\n  position: fixed;\n  z-index: 10000;\n  background: var(--c-white);\n  border: 1px solid var(--border);\n  border-radius: 16px;\n  box-shadow: 0 8px 24px var(--answers-black-08);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 28px;\n  pointer-events: none;\n  overflow: hidden;\n}\n\n.morph-ghost.animating {\n  transition: all 0.65s cubic-bezier(0.19, 1, 0.22, 1);\n}\n\n.morph-ghost-text {\n  font-size: 15px;\n  color: var(--c-black);\n  opacity: 0.9;\n}\n\n@keyframes answersSlideDownIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes answersZoomInLift {\n  from {\n    opacity: 0;\n    transform: scale(0.98) translateY(15px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n@keyframes cardPopIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px) scale(0.98);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n.animate-spin {\n  animation: spin 1s linear infinite;\n}\n\n.premium-loader-orb {\n  position: relative;\n  width: 44px;\n  height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 24px;\n}\n\n.orb-core {\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  border: 1px solid var(--c-black);\n  animation: orbPulse 1.5s cubic-bezier(0.45, 0, 0.55, 1) infinite, orbCoreColors 4s ease-in-out infinite;\n}\n\n.orb-ring {\n  position: absolute;\n  inset: 0;\n  border-radius: 50%;\n  border: 3px solid var(--c-white);\n  border-top-color: var(--c-purple-1);\n  border-right-color: transparent;\n  animation: spin 0.9s cubic-bezier(0.5, 0.1, 0.5, 0.9) infinite, orbRingColors 4s linear infinite;\n}\n\n@keyframes orbPulse {\n  0%, 100% { transform: scale(0.8); opacity: 0.8; }\n  50% { transform: scale(1.25); opacity: 1; }\n}\n\n@keyframes orbCoreColors {\n  0%, 100% { background: var(--c-purple-1); box-shadow: 0 0 12px 2px var(--glow-purple); }\n  25% { background: var(--c-aqua-mass); box-shadow: 0 0 12px 2px var(--glow-teal); }\n  50% { background: var(--c-blue-3); box-shadow: 0 0 12px 2px var(--glow-blue); }\n  75% { background: var(--c-purple-2); box-shadow: 0 0 12px 2px var(--glow-purple); }\n}\n\n@keyframes orbRingColors {\n  0%, 100% { border-top-color: var(--c-purple-1); }\n  25% { border-top-color: var(--c-aqua-mass); }\n  50% { border-top-color: var(--c-blue-3); }\n  75% { border-top-color: var(--c-purple-2); }\n}\n\n.answers-md--copy h2,\n.answers-md--copy h3,\n.answers-md--copy p,\n.answers-md--copy li {\n  font-size: inherit;\n  line-height: 1.5;\n}\n\n.answers-copy-suggestions {\n  margin-top: 12px;\n  padding-top: 10px;\n  border-top: 1px solid var(--border);\n}\n\n.answers-copy-suggestions p {\n  font-size: 11px;\n  color: var(--text2);\n  margin: 0 0 8px;\n}\n\n.answers-copy-suggestions div {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.answers-copy-suggestions button {\n  font-size: 11px;\n  padding: 4px 10px;\n  border-radius: 6px;\n  border: 1px solid var(--border);\n  background: var(--c-white);\n  cursor: pointer;\n  text-align: left;\n  justify-content: flex-start;\n}\n\n.answers-copy-source-summary {\n  flex-shrink: 0;\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--border);\n  font-size: 12px;\n}\n\n.answers-copy-source-summary h3 {\n  margin: 0 0 4px;\n  font-size: 13px;\n}\n\n.answers-copy-source-summary p {\n  margin: 0;\n  color: var(--text2);\n}\n\n.answers-copy-pdf-frame {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.answers-copy-source-text {\n  padding: 16px;\n  font-size: 13px;\n  line-height: 1.5;\n  overflow-y: auto;\n}\n\n\n/* =============================================================================\n   ANSWERS — Chat workspace (/answers/chat)\n   ============================================================================= */\n\n.answers-shell {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  background: var(--c-white);\n  color: var(--c-black);\n  font-family: var(--font);\n  font-size: var(--fs-base);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.answers-shell *,\n.answers-shell input,\n.answers-shell button,\n.answers-shell select,\n.answers-shell textarea {\n  box-sizing: border-box;\n  font-family: var(--font);\n}\n\n.answers-shell-header {\n  min-height: var(--space-10);\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  gap: calc(var(--space-3) + var(--space-2));\n  padding: var(--space-2) var(--space-6);\n  background: var(--c-white);\n  border-bottom: var(--border-width) solid var(--border-color);\n}\n\n.answers-brand-block {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2);\n  min-width: 0;\n}\n\n.answers-brand-block h1,\n.answers-empty-card h2,\n.answers-evidence-header h2,\n.answers-source-summary h3 {\n  margin: 0;\n  color: var(--c-black);\n  font-family: var(--font-display);\n  letter-spacing: -0.035em;\n}\n\n.answers-brand-block h1 {\n  font-size: var(--fs-lg);\n  line-height: 1;\n  font-weight: 600;\n}\n\n.answers-scope-chips {\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n  overflow-x: auto;\n  scrollbar-width: none;\n}\n\n.answers-scope-chips::-webkit-scrollbar {\n  display: none;\n}\n\n.answers-scope-chip {\n  min-height: var(--space-6);\n  display: inline-flex;\n  flex: 0 0 auto;\n  align-items: center;\n  gap: 7px;\n  border: var(--border-width) solid var(--answers-teal-16);\n  border-radius: 8px;\n  background: var(--c-white);\n  color: var(--c-black);\n  font-family: var(--font);\n  font-size: 12px;\n  padding: 0 var(--space-2);\n}\n\n.answers-scope-chip-label {\n  color: var(--text3);\n  font-family: var(--font);\n  font-size: inherit;\n  font-weight: inherit;\n}\n\n.answers-scope-chip-count {\n  flex-shrink: 0;\n  color: var(--c-teal-active);\n  font-size: inherit;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n}\n\n.answers-eyebrow {\n  margin: 0;\n  color: var(--text3);\n  font-size: var(--fs-xs);\n  font-weight: 600;\n  letter-spacing: 0.11em;\n  line-height: 1.2;\n  text-transform: uppercase;\n}\n\n.answers-header-actions {\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n}\n\n.answers-filter-summary {\n  min-width: 132px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 1px;\n}\n\n.answers-filter-summary span {\n  color: var(--c-black);\n  font-size: var(--fs-sm);\n  font-weight: 700;\n}\n\n.answers-filter-summary small {\n  max-width: 180px;\n  overflow: hidden;\n  color: var(--text3);\n  font-size: calc(var(--fs-sm) - 1px);\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.answers-layout {\n  flex: 1 1 auto;\n  min-height: 0;\n  display: grid;\n  grid-template-columns: minmax(680px, 1fr) minmax(360px, 30vw);\n  gap: calc(var(--space-3) + var(--space-1));\n  padding: calc(var(--space-3) + var(--space-1)) var(--space-4) var(--space-4);\n}\n\n.answers-workspace,\n.answers-evidence-panel {\n  min-height: 0;\n  overflow: hidden;\n  border: var(--border-width) solid var(--border-color);\n  border-radius: calc(var(--border-radius-xl) - var(--space-1));\n  background: var(--c-white);\n  box-shadow: 0 var(--space-4) calc(var(--space-6) + var(--space-2)) var(--answers-black-05);\n}\n\n.answers-workspace {\n  display: flex;\n  flex-direction: column;\n}\n\n.answers-scroll-area {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  padding: var(--space-6) calc(var(--space-7) - var(--space-1)) var(--space-7);\n  background: var(--c-white);\n}\n\n.answers-error-banner,\n.answers-loading-banner {\n  margin-bottom: calc(var(--space-3) + var(--space-2));\n  padding: var(--space-3) calc(var(--space-3) + var(--space-1));\n  border-radius: var(--border-radius-lg);\n  font-size: calc(var(--fs-base) - 1px);\n}\n\n.answers-error-banner {\n  border: var(--border-width) solid var(--answers-orange-30);\n  background: var(--orange-bg);\n  color: var(--c-orange);\n}\n\n.answers-loading-banner,\n.answers-loading-inline {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--space-2);\n  color: var(--text2);\n}\n\n.answers-loading-banner span,\n.answers-loading-inline span {\n  width: 7px;\n  height: 7px;\n  border-radius: var(--border-radius-pill);\n  background: var(--c-teal-active);\n  animation: answersPulse 1.2s ease-in-out infinite;\n}\n\n.answers-loading-inline span:nth-child(2) {\n  animation-delay: 0.12s;\n}\n\n.answers-loading-inline span:nth-child(3) {\n  animation-delay: 0.24s;\n}\n\n@keyframes answersPulse {\n  0%, 100% {\n    opacity: 0.35;\n    transform: scale(0.82);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(1.1);\n  }\n}\n\n.answers-empty-card {\n  position: relative;\n  max-width: 760px;\n  margin: 5vh auto 0;\n  padding: calc(var(--space-7) - var(--space-1));\n  overflow: hidden;\n  border: var(--border-width) solid var(--answers-teal-16);\n  border-radius: calc(var(--border-radius-xl) + var(--space-1));\n  background: var(--c-white);\n  box-shadow: 0 var(--space-7) calc(var(--space-8) + var(--space-2)) var(--answers-black-055);\n}\n\n.answers-empty-card h2 {\n  position: relative;\n  max-width: 560px;\n  margin-top: 7px;\n  font-size: clamp(var(--fs-2xl), 3.4vw, var(--fs-3xl));\n  line-height: 1;\n  letter-spacing: -0.045em;\n}\n\n.answers-empty-card p:not(.answers-eyebrow) {\n  position: relative;\n  max-width: 620px;\n  margin: calc(var(--space-3) + 1px) 0 0;\n  color: var(--text2);\n  font-size: calc(var(--fs-base) - 1px);\n  line-height: 1.55;\n}\n\n.answers-empty-card > .answers-scope-chips {\n  position: relative;\n  max-width: 100%;\n  margin-top: calc(var(--space-3) + var(--space-2));\n}\n\n.answers-hero-prompt {\n  position: relative;\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: var(--space-3);\n  align-items: center;\n  margin-top: calc(var(--space-3) + var(--space-2));\n  padding: 7px var(--space-2) 7px calc(var(--space-3) + var(--space-1));\n  border: var(--border-width) solid var(--answers-black-12);\n  border-radius: var(--border-radius-xl);\n  background: var(--c-white);\n  box-shadow: 0 var(--space-4) calc(var(--space-6) + var(--space-2)) var(--answers-black-05);\n}\n\n.answers-hero-prompt:focus-within {\n  border-color: var(--answers-teal-42);\n  box-shadow:\n    0 0 0 var(--space-2) var(--answers-teal-10),\n    0 calc(var(--space-4) + var(--space-2)) calc(var(--space-7) + var(--space-2)) var(--answers-black-06);\n}\n\n.answers-hero-prompt input {\n  min-width: 0;\n  min-height: calc(var(--space-8) + var(--space-2));\n  border: none;\n  outline: none;\n  background: transparent;\n  color: var(--c-black);\n  font-size: calc(var(--fs-base) - 1px);\n}\n\n.answers-hero-prompt input::placeholder {\n  color: var(--text3);\n}\n\n.answers-hero-prompt button {\n  min-width: calc(var(--space-8) + var(--space-6));\n  height: calc(var(--space-6) + var(--space-2));\n  border: none;\n  border-radius: var(--border-radius-md);\n  background: var(--c-black);\n  color: var(--c-white);\n  cursor: pointer;\n  font-size: var(--fs-sm);\n  font-weight: 800;\n}\n\n.answers-hero-prompt button:hover:not(:disabled) {\n  background: var(--c-teal-active);\n}\n\n.answers-hero-prompt button:disabled {\n  background: var(--answers-black-08);\n  color: var(--text3);\n  cursor: not-allowed;\n}\n\n.answers-empty-actions {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--space-2);\n  margin-top: calc(var(--space-3) + var(--space-2));\n}\n\n.answers-empty-actions button,\n.answers-suggestions button {\n  min-height: calc(var(--space-6) + var(--space-2));\n  border: var(--border-width) solid var(--border-color);\n  border-radius: var(--border-radius-pill);\n  background: var(--c-white);\n  color: var(--c-black);\n  cursor: pointer;\n  font-size: var(--fs-sm);\n  font-weight: 700;\n  padding: 0 calc(var(--space-3) - 1px);\n}\n\n.answers-empty-actions button:hover,\n.answers-suggestions button:hover {\n  background: var(--answers-teal-08);\n  border-color: var(--answers-teal-24);\n}\n\n.answers-turn + .answers-turn {\n  margin-top: var(--space-6);\n}\n\n.answers-question-row {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: calc(var(--space-3) + var(--space-1));\n}\n\n.answers-question-bubble {\n  max-width: min(760px, 82%);\n  padding: var(--space-3) calc(var(--space-3) + var(--space-1));\n  border: var(--border-width) solid var(--answers-teal-20);\n  border-radius: calc(var(--border-radius-md) + var(--space-1)) calc(var(--border-radius-md) + var(--space-1)) var(--border-radius-sm) calc(var(--border-radius-md) + var(--space-1));\n  background: var(--c-white);\n  color: var(--c-black);\n  font-size: calc(var(--fs-base) - 1px);\n  font-weight: 700;\n  line-height: 1.45;\n}\n\n.answers-response-grid {\n  display: grid;\n  gap: var(--space-3);\n}\n\n.answers-response-meta {\n  color: var(--text3);\n  font-size: var(--fs-sm);\n}\n\n.answers-answer-card,\n.answers-thinking-card,\n.answers-references-card,\n.answers-suggestions {\n  border: var(--border-width) solid var(--border-color);\n  border-radius: calc(var(--border-radius-md) + var(--space-1));\n  background: var(--c-white);\n}\n\n.answers-answer-card {\n  padding: 0;\n  overflow: hidden;\n  border-color: var(--answers-teal-14);\n  box-shadow: 0 var(--space-4) calc(var(--space-6) + var(--space-2)) var(--answers-black-055);\n}\n\n.answers-artifact-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: calc(var(--space-3) + var(--space-1));\n  padding: calc(var(--space-4) + 1px) var(--space-6) calc(var(--space-3) + 1px);\n  border-bottom: var(--border-width) solid var(--border-color);\n  background: var(--c-white);\n}\n\n.answers-artifact-header h2 {\n  margin: var(--space-1) 0 0;\n  color: var(--c-black);\n  font-family: var(--font-display);\n  font-size: var(--fs-xl);\n  line-height: 1.05;\n  letter-spacing: -0.035em;\n}\n\n.answers-artifact-metrics {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: var(--space-2);\n}\n\n.answers-artifact-metrics span {\n  min-height: 23px;\n  display: inline-flex;\n  align-items: center;\n  border: var(--border-width) solid var(--answers-teal-14);\n  border-radius: var(--border-radius-pill);\n  background: var(--c-white);\n  color: var(--text2);\n  font-size: var(--fs-xs);\n  font-weight: 800;\n  padding: 0 var(--space-2);\n}\n\n.answers-answer-body {\n  max-width: 900px;\n  padding: calc(var(--space-3) + var(--space-1)) var(--space-6) var(--space-6);\n}\n\n.answers-skeleton {\n  display: grid;\n  gap: var(--space-3);\n}\n\n.answers-skeleton span {\n  height: var(--fs-base);\n  border-radius: var(--border-radius-pill);\n  background: var(--bar-track-bg);\n  animation: answersSkeletonPulse 1.2s ease-in-out infinite;\n}\n\n.answers-skeleton span:nth-child(3) {\n  width: 62%;\n}\n\n@keyframes answersSkeletonPulse {\n  0%,\n  100% {\n    opacity: 0.55;\n  }\n\n  50% {\n    opacity: 1;\n  }\n}\n\n.answers-thinking-card {\n  overflow: hidden;\n  background: var(--c-white);\n}\n\n.answers-thinking-card > button {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border: none;\n  background: transparent;\n  color: var(--c-black);\n  cursor: pointer;\n  font-size: var(--fs-sm);\n  font-weight: 800;\n  padding: calc(var(--space-3) - 1px) calc(var(--space-3) + var(--space-1));\n  text-align: left;\n}\n\n.answers-thinking-card > button span:last-child {\n  color: var(--text3);\n  font-size: calc(var(--fs-sm) - 1px);\n  font-weight: 700;\n}\n\n.answers-thinking-body {\n  border-top: var(--border-width) solid var(--border-color);\n  color: var(--text2);\n  font-size: var(--fs-sm);\n  line-height: 1.55;\n  padding: calc(var(--space-3) - 1px) calc(var(--space-3) + var(--space-1));\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.answers-loading-inline em {\n  color: var(--text2);\n  font-style: normal;\n  font-size: calc(var(--fs-base) - 1px);\n}\n\n.answers-references-card {\n  padding: 0;\n  overflow: hidden;\n  border-color: var(--answers-blue-14);\n}\n\n.answers-references-header {\n  display: inline;\n  width: auto;\n  margin: 0;\n  padding: 0;\n  border: none;\n  background: none;\n  box-shadow: none;\n  appearance: none;\n  color: var(--ui-text-body);\n  font: inherit;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.4;\n  text-align: left;\n  text-decoration: none;\n  cursor: pointer;\n  outline: none;\n}\n\n.answers-references-header:hover {\n  color: var(--c-teal-3);\n  /* text-decoration: underline; */\n  /* text-underline-offset: 2px; */\n}\n\n.answers-references-body {\n  display: grid;\n  grid-template-rows: 0fr;\n  opacity: 0;\n  overflow: hidden;\n  transition:\n    grid-template-rows 0.38s cubic-bezier(0.4, 0, 0.2, 1),\n    opacity 0.28s ease;\n}\n\n.answers-references-body.is-expanded {\n  grid-template-rows: 1fr;\n  opacity: 1;\n}\n\n.answers-references-body-inner {\n  min-height: 0;\n  overflow: visible;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .answers-references-body {\n    transition: none;\n  }\n}\n\n.answers-reference-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: var(--space-2);\n  padding: var(--space-3);\n}\n\n.answers-reference-card {\n  min-height: calc(var(--space-9) + var(--space-6));\n  display: grid;\n  grid-template-columns: calc(var(--space-8) + var(--space-2)) 1fr;\n  gap: 9px;\n  align-items: flex-start;\n  border: var(--border-width) solid var(--border-color);\n  border-radius: var(--border-radius-md);\n  background: var(--c-white);\n  color: var(--c-black);\n  cursor: pointer;\n  padding: var(--space-3) calc(var(--space-3) - 1px);\n  text-align: left;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;\n}\n\n.answers-reference-card:hover {\n  border-color: var(--answers-teal-28);\n  box-shadow: 0 var(--space-3) calc(var(--space-6) - var(--space-1)) var(--answers-black-06);\n  transform: translateY(-1px);\n}\n\n.answers-reference-card.is-selected {\n  border-color: var(--answers-teal-48);\n  box-shadow: 0 var(--space-3) var(--space-6) var(--answers-teal-08);\n}\n\n.answers-reference-score {\n  width: var(--space-9);\n  height: calc(var(--space-4) + var(--space-2));\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--border-radius-pill);\n  background: var(--answers-teal-08);\n  color: var(--c-teal-active);\n  font-size: var(--fs-xs);\n  font-weight: 800;\n}\n\n.answers-reference-content {\n  min-width: 0;\n  display: grid;\n  gap: 2px;\n}\n\n.answers-reference-content strong {\n  color: var(--c-black);\n  font-size: calc(var(--fs-xs) + 1px);\n  line-height: 1.25;\n}\n\n.answers-reference-content span,\n.answers-reference-content small {\n  overflow: hidden;\n  color: var(--text2);\n  font-size: var(--fs-xs);\n  line-height: 1.3;\n  text-overflow: ellipsis;\n}\n\n.answers-suggestions {\n  padding: var(--space-3);\n}\n\n.answers-suggestions p {\n  margin: 0 0 var(--space-2);\n  color: var(--text2);\n  font-size: var(--fs-sm);\n  font-weight: 700;\n}\n\n.answers-suggestions div {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--space-2);\n}\n\n.answers-composer {\n  flex: 0 0 auto;\n  padding: var(--space-3) calc(var(--space-7) - var(--space-1)) calc(var(--space-3) + var(--space-1));\n  border-top: var(--border-width) solid var(--border-color);\n  background: var(--c-white);\n}\n\n.answers-composer-box {\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n  min-height: calc(var(--space-8) + var(--space-4));\n  border: var(--border-width) solid var(--answers-black-12);\n  border-radius: calc(var(--border-radius-md) + var(--space-1));\n  background: var(--c-white);\n  padding: var(--space-2) 7px var(--space-2) calc(var(--space-3) + var(--space-1));\n}\n\n.answers-composer-box:focus-within {\n  border-color: var(--answers-teal-36);\n  box-shadow: 0 0 0 var(--space-2) var(--answers-teal-08);\n}\n\n.answers-composer-box input {\n  flex: 1;\n  min-width: 0;\n  border: none;\n  outline: none;\n  background: transparent;\n  color: var(--c-black);\n  font-size: calc(var(--fs-base) - 1px);\n}\n\n.answers-composer-box input::placeholder {\n  color: var(--text3);\n}\n\n.answers-composer-box button {\n  min-width: calc(var(--space-8) + var(--space-6));\n  height: var(--space-8);\n  border: none;\n  border-radius: var(--border-radius-md);\n  background: var(--c-teal-active);\n  color: var(--c-white);\n  cursor: pointer;\n  font-size: var(--fs-sm);\n  font-weight: 800;\n}\n\n.answers-composer-box button:disabled {\n  background: var(--answers-black-08);\n  color: var(--text3);\n  cursor: not-allowed;\n}\n\n.answers-evidence-panel {\n  display: flex;\n  flex-direction: column;\n}\n\n.answers-evidence-header {\n  flex: 0 0 auto;\n  padding: calc(var(--space-4) - 1px) calc(var(--space-4) + 1px) var(--space-3);\n  border-bottom: var(--border-width) solid var(--border-color);\n  background: var(--c-white);\n}\n\n.answers-evidence-header h2 {\n  margin-top: var(--space-1);\n  font-size: calc(var(--fs-md) + 1px);\n  line-height: 1.05;\n}\n\n.answers-evidence-empty {\n  margin: calc(var(--space-3) + var(--space-1));\n  padding: var(--space-6) calc(var(--space-4) + var(--space-1));\n  border: var(--border-width) dashed var(--answers-blue-24);\n  border-radius: calc(var(--border-radius-md) + var(--space-1));\n  background: var(--c-white);\n  text-align: center;\n}\n\n.answers-evidence-empty h3 {\n  margin: 0 0 var(--space-2);\n  color: var(--c-black);\n  font-size: calc(var(--fs-base) - 1px);\n}\n\n.answers-evidence-empty p {\n  margin: 0 auto;\n  max-width: 320px;\n  color: var(--text2);\n  font-size: var(--fs-sm);\n  line-height: 1.55;\n}\n\n.answers-source-summary {\n  flex: 0 0 auto;\n  padding: calc(var(--space-3) + 1px) var(--space-4) var(--space-3);\n  border-bottom: var(--border-width) solid var(--border-color);\n}\n\n.answers-source-summary h3 {\n  font-size: calc(var(--fs-base) + 1px);\n  line-height: 1.15;\n}\n\n.answers-source-summary p {\n  margin: 7px 0 0;\n  color: var(--text2);\n  font-size: calc(var(--fs-sm) - 1px);\n  line-height: 1.35;\n}\n\n.answers-source-summary a {\n  width: fit-content;\n  display: inline-flex;\n  align-items: center;\n  min-height: calc(var(--space-6) + var(--space-2));\n  margin-top: var(--space-2);\n  border-radius: var(--border-radius);\n  background: var(--answers-blue-08);\n  color: var(--c-blue-1);\n  font-size: calc(var(--fs-sm) - 1px);\n  font-weight: 800;\n  padding: 0 var(--space-3);\n  text-decoration: none;\n}\n\n.answers-source-summary a:hover {\n  color: var(--c-blue-2);\n}\n\n.answers-pdf-frame {\n  flex: 1 1 auto;\n  min-height: 0;\n  padding: var(--space-3);\n}\n\n.answers-source-text {\n  flex: 1 1 auto;\n  overflow: auto;\n  margin: calc(var(--space-3) + var(--space-1));\n  border: var(--border-width) solid var(--border-color);\n  border-radius: calc(var(--border-radius-md) + var(--space-1));\n  color: var(--text2);\n  font-size: calc(var(--fs-base) - 1px);\n  line-height: 1.6;\n  padding: var(--space-4);\n  white-space: pre-wrap;\n}\n\n.context-pdf-error {\n  margin: calc(var(--space-3) + var(--space-1));\n  padding: var(--space-3) calc(var(--space-3) + var(--space-1));\n  border: var(--border-width) solid var(--answers-orange-28);\n  border-radius: var(--border-radius-lg);\n  background: var(--orange-bg);\n  color: var(--c-orange);\n  font-size: calc(var(--fs-base) - 1px);\n  line-height: 1.45;\n}\n\n.pdfjs-viewer {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  border: var(--border-width) solid var(--border-color);\n  border-radius: calc(var(--border-radius-md) + var(--space-1));\n  background: var(--c-white);\n}\n\n.pdfjs-toolbar {\n  min-height: calc(var(--space-8) + var(--space-2));\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  padding: var(--space-2) var(--space-3);\n  border-bottom: var(--border-width) solid var(--border-color);\n  background: var(--c-white);\n  color: var(--text2);\n  font-size: var(--fs-sm);\n  flex-wrap: wrap;\n}\n\n.pdfjs-toolbar button {\n  min-height: calc(var(--space-6) + var(--space-1));\n  border: var(--border-width) solid var(--border-color);\n  border-radius: var(--border-radius);\n  background: var(--c-white);\n  color: var(--c-black);\n  cursor: pointer;\n  font-size: var(--fs-sm);\n  font-weight: 800;\n  padding: var(--space-1) var(--space-2);\n}\n\n.pdfjs-toolbar button:hover:not(:disabled) {\n  background: var(--answers-teal-08);\n}\n\n.pdfjs-toolbar button:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.pdfjs-scroll {\n  flex: 1 1 auto;\n  min-height: 0;\n  position: relative;\n  overflow-x: auto;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  padding: calc(var(--space-3) + var(--space-1));\n  background: var(--answers-surface-muted, #f4f5f7);\n}\n\n.pdfjs-scroll--loading .pdfjs-page {\n  visibility: hidden;\n  pointer-events: none;\n}\n\n.pdfjs-loading-panel {\n  position: absolute;\n  inset: 0;\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-3);\n  padding: var(--space-6) var(--space-4);\n  text-align: center;\n  background: var(--answers-surface-muted, #f4f5f7);\n}\n\n.pdfjs-loading-panel--page {\n  background: rgba(244, 245, 247, 0.92);\n}\n\n.pdfjs-loading-spinner {\n  width: 36px;\n  height: 36px;\n  border: 3px solid var(--border-color);\n  border-top-color: var(--c-teal-active);\n  border-radius: 50%;\n  animation: pdfjsSpin 0.85s linear infinite;\n}\n\n.pdfjs-loading-title {\n  margin: 0;\n  color: var(--text1);\n  font-size: var(--fs-base);\n  font-weight: 600;\n}\n\n.pdfjs-loading-meta {\n  margin: 0;\n  color: var(--text2);\n  font-size: var(--fs-sm);\n}\n\n.pdfjs-loading-hint {\n  margin: 0;\n  max-width: 28rem;\n  color: var(--text2);\n  font-size: var(--fs-sm);\n  line-height: 1.45;\n}\n\n@keyframes pdfjsSpin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.pdfjs-page {\n  position: relative;\n  margin: 0 auto;\n  background: var(--c-white);\n  box-shadow:\n    0 var(--space-2) var(--space-3) var(--answers-black-12),\n    0 calc(-1 * var(--space-2)) var(--space-3) var(--answers-black-12);\n}\n\n.pdfjs-page canvas {\n  display: block;\n}\n\n.pdfjs-text-layer {\n  position: absolute;\n  inset: 0;\n  overflow: hidden;\n  line-height: 1;\n  opacity: 1;\n}\n\n.pdfjs-text-layer span {\n  position: absolute;\n  color: transparent;\n  pointer-events: none;\n  transform-origin: 0 0;\n  white-space: pre;\n}\n\n.citation-highlight {\n  position: absolute;\n  z-index: 3;\n  border: var(--border-width-thick) solid var(--c-teal-active);\n  border-radius: var(--border-radius-sm);\n  background: var(--answers-teal-14);\n  box-sizing: border-box;\n  pointer-events: none;\n}\n\n.pdfjs-text-layer .citation-highlight-text {\n  border-radius: var(--border-radius-sm);\n  background: color-mix(in srgb, var(--c-teal-active) 22%, transparent) !important;\n}\n\n\n@media (max-width: 1180px) {\n  .answers-layout {\n    grid-template-columns: minmax(0, 1fr) 350px;\n    padding: calc(var(--space-3) + var(--space-1));\n  }\n\n  .answers-scroll-area {\n    padding: calc(var(--space-6) - var(--space-1));\n  }\n\n  .answers-composer {\n    padding: var(--space-3) calc(var(--space-6) - var(--space-1)) calc(var(--space-3) + var(--space-1));\n  }\n}\n\n@media (max-width: 980px) {\n  .answers-shell-header {\n    height: auto;\n    min-height: calc(var(--space-8) + var(--space-7));\n    align-items: flex-start;\n    flex-direction: column;\n    padding: calc(var(--space-3) + var(--space-1)) var(--space-4);\n  }\n\n  .answers-header-actions {\n    width: 100%;\n    margin-left: 0;\n    justify-content: flex-end;\n    flex-wrap: wrap;\n  }\n\n  .answers-filter-summary {\n    align-items: flex-start;\n    margin-right: auto;\n  }\n\n  .answers-layout {\n    grid-template-columns: 1fr;\n    overflow-y: auto;\n  }\n\n  .answers-workspace,\n  .answers-evidence-panel {\n    min-height: 560px;\n  }\n\n  .answers-evidence-panel {\n    max-height: 620px;\n  }\n}\n\n@media (max-width: 640px) {\n  .answers-scroll-area {\n    padding: var(--space-5);\n  }\n\n  .answers-answer-card {\n    padding: 0;\n  }\n\n  .answers-empty-card {\n    padding: calc(var(--space-6) - var(--space-1));\n  }\n\n  .answers-empty-card h2 {\n    font-size: calc(var(--fs-2xl) + 2px);\n  }\n\n  .answers-reference-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .filters-details-drawer .rag-date-range-row {\n    grid-template-columns: 1fr;\n  }\n}\n\n\n/* =============================================================================\n   DOCUMENTS — filings / exports (not Answers or Assistants)\n   Colors: var(--doc-*), var(--c-*) from tokens.css\n   ============================================================================= */\n\n.markdown-content,\n.doc-body {\n  color: var(--doc-text);\n  font-size: var(--fs-base);\n  line-height: 1.58;\n}\n\n.markdown-content p,\n.doc-body p,\n.doc-p {\n  margin: 0 0 var(--space-2);\n  font-size: var(--fs-base);\n  line-height: 1.58;\n  color: var(--doc-text);\n}\n\n.markdown-content h1,\n.markdown-content h2,\n.markdown-content h3,\n.doc-h1,\n.doc-h2 {\n  margin: var(--space-4) 0 var(--space-2);\n  color: var(--c-black);\n  font-family: var(--font-display);\n  letter-spacing: -0.03em;\n}\n\n.markdown-content h1,\n.doc-h1 {\n  font-size: var(--fs-2xl);\n  font-weight: 500;\n  line-height: 1.3;\n  margin-bottom: var(--space-6);\n}\n\n.markdown-content h2,\n.doc-h2 {\n  font-size: 17px;\n  line-height: 1.2;\n}\n\n.markdown-content h3 {\n  font-size: 15px;\n  line-height: 1.25;\n}\n\n.markdown-content ul,\n.markdown-content ol,\n.doc-ol {\n  margin: 0 0 var(--space-3);\n  padding-left: 18px;\n}\n\n.markdown-content li {\n  margin: 0 0 6px 20px;\n  padding-left: 2px;\n}\n\n.markdown-content a,\n.doc-body a {\n  color: var(--c-blue-1);\n  font-weight: 600;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n}\n\n.markdown-content a:hover {\n  color: var(--c-blue-2);\n}\n\n.markdown-content strong,\n.markdown-content b {\n  font-weight: 600;\n  color: var(--c-black);\n}\n\n.markdown-content code {\n  font-family: var(--mono);\n  font-size: 0.92em;\n  padding: 1px 5px;\n  border-radius: var(--border-radius-sm);\n  background: var(--doc-code-bg);\n}\n\n.markdown-content pre {\n  margin: 0 0 var(--space-3);\n  padding: var(--space-3);\n  border: var(--border-width) solid var(--border);\n  border-radius: var(--border-radius);\n  background: var(--doc-pre-bg);\n  overflow-x: auto;\n}\n\n.markdown-content pre code {\n  padding: 0;\n  background: transparent;\n}\n\n.markdown-content blockquote {\n  margin: 0 0 var(--space-3);\n  padding-left: var(--space-3);\n  border-left: 3px solid var(--border);\n  color: var(--text2);\n}\n\n.markdown-spacer {\n  height: 10px;\n}\n\n.doc-sup {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 9px;\n  background: var(--border);\n  color: var(--text3);\n  width: 14px;\n  height: 14px;\n  border-radius: var(--border-radius-sm);\n  margin-left: 3px;\n  vertical-align: top;\n}\n\n.doc-li-title {\n  font-weight: 500;\n  margin-bottom: var(--space-1);\n}\n\n\n/* =============================================================================\n   ASSISTANTS — Pre-built Assistants landing (/assistants)\n   Colors: var(--ui-*), var(--c-*) from tokens.css (via index.css)\n   ============================================================================= */\n\n@keyframes assistantsPageIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes assistantsHeaderIn {\n  from {\n    opacity: 0;\n    transform: translateY(-12px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.assistants-page {\n  box-sizing: border-box;\n  width: 100%;\n  min-width: 0;\n  flex: 1;\n  padding: 20px;\n  max-width: 100%;\n  margin: 0 auto;\n  overflow-x: auto;\n  overflow-y: auto;\n  font-family: var(--font);\n  font-size: var(--fs-base);\n  color: var(--c-black);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  animation: assistantsPageIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n}\n\n.assistants-page *,\n.assistants-page button,\n.assistants-page input,\n.assistants-page select,\n.assistants-page textarea {\n  font-family: var(--font);\n}\n\n.assistants-surface {\n  box-sizing: border-box;\n  width: 100%;\n  min-width: 0;\n  background: var(--ui-surface);\n  border: 1px solid var(--ui-border-shell);\n  border-radius: var(--border-radius);\n  /* box-shadow: var(--ui-shadow-sm); */\n  overflow: hidden;\n  padding: 20px;\n  animation: assistantsPageIn 0.5s cubic-bezier(0.16, 1, 0.3, 1) 0.05s backwards;\n}\n\n.assistants-header {\n  margin-bottom: 32px;\n  animation: assistantsHeaderIn 0.5s cubic-bezier(0.16, 1, 0.3, 1) 0.1s backwards;\n}\n.assistants-header .assistants-sub {\n  font-size: 17px;\n  font-weight: 500;\n  color: var(--ui-text-heading);\n  margin: 0;\n}\n\n.assistants-status {\n  font-size: 14px;\n  color: var(--ui-text-secondary);\n  margin: 0 0 20px;\n}\n.assistants-status.error {\n  color: var(--ui-text-error);\n}\n\n.agents-grid {\n  display: grid;\n  box-sizing: border-box;\n  width: 100%;\n  min-width: 0;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 24px;\n}\n\n.agent-card {\n  background: var(--c-white);\n  border: 1px solid var(--ui-border-card);\n  border-radius: var(--border-radius);\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  transition: transform 0.2s, box-shadow 0.2s;\n  min-height: 200px;\n  animation: cardPopIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) backwards;\n}\n\n.agent-card:nth-child(1) { animation-delay: 0.14s; }\n.agent-card:nth-child(2) { animation-delay: 0.2s; }\n.agent-card:nth-child(3) { animation-delay: 0.26s; }\n.agent-card:nth-child(4) { animation-delay: 0.32s; }\n.agent-card:nth-child(5) { animation-delay: 0.38s; }\n.agent-card:nth-child(6) { animation-delay: 0.44s; }\n.agent-card:nth-child(n + 7) { animation-delay: 0.5s; }\n.agent-card:hover {\n  box-shadow: var(--ui-shadow-md);\n}\n\n.agent-card-header {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  margin-bottom: 10px;\n  gap: 10px;\n}\n.agent-card-header .title-wrap {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  width: 100%;\n  min-width: 0;\n}\n.agent-card-header .title-wrap .title-bar {\n  width: 4px;\n  height: 20px;\n  background-color: var(--c-black);\n  border-radius: 2px;\n  margin-top: 2px;\n  flex: 0 0 auto;\n}\n.agent-card-header .title-wrap .title {\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--ui-text-heading);\n  margin: 0;\n  line-height: 1.25;\n  min-width: 0;\n  word-break: break-word;\n}\n.agent-card-header .info-icon {\n  color: var(--ui-text-icon);\n  font-size: 16px;\n  cursor: help;\n}\n\n.agent-type-badge {\n  box-sizing: border-box;\n  height: 18px;\n  padding: 0 10px;\n  border-radius: 999px;\n  display: inline-grid;\n  place-items: center;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1;\n  white-space: nowrap;\n  border: 1px solid var(--c-agent-badge-surface);\n  color: var(--c-agent-badge-text);\n  background: var(--c-agent-badge-surface);\n  flex: 0 0 auto;\n}\n\n.card-separator {\n  height: 1px;\n  background-color: var(--ui-border-separator);\n  margin: 12px 0 16px 0;\n  width: 100%;\n}\n\n.agent-card-desc {\n  font-size: 14px;\n  color: var(--ui-text-body);\n  line-height: 1.75;\n  margin: 0 0 24px 0;\n  flex-grow: 1;\n}\n\n.agent-config-summary {\n  margin: 0 0 12px;\n  font-size: 12px;\n  color: var(--ui-text-link);\n  line-height: 1.4;\n}\n\n.agent-card-footer {\n  text-align: center;\n  margin-top: auto;\n}\n\n.configure-btn {\n  background-color: var(--c-neon);\n  color: var(--c-black);\n  border: none;\n  border-radius: 24px;\n  padding: 6px 24px;\n  font-family: var(--font);\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  transition: background-color 0.2s ease, transform 0.2s ease;\n  outline: none;\n}\n.configure-btn .pi {\n  font-size: 24px;\n  color: var(--c-black);\n  font-weight: 200;\n}\n.configure-btn:hover {\n  background-color: var(--neon-btn-bg-hover);\n  transform: translateY(-1px);\n}\n.configure-btn:active {\n  transform: translateY(0);\n}\n.configure-btn:focus-visible {\n  box-shadow: 0 0 0 2px var(--c-white), 0 0 0 4px var(--c-neon);\n}\n\n.no-config-inline {\n  font-size: 13px;\n  color: var(--ui-text-label);\n}\n\n/* Configure modal shell (Comply p-dialog: 70vw × 85vh, centered overlay) */\n@keyframes configureDialogIn {\n  from {\n    opacity: 0;\n    transform: translateY(14px) scale(0.97);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.configure-dialog-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1100;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  box-sizing: border-box;\n  background: var(--ui-overlay-backdrop);\n}\n\n.configure-dialog {\n  --configure-dialog-max-height: min(85vh, calc(100vh - 48px));\n  display: flex;\n  flex-direction: column;\n  width: min(70vw, calc(100vw - 48px));\n  max-width: 70vw;\n  height: auto;\n  max-height: var(--configure-dialog-max-height);\n  background: var(--ui-surface);\n  border-radius: var(--border-radius);\n  box-shadow: var(--ui-shadow-dialog);\n  overflow: hidden;\n  box-sizing: border-box;\n  font-family: var(--font);\n  font-size: var(--fs-base);\n  color: var(--c-black);\n  transform-origin: center center;\n  animation: configureDialogIn 0.38s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .configure-dialog {\n    animation: none;\n  }\n}\n.configure-dialog .competitor-picker {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  flex: 0 1 auto;\n  min-height: 0;\n}\n.configure-dialog .modal-desc {\n  color: var(--text2);\n  margin: 0 0 20px;\n  font-size: 14px;\n  width: 100%;\n}\n.configure-dialog .config-mode-row {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin: 0 0 16px;\n}\n.configure-dialog .mode-option {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  color: var(--ui-text-body);\n}\n.configure-dialog .mode-option input {\n  margin: 0;\n  accent-color: var(--ui-accent-control);\n}\n.configure-dialog .config-hint {\n  margin: 0 0 10px;\n  font-size: 14px;\n  color: var(--ui-text-primary);\n  font-weight: 600;\n}\n.configure-dialog .competitor-columns {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n  width: 100%;\n}\n.configure-dialog .competitor-column {\n  border: 1px solid var(--ui-border-column);\n  border-radius: var(--border-radius);\n  background: var(--ui-surface);\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n.configure-dialog .competitor-list {\n  border: none;\n  border-radius: 0 0 8px 8px;\n  background: transparent;\n  width: 100%;\n}\n.configure-dialog .competitor-list.single-select .competitor-item input[type=radio] {\n  width: 17px;\n  height: 17px;\n  margin-top: 1px;\n  accent-color: var(--c-teal-active);\n}\n.configure-dialog .competitor-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 10px 14px;\n  border-bottom: 1px solid var(--ui-border-list);\n  cursor: pointer;\n  width: 100%;\n  box-sizing: border-box;\n}\n.configure-dialog .competitor-item:last-child {\n  border-bottom: none;\n}\n.configure-dialog .competitor-item:hover:not(.selected):not(:has(input:checked)) {\n  background: var(--ui-surface-hover);\n}\n.configure-dialog .competitor-item.selected,\n.configure-dialog .competitor-item:has(input:checked) {\n  background: var(--bg-teal-soft);\n  box-shadow: inset 3px 0 0 var(--c-teal-active);\n}\n.configure-dialog .competitor-item.selected:hover,\n.configure-dialog .competitor-item:has(input:checked):hover {\n  background: var(--bg-teal-soft);\n}\n.configure-dialog .competitor-item input {\n  margin: 2px 0 0;\n  accent-color: var(--c-teal-active);\n  width: 16px;\n  height: 16px;\n  flex: 0 0 auto;\n}\n.configure-dialog .competitor-item .competitor-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n.configure-dialog .competitor-item .competitor-name {\n  font-size: 12px;\n  color: var(--ui-text-primary);\n  font-weight: 600;\n  line-height: 1.2;\n  word-break: break-word;\n}\n.configure-dialog .competitor-item .competitor-domain {\n  font-size: 13px;\n  color: var(--ui-text-domain);\n  line-height: 1.2;\n  word-break: break-word;\n}\n.configure-dialog .competitor-group-heading {\n  flex: 0 0 auto;\n  background: var(--ui-surface-panel);\n  color: var(--ui-text-body);\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  padding: 8px 14px;\n  border-top: 1px solid var(--ui-border-list);\n  border-bottom: 1px solid var(--ui-border-list);\n  border-radius: var(--border-radius) var(--border-radius) 0 0;\n}\n.configure-dialog .state-jurisdiction-column {\n  width: 100%;\n  flex: 0 0 auto;\n}\n.configure-dialog .state-jurisdiction-column .state-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));\n  gap: 10px;\n  padding: 12px;\n  align-content: start;\n}\n.configure-dialog .state-jurisdiction-column .state-card {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  border: 1px solid var(--ui-border-state);\n  border-radius: var(--border-radius-md);\n  padding: 10px 12px;\n  background: var(--ui-surface);\n  cursor: pointer;\n  min-height: 64px;\n}\n.configure-dialog .state-jurisdiction-column .state-card:hover {\n  border-color: var(--ui-border-state-hover);\n  background: var(--ui-surface-hover);\n}\n.configure-dialog .state-jurisdiction-column .state-card.selected {\n  border-color: var(--c-teal-active);\n  background: var(--bg-teal-soft);\n}\n.configure-dialog .state-jurisdiction-column .state-card input {\n  margin: 0;\n  width: 16px;\n  height: 16px;\n  accent-color: var(--c-teal-active);\n  flex: 0 0 auto;\n}\n.configure-dialog .state-jurisdiction-column .state-card-meta {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n.configure-dialog .state-jurisdiction-column .state-card-name {\n  color: var(--ui-text-heading);\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1.3;\n  word-break: break-word;\n}\n.configure-dialog .state-jurisdiction-column .state-card-abbrev {\n  color: var(--ui-text-muted);\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n.configure-dialog .custom-url-box {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n}\n.configure-dialog .custom-url-box label {\n  font-size: 14px;\n  color: var(--ui-text-label);\n  font-weight: 500;\n}\n.configure-dialog .custom-url-box input,\n.configure-dialog .custom-url-box select {\n  padding: 10px 12px;\n  border: 1px solid var(--ui-border-input);\n  border-radius: 6px;\n  font-size: 14px;\n  width: 100%;\n  background: var(--ui-surface);\n}\n.configure-dialog .custom-url-box input:focus,\n.configure-dialog .custom-url-box select:focus {\n  outline: none;\n  border-color: var(--ui-accent-control);\n}\n.configure-dialog .no-config-message {\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 2.5rem 1.5rem;\n  text-align: center;\n  font-size: 24px;\n  color: var(--ui-text-label);\n}\n\n.configure-dialog .no-config-message p {\n  margin: 0;\n}\n\n.configure-dialog .no-config-message-illustration {\n  display: block;\n  width: 360px;\n  height: auto;\n  max-width: 100%;\n  flex-shrink: 0;\n  object-fit: contain;\n}\n.configure-dialog .p-dialog-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-shrink: 0;\n  padding: 1.5rem 1.5rem 1rem 1.5rem;\n  border-bottom: 1px solid var(--ui-border-divider);\n}\n.configure-dialog .p-dialog-header .p-dialog-title {\n  font-size: 1.15rem;\n  font-weight: 500;\n  font-family: var(--font-display);\n  color: var(--ui-text-heading);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.configure-dialog .p-dialog-content {\n  flex: 0 1 auto;\n  min-height: 0;\n  max-height: calc(var(--configure-dialog-max-height) - 11rem);\n  padding: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: stretch;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n/*\n * Unconfigured agent — compact empty state (not 70vw wide).\n */\n.configure-dialog.configure-dialog--unconfigured {\n  width: min(100%, 840px);\n  max-width: 840px;\n  height: auto;\n  max-height: min(100vh, calc(100vh - 48px));\n  overflow: hidden;\n}\n\n.configure-dialog--unconfigured .p-dialog-content {\n  flex: 0 0 auto;\n  min-height: unset;\n  max-height: none;\n  overflow: visible;\n}\n\n.configure-dialog--unconfigured .no-config-message {\n  padding: 2rem 1.25rem 2.25rem;\n  font-size: 18px;\n}\n\n.configure-dialog--unconfigured .no-config-message-illustration {\n  width: 360px;\n}\n\n/*\n * Competitor — tall 85vh shell; full lists (no per-column scroll). Body scrolls once if needed.\n */\n.configure-dialog.configure-dialog--competitor {\n  height: min(85vh, calc(100vh - 48px));\n  max-height: min(85vh, calc(100vh - 48px));\n  overflow: hidden;\n}\n\n.configure-dialog--competitor .p-dialog-content {\n  flex: 1 1 auto;\n  min-height: 0;\n  max-height: none;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.configure-dialog--competitor .competitor-picker {\n  flex: 0 1 auto;\n  min-height: 0;\n}\n\n.configure-dialog--competitor .competitor-columns {\n  flex: 0 1 auto;\n  align-items: stretch;\n}\n\n.configure-dialog--competitor .competitor-column {\n  min-height: 0;\n}\n\n.configure-dialog--competitor .competitor-list {\n  flex: 0 0 auto;\n  overflow: visible;\n}\n\n/*\n * Jurisdiction: fit the state grid — use nearly full viewport, no inner body scroll.\n */\n.configure-dialog--jurisdiction {\n  --configure-dialog-max-height: calc(100vh - 24px);\n  height: auto;\n  max-height: var(--configure-dialog-max-height);\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.configure-dialog--jurisdiction .p-dialog-content {\n  flex: 0 0 auto;\n  min-height: unset;\n  max-height: none;\n  overflow: visible;\n}\n\n.configure-dialog--jurisdiction .competitor-picker,\n.configure-dialog--jurisdiction .state-jurisdiction-column {\n  flex: 0 0 auto;\n  min-height: unset;\n}\n\n.configure-dialog .p-dialog-footer {\n  flex-shrink: 0;\n  padding: 1rem 1.5rem;\n  border-top: 1px solid var(--ui-border-divider);\n  display: flex;\n  justify-content: flex-end;\n}\n\n@media (max-width: 1280px) {\n  .configure-dialog .competitor-columns {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n  .configure-dialog .state-jurisdiction-column .state-grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n@media (max-width: 920px) {\n  .configure-dialog .competitor-columns {\n    grid-template-columns: minmax(0, 1fr);\n  }\n  .configure-dialog .state-jurisdiction-column .state-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n.cancel-btn {\n  color: var(--c-black);\n  border: 1px solid var(--border2);\n  border-radius: 6px;\n  padding: 8px 16px;\n  background: transparent;\n  cursor: pointer;\n  font-family: var(--font);\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.15s ease;\n}\n.cancel-btn:hover {\n  background: color-mix(in srgb, var(--c-white) 92%, var(--c-black));\n  border-color: color-mix(in srgb, var(--ui-border-input) 85%, var(--c-black));\n}\n\n.add-btn {\n  background-color: var(--c-neon);\n  color: var(--c-black);\n  border: none;\n  border-radius: 6px;\n  padding: 8px 24px;\n  margin-left: 8px;\n  cursor: pointer;\n  font-family: var(--font);\n  font-size: 14px;\n  font-weight: 500;\n  transition: background-color 0.2s ease, transform 0.2s ease;\n}\n.add-btn:hover:not(:disabled) {\n  background-color: var(--neon-btn-bg-hover);\n  transform: translateY(-1px);\n}\n.add-btn:active:not(:disabled) {\n  transform: translateY(0);\n}\n.add-btn:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 2px var(--c-white), 0 0 0 4px var(--c-neon);\n}\n.add-btn:disabled {\n  background-color: var(--border);\n  color: var(--text3);\n  box-shadow: none;\n  cursor: not-allowed;\n}\n\n\n/* =============================================================================\n   ASSISTANTS — Researcher shell (Koby chat routes)\n   Colors: var(--mi-*), var(--c-*) from tokens.css\n   ============================================================================= */\n\n@keyframes miSourcesPanelIn {\n  from {\n    opacity: 0;\n    transform: translateX(10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n.main > .mi-page {\n  flex: 1;\n  min-height: 0;\n  height: 100%;\n  max-height: 100%;\n}\n\n.mi-page {\n  --mi-brand: var(--c-teal-active);\n  --mi-brand-hover: var(--c-teal-3);\n  --mi-brand-soft: var(--bg-teal-soft);\n  --mi-shell-max: 990px;\n  --mi-suggestions-max: 920px;\n  --mi-prompt-radius: 28px;\n  --mi-prompt-pad: 1rem 1.35rem 0.85rem;\n  --mi-textarea-min-h: 98px;\n  --mi-title-size: 2.2rem;\n  --mi-subtitle-size: 1rem;\n\n  margin: 0 auto;\n  padding: 0;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  height: 100%;\n  min-height: 0;\n  box-sizing: border-box;\n  overflow: hidden;\n  font-family: var(--font);\n  font-size: var(--fs-base);\n  line-height: 1.5;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/* Enforce primary typography across nested elements (including markdown content). */\n.mi-page,\n.mi-page * {\n  font-family: var(--font) !important;\n}\n\n.mi-sub {\n  margin: 0;\n  color: var(--mi-text-badge);\n  font-size: 0.95rem;\n  line-height: 1.45;\n}\n\n.mi-error {\n  color: var(--mi-text-error);\n  margin: 0 0 0.75rem;\n  font-size: 0.9rem;\n}\n\n.mi-first-screen {\n  flex: 1;\n  min-height: 0;\n  width: 100%;\n  /* border: 1px solid var(--mi-border); */\n  background: var(--ui-surface);\n  /* box-shadow: var(--mi-shadow-xs); */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1.5rem;\n  box-sizing: border-box;\n  animation: assistantsPageIn 0.42s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n}\n\n.mi-first-shell {\n  width: min(100%, var(--mi-shell-max));\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.mi-first-icon {\n  width: 72px;\n  height: 72px;\n  border-radius: 999px;\n  background: var(--mi-surface-icon);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 0.95rem;\n}\n\n.mi-first-icon i {\n  color: var(--mi-text-icon);\n  font-size: 1.65rem;\n}\n\n.mi-first-title {\n  margin: 0 0 0.8rem;\n  font-size: var(--mi-title-size);\n  line-height: 1.15;\n  font-weight: 400;\n  font-family: var(--font-display) !important;\n  color: var(--mi-text-title);\n  text-align: center;\n  font-family: inherit;\n  animation: assistantsHeaderIn 0.48s cubic-bezier(0.16, 1, 0.3, 1) 0.06s backwards;\n}\n\n.mi-first-subtitle {\n  margin: 0 0 1.5rem;\n  font-size: var(--mi-subtitle-size);\n  line-height: 1.45;\n  color: var(--mi-text-secondary);\n  text-align: center;\n  animation: assistantsPageIn 0.42s cubic-bezier(0.16, 1, 0.3, 1) 0.1s backwards;\n}\n\n.mi-prompt-shell {\n  width: 100%;\n  box-sizing: border-box;\n  border: 1px solid var(--mi-border-prompt);\n  border-radius: var(--mi-prompt-radius);\n  background: var(--mi-surface-white);\n  box-shadow: var(--mi-shadow-sm);\n  padding: var(--mi-prompt-pad);\n  animation: cardPopIn 0.44s cubic-bezier(0.16, 1, 0.3, 1) 0.14s backwards;\n}\n\n.mi-first-textarea {\n  width: 100%;\n  box-sizing: border-box;\n  resize: none;\n  min-height: var(--mi-textarea-min-h);\n  border: none;\n  background: transparent;\n  font-family: inherit;\n  font-size: 14.5px;\n  line-height: 1.5;\n  color: var(--mi-text-primary);\n  padding: 0;\n  margin: 0;\n  display: block;\n}\n\n.mi-first-textarea::placeholder {\n  color: var(--mi-text-placeholder);\n}\n\n.mi-first-textarea:focus {\n  outline: none;\n}\n\n.mi-prompt-toolbar {\n  border-top: 1px solid var(--mi-border-toolbar);\n  padding-top: 0.7rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n}\n\n.mi-toolbar-context {\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n  flex-wrap: wrap;\n}\n\n.mi-first-suggestions {\n  width: min(100%, var(--mi-suggestions-max));\n  margin-top: 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n  align-self: center;\n  animation: assistantsPageIn 0.4s cubic-bezier(0.16, 1, 0.3, 1) 0.18s backwards;\n}\n\n.mi-suggestion-item {\n  width: 100%;\n  max-width: var(--mi-suggestions-max);\n  border: 1px solid transparent;\n  border-radius: 10px;\n  background: transparent;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.62rem 0.35rem;\n  text-align: left;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 14px;\n  color: inherit;\n  -webkit-appearance: none;\n  appearance: none;\n  animation: cardPopIn 0.38s cubic-bezier(0.16, 1, 0.3, 1) backwards;\n}\n\n.mi-suggestion-item:nth-child(1) { animation-delay: 0.22s; }\n.mi-suggestion-item:nth-child(2) { animation-delay: 0.28s; }\n.mi-suggestion-item:nth-child(3) { animation-delay: 0.34s; }\n.mi-suggestion-item:nth-child(4) { animation-delay: 0.4s; }\n.mi-suggestion-item:nth-child(5) { animation-delay: 0.46s; }\n.mi-suggestion-item:nth-child(n + 6) { animation-delay: 0.52s; }\n\n.mi-suggestion-item:hover {\n  background: var(--mi-surface-suggestion-hover);\n  border-color: var(--mi-border-suggestion-hover);\n}\n\n.mi-suggestion-arrow {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.38rem;\n  min-width: 1.38rem;\n  height: 1.38rem;\n  color: var(--mi-text-stone-light);\n  margin-top: 0.4rem;\n}\n.mi-suggestion-arrow svg {\n  width: 100%;\n  height: 100%;\n  display: block;\n  stroke: currentColor;\n  stroke-width: 2;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  fill: none;\n}\n\n.mi-suggestion-item:hover .mi-suggestion-arrow {\n  color: var(--mi-text-stone);\n}\n\n.mi-suggestion-copy {\n  min-width: 0;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 0.65rem;\n  width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.mi-suggestion-title {\n  flex: 0 0 auto;\n  font-size: 14.5px;\n  line-height: 1.35;\n  color: var(--mi-text-heading);\n}\n\n.mi-suggestion-subtitle {\n  flex: 1 1 auto;\n  font-size: 14.5px;\n  line-height: 1.35;\n  color: var(--mi-text-subtitle);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n@media (max-width: 860px) {\n  .mi-first-title {\n    font-size: 2.25rem;\n  }\n  .mi-prompt-shell {\n    border-radius: 20px;\n    padding: 0.85rem 0.9rem 0.7rem;\n  }\n  .mi-first-textarea {\n    min-height: 82px;\n    font-size: 1rem;\n  }\n  .mi-prompt-toolbar {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n}\n.mi-context-badges {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.45rem;\n}\n\n.mi-context-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.3rem;\n  border: 1px solid var(--mi-border);\n  border-radius: 999px;\n  background: var(--mi-surface-white);\n  color: var(--mi-text-body);\n  font-size: 0.8rem;\n  line-height: 1.1;\n  padding: 0.24rem 0.58rem;\n}\n\n.mi-context-badge-main {\n  display: inline-flex;\n  align-items: center;\n  max-width: min(420px, 55vw);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: var(--mi-text-primary);\n}\n\n.mi-context-badge-agent {\n  border-color: transparent;\n  max-width: min(360px, 46vw);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-weight: 500;\n}\n\n.mi-context-badge-emphasis {\n  font-weight: 500;\n}\n\n.mi-context-dot {\n  display: inline-block;\n  width: 0.45rem;\n  height: 0.45rem;\n  border-radius: 999px;\n  background: var(--c-teal-active);\n  margin-right: 0;\n  flex: 0 0 auto;\n}\n\n.mi-chat {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  /* border: 1px solid var(--mi-border); */\n  /* border-radius: 12px; */\n  /* background: var(--mi-surface); */\n  /* box-shadow: var(--mi-shadow-xs); */\n  overflow: hidden;\n  animation: cardPopIn 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n}\n\n.mi-chat-body {\n  flex: 1;\n  min-height: 0;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) clamp(240px, 22vw, 320px);\n  align-items: stretch;\n  position: relative;\n}\n\n/* Full-height column divider (panel border-left was clipped short of the input bar) */\n.mi-chat-body::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: clamp(240px, 22vw, 320px);\n  width: 1px;\n  background: var(--mi-border);\n  pointer-events: none;\n}\n\n.mi-chat-main {\n  min-width: 0;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.mi-messages {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 0.9rem 0.95rem;\n  scroll-behavior: smooth;\n}\n\n.mi-messages-layout {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.mi-sources-panel {\n  background: var(--mi-surface-white);\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  align-self: stretch;\n  animation: miSourcesPanelIn 0.38s cubic-bezier(0.16, 1, 0.3, 1) 0.08s backwards;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .mi-first-screen,\n  .mi-first-title,\n  .mi-first-subtitle,\n  .mi-prompt-shell,\n  .mi-first-suggestions,\n  .mi-suggestion-item,\n  .mi-chat,\n  .mi-sources-panel {\n    animation: none;\n  }\n}\n\n.mi-sources-header {\n  padding: 0.9rem 0.95rem;\n  border-bottom: 1px solid var(--mi-border-divider);\n}\n\n.mi-sources-header h3 {\n  margin: 0;\n  font-size: 1rem;\n  color: var(--mi-text-primary);\n  font-weight: 600;\n}\n\n.mi-sources-list {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 0.75rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n}\n\n.mi-source-item {\n  border: 1px solid var(--mi-border-source);\n  border-radius: 10px;\n  padding: 0.55rem 0.6rem;\n  display: flex;\n  align-items: flex-start;\n  gap: 0.55rem;\n  text-decoration: none;\n  color: inherit;\n  background: var(--mi-surface-white);\n}\n\n.mi-source-item:hover {\n  border-color: var(--mi-border-input);\n  background: var(--mi-surface-warm);\n}\n\n.mi-source-index {\n  min-width: 1.1rem;\n  height: 1.1rem;\n  border-radius: 999px;\n  background: var(--bg-teal-soft);\n  border: 1px solid var(--mi-border-teal);\n  color: var(--c-teal-active);\n  font-size: 0.72rem;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 1;\n  margin-top: 0.1rem;\n}\n\n.mi-source-host {\n  flex: 1;\n  min-width: 0;\n  font-size: 0.95rem;\n  font-weight: 500;\n  color: var(--mi-text-source);\n  line-height: 1.3;\n  overflow-wrap: anywhere;\n}\n\n.mi-sources-empty {\n  margin: 0;\n  padding: 0.88rem;\n  color: var(--mi-text-stone);\n  font-size: 0.84rem;\n}\n\n.mi-bubble {\n  border-radius: 10px;\n  padding: 0.75rem 1rem;\n  max-width: 100%;\n  min-width: 0;\n}\n\n.mi-bubble.user {\n  background: var(--bg-teal-soft);\n  border: 1px solid var(--mi-border-teal);\n  align-self: flex-end;\n  max-width: 90%;\n  margin-left: 0;\n}\n\n.mi-bubble.assistant {\n  background: var(--mi-surface-white);\n  border: 1px solid var(--mi-border);\n  align-self: stretch;\n  width: 100%;\n  margin-right: 0;\n  box-shadow: var(--mi-shadow-bubble);\n}\n\n.mi-assistant-turn {\n  width: 95%;\n  align-self: flex-start;\n  display: flex;\n  flex-direction: column;\n}\n\n.mi-assistant-turn-live {\n  gap: 0.35rem;\n}\n\n.mi-role {\n  font-size: 0.72rem;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--mi-text-stone);\n  margin-bottom: 0.35rem;\n}\n\n.mi-assistant-head {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  margin: 0 0 0.35rem;\n}\n\n.mi-assistant-head-live {\n  margin-bottom: 0.4rem;\n}\n\n.mi-assistant-avatar {\n  box-sizing: border-box;\n  width: 22px;\n  height: 22px;\n  border-radius: 6px;\n  border: 1px solid var(--border-color-strong);\n  background: var(--c-neon);\n  color: var(--mi-avatar-text);\n  display: inline-grid;\n  place-items: center;\n  flex-shrink: 0;\n  font-size: 9px;\n  font-weight: 600;\n  letter-spacing: -0.04em;\n  line-height: 1;\n  padding-top: 1px;\n}\n\n.mi-assistant-name {\n  font-size: 12px;\n  line-height: 1;\n  font-weight: 600;\n  color: var(--mi-text-secondary);\n}\n\n.mi-user-text {\n  margin: 0;\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n  font-family: inherit;\n  font-size: 14.5px;\n  color: var(--mi-text-primary);\n}\n\n.mi-md {\n  display: block;\n  width: 100%;\n  font-family: var(--font) !important;\n  font-size: 14.5px !important;\n  line-height: 1.65;\n  color: var(--mi-text-primary);\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.mi-md,\n.mi-md p,\n.mi-md li,\n.mi-md td,\n.mi-md th,\n.mi-md blockquote,\n.mi-draft-md,\n.mi-draft-md p,\n.mi-draft-md li,\n.mi-draft-md td,\n.mi-draft-md th,\n.mi-draft-md blockquote {\n  font-family: var(--font) !important;\n  font-size: 14.5px !important;\n}\n\n.mi-md p,\n.mi-draft-md p {\n  margin: 0 0 0.65rem;\n  line-height: 1.65;\n}\n\n.mi-md p:last-child,\n.mi-draft-md p:last-child {\n  margin-bottom: 0;\n}\n\n.mi-md li,\n.mi-draft-md li {\n  line-height: 1.65;\n  margin-bottom: 0.3rem;\n}\n\n.mi-md li:last-child,\n.mi-draft-md li:last-child {\n  margin-bottom: 0;\n}\n\n.mi-md-spacer {\n  height: 0.35rem;\n}\n\n.mi-md p strong,\n.mi-md li strong,\n.mi-draft-md p strong,\n.mi-draft-md li strong {\n  font-weight: 600;\n  color: var(--mi-text-primary);\n}\n\n.mi-md p em,\n.mi-md li em,\n.mi-draft-md p em,\n.mi-draft-md li em {\n  font-style: italic;\n}\n\n.mi-md code,\n.mi-draft-md code {\n  font-family: var(--font) !important;\n  font-size: 0.92em;\n  padding: 1px 0.38em;\n  border-radius: var(--border-radius-sm);\n  background: var(--bar-track-bg);\n}\n\n/* Make markdown structure readable (enterprise doc style). */\n.mi-md h1,\n.mi-draft-md h1 {\n  margin: 0.3rem 0 0.7rem;\n  font-size: 1.12rem;\n  line-height: 1.45;\n  font-weight: 500;\n  font-family: var(--font-display) !important;\n  color: var(--mi-text-heading);\n}\n\n.mi-md h2,\n.mi-draft-md h2 {\n  margin: 0.25rem 0 0.6rem;\n  font-size: 1rem;\n  line-height: 1.45;\n  font-weight: 700;\n  font-family: var(--font-display) !important;\n  color: var(--mi-text-primary);\n}\n\n.mi-md h3,\n.mi-draft-md h3 {\n  margin: 0.2rem 0 0.55rem;\n  font-size: 0.88rem;\n  line-height: 1.45;\n  font-weight: 500;\n  font-family: var(--font-display) !important;\n  color: var(--mi-text-body-muted);\n}\n\n.mi-md ul,\n.mi-md ol,\n.mi-draft-md ul,\n.mi-draft-md ol {\n  margin: 0.45rem 0 0.65rem;\n  padding-left: 1.2rem;\n}\n\n.mi-md ul li::marker,\n.mi-draft-md ul li::marker {\n  font-size: 1.12em;\n}\n\n.mi-md blockquote,\n.mi-draft-md blockquote {\n  margin: 0 0 0.7rem;\n  padding: 0.25rem 0.8rem;\n  border-left: var(--border-width-thick) solid var(--mi-border-strong);\n  color: var(--mi-text-secondary);\n  background: var(--answers-black-03);\n  border-radius: 0 var(--border-radius-sm) var(--border-radius-sm) 0;\n}\n\n.mi-md-hr {\n  margin: 0.9rem 0;\n  border: none;\n  border-top: var(--border-width) solid var(--mi-border);\n}\n\n.mi-md-table-wrap,\n.mi-draft-md .mi-md-table-wrap {\n  margin: 0 0 var(--space-3);\n  overflow-x: auto;\n  border: var(--border-width) solid var(--mi-border);\n  border-radius: var(--border-radius);\n}\n\n.mi-md-table,\n.mi-draft-md .mi-md-table {\n  width: 100%;\n  min-width: 480px;\n  border-collapse: collapse;\n  font-size: var(--fs-sm);\n  line-height: 1.45;\n}\n\n.mi-md-table th,\n.mi-md-table td,\n.mi-draft-md .mi-md-table th,\n.mi-draft-md .mi-md-table td {\n  padding: var(--space-2) var(--space-3);\n  border: var(--border-width) solid var(--mi-border);\n  text-align: left;\n  vertical-align: top;\n  max-width: 0;\n}\n\n.mi-md-table .md-table-cell-inner,\n.mi-draft-md .mi-md-table .md-table-cell-inner {\n  display: block;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.mi-md-table th,\n.mi-draft-md .mi-md-table th {\n  font-weight: 600;\n  color: var(--c-black);\n  background: var(--bar-track-bg);\n}\n\n.mi-md-table tbody tr:nth-child(even),\n.mi-draft-md .mi-md-table tbody tr:nth-child(even) {\n  background: var(--answers-black-03);\n}\n\n.mi-md-list-item {\n  margin: 0 0 0.5rem;\n}\n\n.mi-typing {\n  display: flex;\n  align-items: flex-start;\n  gap: 0;\n  color: var(--mi-text-body-muted);\n  font-size: 0.9rem;\n  background: var(--mi-surface-typing);\n  border: 1px solid var(--mi-border-source);\n  border-radius: 10px;\n  padding: 0.75rem 0.85rem;\n}\n\n.mi-live-wrap {\n  flex: 1;\n  min-width: 0;\n}\n\n.mi-live-loader {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  margin-bottom: 1rem;\n}\n\n.mi-live-loader-dot {\n  width: 0.38rem;\n  height: 0.38rem;\n  border-radius: 999px;\n  background: var(--mi-loader-dot);\n  opacity: 0.35;\n  animation: mi-loader-pulse 1s infinite ease-in-out;\n}\n\n.mi-live-loader-dot:nth-child(2) {\n  animation-delay: 0.15s;\n}\n\n.mi-live-loader-dot:nth-child(3) {\n  animation-delay: 0.3s;\n}\n\n@keyframes mi-loader-pulse {\n  0%, 80%, 100% {\n    transform: scale(0.85);\n    opacity: 0.35;\n  }\n  40% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n.mi-live-title {\n  display: block;\n  font-size: 0.72rem;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--mi-text-stone);\n  margin-bottom: 0.4rem;\n  font-weight: 600;\n}\n\n.mi-live-stats {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem 0.45rem;\n  margin-bottom: 0.55rem;\n}\n\n.mi-live-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0.2rem 0.45rem;\n  border: 1px solid var(--mi-border);\n  border-radius: 999px;\n  background: var(--mi-surface-white);\n  color: var(--mi-text-badge);\n  font-size: 0.76rem;\n  line-height: 1.2;\n}\n\n.mi-live-chip strong {\n  color: var(--mi-text-primary);\n  font-weight: 600;\n}\n\n.mi-live-chip-phase {\n  border-width: 1px;\n}\n\n.mi-live-chip-phase.is-initializing,\n.mi-live-chip-phase.is-processing {\n  background: var(--mi-phase-idle-bg);\n  border-color: var(--mi-border-input);\n  color: var(--mi-text-body-muted);\n}\n\n.mi-live-chip-phase.is-research {\n  background: var(--mi-phase-research-bg);\n  border-color: var(--mi-phase-research-border);\n  color: var(--mi-phase-research-text);\n}\n\n.mi-live-chip-phase.is-reading {\n  background: var(--mi-phase-reading-bg);\n  border-color: var(--mi-phase-reading-border);\n  color: var(--mi-phase-reading-text);\n}\n\n.mi-live-chip-phase.is-analysis {\n  background: var(--mi-phase-analysis-bg);\n  border-color: var(--mi-phase-analysis-border);\n  color: var(--mi-phase-analysis-text);\n}\n\n.mi-live-chip-phase.is-drafting {\n  background: var(--mi-phase-drafting-bg);\n  border-color: var(--mi-phase-drafting-border);\n  color: var(--mi-phase-drafting-text);\n}\n\n.mi-live-reasoning {\n  margin-bottom: 0.55rem;\n}\n\n.mi-live-reasoning-list {\n  margin: 0;\n  padding-left: 1rem;\n  font-size: 0.83rem;\n  color: var(--mi-text-body-muted);\n  line-height: 1.45;\n}\n\n.mi-live-reasoning-list li {\n  margin-bottom: 0.2rem;\n}\n\n.mi-live-evidence {\n  margin: 0.15rem 0 0.55rem;\n}\n\n.mi-evidence-list {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: grid;\n  gap: 0.4rem;\n}\n\n.mi-evidence-item {\n  border: 1px solid var(--mi-border);\n  background: var(--mi-surface-white);\n  border-radius: 8px;\n  padding: 0.4rem 0.55rem;\n}\n\n.mi-evidence-host {\n  display: inline-block;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--mi-evidence-link);\n  text-decoration: none;\n  margin-bottom: 0.15rem;\n}\n\n.mi-evidence-host:hover {\n  color: var(--mi-evidence-link-hover);\n  text-decoration: underline;\n}\n\n.mi-evidence-title {\n  margin: 0 0 0.12rem;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--mi-text-primary);\n  line-height: 1.35;\n}\n\n.mi-evidence-snippet {\n  margin: 0;\n  font-size: 0.82rem;\n  line-height: 1.4;\n  color: var(--mi-text-body-muted);\n}\n\n.mi-live-fallback {\n  margin: 0;\n  color: var(--mi-text-stone-light);\n  font-size: 0.85rem;\n}\n\n.mi-live-draft {\n  margin-top: 0.45rem;\n  padding-top: 0.55rem;\n  border-top: 1px dashed var(--mi-border-dashed);\n}\n\n.mi-draft-md {\n  font-size: 14.5px;\n  opacity: 1;\n  color: var(--mi-text-draft);\n}\n\n.mi-draft-md p,\n.mi-draft-md ul,\n.mi-draft-md ol {\n  margin-bottom: 0.45rem;\n}\n\n/* Input docked to bottom of chat card */\n.mi-input-bar {\n  display: flex;\n  gap: 0.75rem;\n  padding: 0.875rem 1rem;\n  border-top: 1px solid var(--mi-border);\n  background: var(--mi-surface-white);\n  flex-shrink: 0;\n  box-shadow: var(--mi-shadow-input-bar);\n  align-items: flex-end;\n}\n\n.mi-input-main {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.mi-input-context-badges {\n  gap: 0.4rem;\n}\n\n.mi-textarea {\n  width: 100%;\n  resize: vertical;\n  min-height: 52px;\n  max-height: 160px;\n  padding: 0.65rem 0.85rem;\n  border-radius: 8px;\n  border: 1px solid var(--mi-border-input);\n  font-family: inherit;\n  font-size: 14.5px;\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n\n.mi-textarea:hover:not(:disabled) {\n  border-color: var(--mi-text-stone-light);\n}\n\n.mi-textarea:focus {\n  outline: none;\n  border-color: var(--mi-focus-accent-border);\n  box-shadow: var(--mi-focus-accent-ring);\n}\n\n/* Stop — neutral outline so it reads as “cancel”, not primary action */\nbutton.mi-stop,\n.mi-stop.p-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  background: var(--mi-surface-white);\n  border: 1px solid var(--mi-border-input);\n  color: var(--mi-text-body-muted);\n  font-weight: 600;\n  font-size: 0.95rem;\n  font-family: inherit;\n  line-height: 1.2;\n  padding: 0.65rem 1.1rem;\n  border-radius: 8px;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\nbutton.mi-stop:hover:not(:disabled),\n.mi-stop.p-button:hover {\n  background: var(--mi-phase-idle-bg);\n  border-color: var(--mi-text-stone-light);\n  color: var(--mi-text-heading);\n}\n\nbutton.mi-stop:focus-visible,\n.mi-stop.p-button:focus-visible {\n  outline: none;\n  box-shadow: var(--mi-focus-neutral-ring);\n}\n\nbutton.mi-stop:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n/* Send — teal primary (matches Assistants / Answers CTA) */\nbutton.mi-send,\n.mi-send.p-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  background: var(--mi-brand);\n  border: 1px solid var(--mi-brand);\n  color: var(--c-white);\n  font-weight: 600;\n  font-size: 0.95rem;\n  font-family: inherit;\n  line-height: 1.2;\n  padding: 0.65rem 1.1rem;\n  border-radius: 8px;\n  cursor: pointer;\n  flex-shrink: 0;\n  white-space: nowrap;\n  transition: background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;\n  box-shadow: var(--mi-shadow-send);\n}\n\nbutton.mi-send:hover:not(:disabled),\n.mi-send.p-button:not(:disabled):hover {\n  background: var(--mi-brand-hover);\n  border-color: var(--mi-brand-hover);\n  box-shadow: var(--mi-shadow-send-hover);\n}\n\nbutton.mi-send:focus-visible,\n.mi-send.p-button:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 3px var(--bg-teal-soft), 0 0 0 5px var(--c-teal-active);\n}\n\nbutton.mi-send:disabled,\n.mi-send.p-button:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.mi-send-icon,\n.mi-stop-icon {\n  width: 1rem;\n  height: 1rem;\n  flex-shrink: 0;\n  display: block;\n}\n\n.mi-hint {\n  color: var(--mi-text-stone);\n  font-size: 0.95rem;\n  margin-top: 1rem;\n}\n\n.mi-disclaimer {\n  margin: 0.3rem 0 0.3rem;\n  text-align: center;\n  color: var(--mi-text-secondary);\n  font-size: 0.82rem;\n  line-height: 1.25;\n  flex-shrink: 0;\n}\n\n.mi-chat-main > .mi-disclaimer {\n  margin: 0;\n  padding: 0.35rem 0.95rem 0.5rem;\n  background: var(--mi-surface-white);\n}\n\n@media (max-width: 900px) {\n  .mi-first-title {\n    font-size: 1.6rem;\n  }\n  .mi-chat-body {\n    grid-template-columns: minmax(0, 1fr);\n  }\n  .mi-chat-main {\n    min-height: 0;\n  }\n  .mi-messages {\n    padding: 0.9rem 0.9rem;\n  }\n  .mi-messages-layout {\n    width: 100%;\n  }\n  .mi-chat-body::after {\n    display: none;\n  }\n\n  .mi-sources-panel {\n    border-top: 1px solid var(--mi-border);\n    max-height: 220px;\n  }\n}\n@media (max-width: 640px) {\n  .mi-first-screen {\n    padding: 1rem 0.75rem;\n  }\n  .mi-first-title {\n    font-size: 1.35rem;\n    margin-bottom: 0.8rem;\n  }\n  .mi-first-textarea {\n    min-height: 104px;\n    font-size: 0.92rem;\n  }\n  .mi-context-badge-main {\n    max-width: min(88vw, 300px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
